// DO NOT EDIT THIS FILE
// This file was generated by a Vite plugin
// Do not manually edit this file; it is always overwritten

const englishStrings = {
  "firstAndLastName": "{{firstName}} {{lastName}}",
  "cancel": "Cancel",
  "contactSupport": "Contact support",
  "continue": "Continue",
  "done": "Done",
  "requiredField": "Required",
  "departure": "Departure",
  "email": "Email",
  "enterYourEmail": "Enter your email",
  "genericErrorTitle": "Uh oh! Something went wrong",
  "person": "Person",
  "person_male": "Male",
  "person_female": "Female",
  "details": "Details",
  "photos": "Photos",
  "homeTitle": "<b>Welcome</b> to $t(brand:portalName).",
  "homeInfoWallet": "Pay with the money you have in <b>$t(brand:merchantPayments)</b> without having to download another app.",
  "homeInfoSave": "Get the best prices on flights and <b>save up to 40%</b> everytime you book.",
  "homeSubtitle": "Book the trip you've been waiting for.",
  "covidWarningBanner": "<a href='https://wwwnc.cdc.gov/travel/' target='_blank' rel='noreferrer'> COVID-19 travel restrictions</a>are in effect.",
  "fareDetails": "Fare Details",
  "faqTitle": "Questions about your trip?",
  "flight": "Flight",
  "flights": "Flights",
  "hotels": "Hotels",
  "cars": {
    "pickUp": "Pick-up",
    "dropOff": "Drop-off",
    "confirmation": "Confirmation",
    "driverInfo": "Driver Information",
    "locationInfo": "Location",
    "fuelInfo": "Fuel Policy",
    "payment": "Payment",
    "cancelPolicy": {
      "title": "Cancel Policy",
      "nonRefundable": "Non-refundable",
      "freeCancellation": "Free Cancellation",
      "unknown": "Unknown"
    }
  },
  "flightSearchPrompt": "Search for Flights",
  "hotelSearchPrompt": "Search for Hotels",
  "activitiesSearchPrompt": "Search for Activities",
  "mobileMenuBookFlights": "Book Flights",
  "mobileMenuMyTrips": "My Trips",
  "mobileMenuProfile": "Profile",
  "mobileMenuCustomerSupport": "Need support? Chat with an agent",
  "mobileSupportLoading": "Loading chat",
  "mobileMenuLogOut": "Log Out",
  "outbound": "Outbound",
  "timeCount": {
    "day_one": "{{count}} day",
    "day_other": "{{count}} days",
    "hour_one": "{{count}} hour",
    "hour_other": "{{count}} hours",
    "second_one": "{{count}} second",
    "second_other": "{{count}} seconds"
  },
  "andSeparator": "&",
  "permissionsBalanceModalTitle": "To buy your ticket, we need to know that your balance is sufficient.",
  "permissionsBalanceModalDescription": "We won’t share your balance information with anyone nor use it for anything else.",
  "permissionsBalanceModalButton": "Click here. Then go to Nequi and click on accept permissions.",
  "permissionsBalanceModalRedirect": "Go to $t(brand:merchantPayments) and click on accept to continue with the purchase of your flight tickets.",
  "permissionsBalanceModalTryAgain": "$t(genericShopErrorTitle) Visit your $t(brand:clientName) dashboard to update your permissions.",
  "permissionsBalanceModalSkip": "Continue without giving permission",
  "privacyPolicy": "Privacy Policy",
  "documentTitle": "$t(brand:portalName)",
  "return": "Return",
  "seatSelection": "Seat selection",
  "step2SeatSelection": "Step 2: Seat selection",
  "stop": "Stop",
  "stops": "Stops",
  "stopDetails": {
    "nonstop": "Nonstop",
    "stop_one": "{{count}} stop",
    "stop_other": "{{count}} stops"
  },
  "intervals": {
    "hoursMinutes": "{{hours}}h {{minutes}}m",
    "minutes": "{{minutes}}m"
  },
  "termsAndConditions": "Terms and Conditions",
  "searching": "Searching",
  "supportIntent": {
    "generalPortalOption": "I need help with the Portal",
    "upcomingFlight": "I need help with an upcoming flight",
    "cancelFlight": "I need help cancelling a flight",
    "changeFlight": "I need help changing a flight",
    "openExisting": "Open an existing conversation ({{count}} open)",
    "title": "What can we help you with?"
  },
  "customerSupport": "Customer Support",
  "tryAgain": "Try Again",
  "cancelSearch": "Cancel search",
  "select": "Select",
  "pricesFrom": "From <0>{{price}}</0>",
  "more": "{{count}} more",
  "viewAllAmenities": "View all {{count}} amenities",
  "travelTime": "Travel time:",
  "poweredBy": "Powered by",
  "loggingIn": "Logging in",
  "invalidSession": "Oops! Your session timed out. Please login again through the $t(brand:clientName) app.",
  "loggingOut": "Logging out",
  "goHome": "Home",
  "edit": "Edit",
  "hide": "Hide",
  "delete": "Delete",
  "choose": "Choose",
  "gender": "Gender",
  "remove": "Remove",
  "add": "Add",
  "noSpecialCharactersError": "No special characters permitted",
  "onlyNumbersPermittedError": "Only numbers permitted",
  "noWhitespaceError": "No spaces permitted",
  "firstNameMinCharacterError": "First name must be at least two characters",
  "firstNameMaxCharacterError": "First name is too long",
  "lastNameMinCharacterError": "Last name must be at least two characters",
  "firstNameRequiredError": "First name required",
  "lastNameRequiredError": "Last name required",
  "birthDateRequiredError": "Birthdate required",
  "genderRequiredError": "Gender required",
  "nationalityError": "Nationality required",
  "nationalIdPlaceholder": "Enter your {{id}}",
  "nationalIdRequiredError": "{{id}} required",
  "nationalIdLengthError": "{{id}} must include {{length}} numbers",
  "nationalIdInvalid": "Invalid {{id}}",
  "phoneNumber": "Phone Number",
  "phone": "Phone",
  "hopperLogo": "Hopper Logo",
  "b2bLogo": "B2B Logo",
  "currencies": "Currencies",
  "usDollar": "US Dollar",
  "mexicanPeso": "Mexican Peso",
  "languages": "Languages",
  "expiredSessionModal": {
    "title": "Your session has expired",
    "description": "Since we didn't notice any activity for a while, we ended your session. If you're there and want to keep looking, start a new search.",
    "errorCode": "Error: {{errorCode}}",
    "confirm": "Start new search"
  },
  "confirm": "Confirm",
  "priceFreezeIconAlt": "lock icon.",
  "vipSupportIconAlt": "green bolt icon.",
  "basicSupportIconAlt": "headset icon.",
  "or": "or",
  "verify": "Verify",
  "verifyCodePlaceholder": "1 2 3 4 5 6",
  "signInOrCreateNewTitle": "Sign in and start saving",
  "enterPhoneNumber": "Enter phone number",
  "verifyPhoneTitle": "Verify your phone number",
  "verifyEmailTitle": "Verify your email",
  "verifyCodeSubtitle": "Hopper just sent a 6-digit code to {{emailOrPhone}}",
  "resendDescription": "Didn't get a code? Please wait 30 seconds then try again.",
  "additionalOptionDescription": "Or try sending the code a different way.",
  "additionalModalTitle": "More verification options",
  "additionalModalSubtitle": "Choose an option to receive the code:",
  "sendCode": "Send Code",
  "resendCode": "Resend",
  "moreOptions": "More options",
  "newUserTitle": "Welcome to Hopper!",
  "mergeAccountTitle": "An account already exists",
  "newUserSubtitle": "Fill in your account details",
  "createAccountAgreeToTerms": "By continuing, you confirm you've read and agree to our Terms & Conditions and Privacy Policy.",
  "createAccount": "Create account",
  "existingUserTitle": "Hopper would like to:",
  "existingUserBullet1": "Know who you are on Google",
  "existingUserBullet2": "View your email address",
  "existingUserBullet3": "View your basic profile info",
  "allow": "Allow",
  "deny": "Deny",
  "successfulLoginHeader": "Logged in successfully!",
  "successfulLoginSubheader": "Logged in successfully!",
  "loginErrorHeader": "There was an error.",
  "loginErrorSubheader": "There was an error, please try again or reload the page.",
  "signInContinue": "Continue without signing in",
  "loginMatchingEmailSubheader": "Looks like the email {{redactedEmail}} has an existing account.",
  "loginMatchingPhoneSubheader": "Looks like the phone {{redactedPhone}} has an existing account.",
  "continueAddingPhone": "Login using phone number",
  "continueAddingEmail": "Login using email",
  "noCreateNewUser": "No, create new user",
  "mergeModalPhoneDescription": "The phone number on the account will be updated to {{phoneNumber}}",
  "mergeEmailEmailDescription": "The email on the account will be updated to {{email}}",
  "profile": {
    "accountTitle": "Account Information",
    "travelersTitle": "Travelers",
    "addTraveler": "Add new traveler",
    "travelersErrorTitle": "Sorry, we couldn’t retrieve your traveler details.",
    "travelersErrorDescription": "Please reload the page or try again later."
  },
  "findBooking": "Find Booking",
  "signIn": "Sign In",
  "signInOrRegister": "Sign in or register",
  "signOut": "Sign Out",
  "myProfile": "My Profile",
  "myTrips": "My Trips",
  "getHelp": "Get Help",
  "accountHeader": "Account",
  "moreHeader": "More",
  "walletBalance": "Wallet Balance ({{walletBalance}})",
  "walletBannerSignIn": "Sign in and start saving",
  "back": "Back",
  "next": "Next",
  "apply": "Apply",
  "close": {
    "button": "Close",
    "imageAlt": "close button icon"
  },
  "chooseSortOption": "Choose a sort option",
  "changeSortOption": "Change sort option",
  "filterAndSortMenu": "Filter and sort menu",
  "none": "None",
  "backIconAltText": "Back chevron icon",
  "carouselPositionLabel": "Displaying item {{position}} out of {{numberOfItems}} total items.",
  "autocompleteAriaHelperText": "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.",
  "outageBannerTitle": "Ongoing System Disruption",
  "outageBannerSubtitle": "We are experiencing technical issues, and some features may be temporarily unavailable. We appreciate your patience as we work to resolve the issue.",
  "sort": "Sort",
  "loadingWithEllipsis": "Loading...",
  "flightHome": {
    "title": "<strong>Welcome back</strong> to travel.",
    "subtitle": "Book the trip you've been waiting for."
  },
  "amenitiesCategories": {
    "seat": "Seat",
    "aircraft": "Aircraft",
    "entertainment": "Entertainment",
    "beverage": "Beverage",
    "wifi": "Wifi",
    "layout": "Layout",
    "power": "Power",
    "freshFood": "Fresh Food"
  },
  "amenityUtaCategories": {
    "advance-change": "Changes",
    "boarding-priority": "Boarding",
    "cancellation": "Cancellation",
    "carry-on-allowance": "Carry-on Bags",
    "check-in-priority": "Check In",
    "checked-bag-allowance": "Checked Bags",
    "lounge-access": "Lounge Access",
    "same-day-change": "Same-day Change",
    "seat-selection": "Seat Selection",
    "upgrade-eligibility": "Upgrade Eligibility",
    "personal-item": "Personal Item",
    "refundable-fare": "Refundable Fare"
  },
  "moreFareDetails": "+ {{number}} more",
  "lessFareDetails": "Show less",
  "flightsPageTitles": {
    "default": "Hopper",
    "travellers": "Travelers",
    "travellersWarning": "You can search for up to 6 travelers",
    "shopFlights": "Shop Flights",
    "searchFlights": "Search Flights",
    "selectDate": "Select Dates",
    "selectFlights": "Select Flight",
    "selectOutbound": "Select Outbound",
    "detailsOutbound": "Outbound to {{outboundCity}}",
    "outboundOnDate": "<0>Outbound </0> to <1>{{destination}}</1> on <2>{{date}}</2>",
    "selectReturn": "Select Return",
    "detailsReturn": "Return to {{returnCity}}",
    "returnOnDate": "Return to <0><{{destination}}></0> on <1>{{date}}</1>",
    "reviewItinerary": "Review Itinerary",
    "fareDetails": "Fare Details",
    "disruptionGuarantee": "Delay + Cancellation Guarantee",
    "customize": "Customize your trip"
  },
  "homeCovidWarning": "Travel restrictions are in effect due to coronavirus (COVID-19). Learn more by  <a href='https://wwwnc.cdc.gov/travel' target='_blank' rel='noreferrer'>reviewing the latest CDC guidelines.</a>",
  "mobileSearchChooseDate": "Choose your dates",
  "chooseDates": "Choose Dates",
  "availableSeats": "({{numberOfSeats}} seats left)",
  "flightDetails": "Flight details",
  "updateCalendarText": "Updating your calendar",
  "mobileSearchButton": "Search Flights",
  "mobileSearchButtonPopup": "Search Flights",
  "flightRoundTrip": "Round-trip",
  "flightOneWay": "One-way",
  "flightMultiCity": "Multi-city",
  "flightRoundTripPricing": "Round-trip from",
  "flightOneWayPricing": "One-way trip from",
  "tripCategoryAria": "trip category",
  "searchControl": {
    "originHeader": "Where from?",
    "originPlaceholder": "Search by country, city, or airport",
    "originRequired": "Please select where you're flying from",
    "destinationHeader": "Where to?",
    "destinationPlaceholder": "Search by country, city, or airport",
    "whereFrom": "Where from?",
    "whereTo": "Where to?",
    "whereFromExtended": "From city, airport, or station",
    "whereToExtended": "To city, airport, or station",
    "searchInstructions": "※ Please search for a destination using this search field.",
    "searchAgain": "Search Again",
    "calendarPicker": "Done",
    "resetDates": "Reset dates",
    "calendarOneWay": "Select your departure date for your flight",
    "calendarRoundTrip": "Select the arrival and departure dates for your flight",
    "roundTripCalendar": "Select the departure and return dates for your flight",
    "city": "Cities",
    "calendarPricesInLabel": "<strong>Showing prices in {{currency}}</strong> • per traveler",
    "airport": "Airports"
  },
  "saveAndContinue": "Save and continue",
  "editTravelerInformation": "Edit traveler information",
  "flightDetailsContine": "Continue",
  "continueBooking": "Continue booking",
  "passengerCount": {
    "modalTitle": "Edit Travelers",
    "adultTitle": "Adults",
    "adultSubtitle": "Ages 11 or above",
    "childrenTitle": "Children",
    "childrenSubtitle": "Ages 2-11",
    "infantLapTitle": "Infants",
    "infantLapSubtitle": "On lap",
    "infantSeatTitle": "Infants",
    "infantSeatSubtitle": "In seat",
    "roomsTitle": "Rooms",
    "warningMessage": "You can search for up to {{maximumCount}} travelers",
    "apply": "Apply"
  },
  "tripCategory": {
    "modalTitle": "Trip type",
    "cta": "Cancel"
  },
  "searchFilter": {
    "reset": "Reset Filters",
    "apply": "Apply Filters",
    "sortAndFilter": "Sort and filter",
    "sortHeader": "Sort by:",
    "stopHeader": "Stops",
    "priceHeader": "Price",
    "pickerTraveler_one": "{{count}} Traveler",
    "pickerTraveler_other": "{{count}} Travelers",
    "outbound": "Times - Outbound",
    "outboundFlight": "Outbound Flight - Times",
    "return": "Times - Return",
    "returnFlight": "Return Flight - Times",
    "arrival": "Arrival",
    "departureLabel": "Departure",
    "arrivalLabel": "Arrival",
    "departureLabelOutbound": "Departure",
    "arrivalLabelOutbound": "Arrival",
    "departureLabelReturn": "Departure",
    "arrivalLabelReturn": "Arrival",
    "airline": "Airline",
    "flightNumber": "Flight #",
    "price": "Price",
    "airport": "Airports",
    "stops": "Stops",
    "anyStop": "Any number of stops",
    "noStops": "Nonstop only",
    "oneOrFewerStops": "One stop or fewer",
    "twoOrFewerStops": "Two stops or fewer",
    "filterStops": "Filter stops",
    "changeFilterStops": "Change stops filter",
    "filterFareClass": "Filter fare class",
    "changeFilterFareClass": "Change fare class filter",
    "maxPrice": "Set max price",
    "time": "Time",
    "flightNumberHeader": "Select an airline to view flight numbers departing on {{departureDateString}}",
    "departureTime": "Departure time in {{location}}",
    "arrivalTime": "Arrival time in {{location}}",
    "fareClass": "Fare class",
    "allFilters": "All filters",
    "maxPriceLabel": "Max {{price}}",
    "sortLabel": {
      "recommended": "By recommended",
      "price": "By cheapest",
      "departureTime": "By departure",
      "arrivalTime": "By arrival",
      "stops": "By stops",
      "duration": "By duration"
    }
  },
  "searchFilters": "Filters",
  "searchButton": "Search",
  "searchEditTravelersTitle": "Travelers",
  "mobileFareDetails": "Fares",
  "fareClass": {
    "fares": "{{fareClass}} Fares",
    "all": "All",
    "basicLabel": "Basic",
    "basicDetails": "Typically the best priced options. These are economy fares with more restrictive policies and no checked-in luggage.",
    "standardLabel": "Standard",
    "standardDetails": "Typically economy fares that include more amenities as well as checked-in luggage.",
    "enhancedLabel": "Enhanced",
    "enhancedDetails": "Typically economy fares that include more amenities, flexible fare conditions, as well as checked-in luggage.",
    "premiumLabel": "Premium",
    "premiumDetails": "Typically premium economy or some business fares that include premium seats, priority boarding, premium snacks and beverages.",
    "luxuryLabel": "Luxury",
    "luxuryDetails": "Business or first class fares with luxury reclined or lie-flat seats with personalized services and premium meals. Priority boarding and lounge access are typically also included."
  },
  "sortOption": {
    "recommended": "Recommended",
    "price": "Price (Low to High)",
    "priceShortened": "Price",
    "depart": "Depart (Earliest to Latest)",
    "departShortened": "Depart",
    "arrive": "Arrive (Earliest to Latest)",
    "arriveShortened": "Arrive",
    "stops": "Stops (Least to Most)",
    "stopsShortened": "Stops",
    "duration": "Duration (Shortest to Longest)",
    "durationShortened": "Duration"
  },
  "depart": "Depart",
  "locationSearchTraveler_one": "{{count}} Traveler",
  "locationSearchTraveler_other": "{{count}} Travelers",
  "loading": "Loading",
  "viewFlights": "Continue to Flights",
  "priceWatch": {
    "title": "Price Watch",
    "copy": "If you're still not ready to buy, watch this trip for deals.",
    "copyAlt": "Get notified of price changes",
    "unsupportedFilterCopy": "Watch this trip for deals. You will be notified when deals are available or prices start to rise.",
    "watchThisTrip": "Watch This Trip",
    "alreadyWatching": "Already watching",
    "watch": "Watch",
    "watchTrip": "Watch Trip",
    "watching": "Stop Watching",
    "titles": {
      "header": "Watch This Trip",
      "title": "How it works",
      "subtitle": "Not ready to buy? We'll watch your flight 24/7 and notify you when it's the best time to book.",
      "watchedTitle": "You're all set!",
      "watchedHeader": "You are now watching this trip",
      "watchedSubtitle": "We'll send you an email when there's a change to the price of this trip. To manage your watched trips, visit My Trips.",
      "description": "By watching this trip you are agreeing to receive email updates when the price of this trip changes. To manage your watched trips, visit My Trips.",
      "buttonCopy": "Watch this trip",
      "copyHeader": "<strong>Watch</strong> this trip",
      "copyWatchedHeader": "<strong>You are now watching</strong> this trip"
    },
    "preferences": "Flight preferences",
    "nonstopOnly": "Nonstop flights only",
    "excludeBasic": "Exclude Basic fares",
    "alertPreferences": "Price alert preferences",
    "emailDefault": "Email (default)"
  },
  "priceDrop": {
    "title": "Price drop protection",
    "priceDropText": "Complimentary <span id=\"priceDropLink\">price drop protection</span> included.",
    "priceDropDescription": "When you book a flight with us, receive complimentary price drop protection. We'll monitor the price for up to {{day}} days. If we detect a price drop, we'll refund the difference up to {{amount}}."
  },
  "priceForecast": {
    "greatTitle": "Great price",
    "goodTitle": "Good price",
    "fairTitle": "Fair price",
    "waitTitle": "Wait",
    "greatDescription": "This is a great price",
    "goodDescription": "This is a good price",
    "fairDescription": "This is a fair price",
    "waitDescription": "Wait",
    "recommendedBody": "If the price drops, you'll get back up to {{amount}} of the difference with",
    "recommendedInfoLabel": "Free price drop protection",
    "learnMore": "Learn how price prediction works",
    "freePriceDrop": "Free price drop protection included."
  },
  "reviewItineraryHeader": "Review Itinerary",
  "reviewItineraryTitle": "Review your itinerary",
  "reviewItinerarySubtitle": "Review the details of your trip before you continue",
  "importantInfoTitle": "Important information",
  "chooseFlightOutgoing": "Choose departure flight to {{destination}}",
  "chooseFlightReturn": "Choose return flight to {{origin}}",
  "flightPricesRoundTrip": "Prices are round trip, per traveler",
  "flightPricesOneWayTrip": "Prices are single trip, per traveler",
  "flightSearchLoadingText": "Searching for flights",
  "flightSearchLoadingSubtitle": "",
  "flightSearchLoadingCancel": "Cancel search",
  "pricePrediction": {
    "header": "Price Prediction",
    "currentPrice": "Current lowest price",
    "currentLowestPrice": "{{price}} is the current lowest price",
    "lowestPriceOneWaySuffix": " one way, per traveler",
    "lowestPriceRoundTripSuffix": " round trip, per traveler",
    "oneWayCurrentPrice": "Current lowest price, one way, per traveler",
    "roundTripCurrentPrice": "Current lowest price, round trip, per traveler",
    "viewButton": "View price prediction",
    "unavailableHeader": "Price prediction data is unavailable.",
    "adjustOrReset": "Adjust or reset filters to see a price prediction for this trip.",
    "waitIcon": "Wait",
    "bookNowIcon": "Book Now",
    "forecastedHighest": "Forecasted highest price",
    "forecastedLowest": "Forecasted lowest price",
    "unsupportedFilters": "Price prediction data can only be viewed if your filter is set to No Stops or Any Number of Stops.",
    "unsupportedFiltersCopy": "The filters you've applied will not be taken into account when you watch this price.",
    "ariaLabel": "View price prediction details",
    "priceDropAriaLabel": "View price drop details",
    "freePriceDropProtection": "Free price drop protection included",
    "termsAndConditions": "<p>$t(brand:portalName) price prediction services and notifications, offered in collaboration with Hopper, provide a powerful tool to assist you in finding the best time to book travel and save money. $t(brand:clientName) and Hopper work hard to ensure the accuracy of its predictions based on past data and current trends. However, forecasting price movements in a highly competitive, unpredictable global market has inherent limitations, and no prediction tool can be 100% accurate. Accordingly, while $t(brand:clientName) and Hopper believe strongly in the accuracy of its predictions, they do not guarantee its accuracy, and shall not be liable for any reliance upon them, except as expressly set forth in the terms of any $t(brand:clientName) product purchased by you.</p><p><strong>Disclaimer:</strong> Availability of these services may vary based on your account, and not all services are available to all customers or on all bookings. The availability of the services is subject to change without prior notice. $t(brand:clientName) may revise these Terms and Conditions at any time by updating this posting.</p><p>Some of the services made available through $t(brand:portalName) are offered by Hopper (USA) Inc. and its affiliated companies (“Hopper”). Your use of the services offered by Hopper, and other third-parties that may be linked to from the Sites will be governed by their respective Terms and Conditions and Privacy Policies.</p>"
  },
  "noDataErrorTitle": "Not enough data.",
  "noDataErrorSubtitle": "We are unable to make an accurate prediction but you can still view flights.",
  "noFlightsTitle": "No flights found",
  "noFlightsSubtitle": "There are no flights available for your selected dates.",
  "noFlightsFilterSubtitle": "There are no flights on these dates that match your preferences.",
  "changeDates": "Change Dates",
  "noResultsCta": "Change Dates",
  "resetFilters": "Reset Filters",
  "adjustFilters": "Adjust Filters",
  "pdpTitle": "How it works",
  "readTermsAndConditions": "Read Terms and Conditions",
  "flightBookPdpHeader": "Book now with <span class='font-regular'>free price drop protection</span>",
  "flightShopPdpHeader": "<span class='font-regular'>Price prediction</span> allows you to book with confidence.",
  "flightShopPdpSubtitle": "To save you an average of 15% on flights, our price prediction tool recommends the best time to book with 95% confidence.",
  "priceDropSubtitle_one": "We'll monitor the price for up to {{days}} day. If we detect a price drop, we'll refund the difference up to {{maxRefund}}.",
  "priceDropSubtitle_other": "We'll monitor the price for up to {{days}} days. If we detect a price drop, we'll refund the difference up to {{maxRefund}}.",
  "priceDropProtectionBody": "<p>When Hopper recommends that a customer buys a given flight now (including a flight subject to a frozen flight price), Hopper will automatically apply price drop protection to that purchase.</p><p>For flights subject to a frozen price, Price Drop Protection is based on the recommendation at the time of purchase to freeze the price. If the recommendation changes before or at the time of exercise of the frozen flight price, the initial recommendation at the time of purchase to freeze a price still applies.</p><p>Once price drop protection is applied to a flight, Hopper will monitor the price of that particular itinerary (with the same flight, fare class, seat selection if applicable, etc.) for a set amount of time (e.g., 10 days) after the day of purchase. There is no further action on the customer's part to receive this complimentary price drop protection service.</p><p>Throughout the timeframe of monitoring, Hopper will record price updates at least every 24 hours. After the monitoring timeframe has expired, if there was a price drop of at least a certain threshold (e.g., $5), the maximum difference in price will be refunded to the customer, up to a set limit (e.g., $30). Price drops smaller than the threshold will not trigger a refund.</p><p>Refunds under the price drop protection plan made for a frozen flight purchase may be calculated differently to take into account the amount Hopper already paid on your behalf if the frozen flight price was less than the current flight price at the time of purchase. If this amount was greater than the set limit, you will not receive a price drop protection benefit refund.</p><p>When you receive a refund under the price drop protection benefit, the refund will be applied to your original form of payment (e.g., credit card and/or rewards redemption), up to the benefit maximum. If you used a credit card and/or redeemed rewards to purchase the fare, the difference will be refunded proportionally, up to the benefit maximum. Price drop refunds will result in an adjustment to the amount of rewards you earned on that transaction.</p><p>In the case that a user voids or cancels a flight, Hopper will no longer monitor the flight or provide price drop protection.</p>",
  "priceFreezeTitles": {
    "header": "<span class='font-regular'>Freeze the price,</span> <span>book later.</span>",
    "title": "Freeze the current price for <strong>{{durationText}}</strong> for <strong>{{amount}}</strong> or <strong>{{rewards}}</strong> per traveler.",
    "increaseText": "<strong>If the price goes up after you freeze,</strong> we'll cover the difference up to {{priceString}} per traveler when you book with us.",
    "decreaseText": "<strong>If the price goes down after you freeze,</strong> you pay the lower price when you book with us!",
    "similarFlightText": "<strong>If there aren't enough available seats when you try to book,</strong> you can choose between a seat on a similar flight if available or a full refund.",
    "ctaText": "Read Terms and Conditions"
  },
  "priceWatchErrors": {
    "invalidEmail": "Enter a valid email address",
    "createErrorTitle": "Something went wrong",
    "createErrorSubtitle": "Please try again."
  },
  "flightShopReview": {
    "bestFlight": "Best Flight",
    "cheapestFlight": "Cheapest",
    "bestQuality": "Best Quality",
    "fastest": "Fastest",
    "itineraryHeader": "Review Itinerary",
    "itinerarySubheader": "Review the details of your trip before you continue",
    "customerSupportTitle": "Customer Support",
    "customerSupportSubtitle": "Guaranteed assistance with your trip",
    "viTicketTitle": "Your trip is a combination of multiple itineraries.",
    "multiTicketTitle": "Your trip is a combination of 2 one-way fares.",
    "nonMultiTicketTitle": "Ready to book?",
    "viTicketMultipleAirlinesSubtitle": "Restrictions may differ between airlines.",
    "viTicketSubtitle": "Restrictions may differ between fares.",
    "multiTicketSubtitle": "Restrictions may differ between airlines.",
    "nonMultiTicketSubtitle": "Here are some details you should know about.",
    "multiTicketBanner": "Your trip is a combination of 2 one-way fares. Restrictions may differ between airlines.",
    "continueToCheckout": "Continue to checkout",
    "outboundCardHeader": "<strong>Departure to {{location}}</strong> on {{date}}",
    "outboundCardHeaderWithOrigin": "<strong>{{origin}}</strong> to <strong>{{destination}}</strong> on <strong>{{date}}</strong>",
    "departureCardHeader": "<strong>Departure to {{location}}</strong> on {{date}}",
    "returnCardHeader": "<strong>Return to {{location}}</strong> on {{date}}",
    "changeFlight": "Change Flight",
    "departureTo": "Departure to {{location}}",
    "voucherApplicable": "Your {{amount}} wallet balance will be applied at checkout"
  },
  "chooseFlightOneWay": "Prices are single trip, per traveler",
  "chooseFlightRoundTrip": "Prices are round trip, per traveler",
  "flightShopHeader": {
    "departureTitle": "<strong>Choose outbound <strong>flight to {{location}}",
    "returnTitle": "<strong>Choose return <strong>flight to {{location}}",
    "subtitleSingleTrip": "Prices are single trip, per traveler",
    "subtitleRoundTrip": "Prices are round trip, per traveler"
  },
  "calendarModal": {
    "updateDate": "Update your dates"
  },
  "algomerch": {
    "title": "How are flights scored?",
    "scoreFactor": {
      "airline": "Airline",
      "fareClass": "Fare Class",
      "price": "Price",
      "duration": "Duration",
      "stops": "Stops"
    },
    "cheapestTag": {
      "title": "Best Price",
      "description": "Travel more (for less).",
      "factors": "We sift through hundreds of <strong>flight prices</strong> to find the absolute best price."
    },
    "bestFlightTag": {
      "title": "Best Overall",
      "description": "Let data decide.",
      "factors": "<strong>Price</strong>, <strong>quality</strong>, and <strong>total flight time</strong> are considered to find the flight with the highest flight score and best overall value."
    },
    "fastestTag": {
      "title": "Fastest",
      "description": "Get from A to B without losing any Zzz's.",
      "factors": "<strong>Duration</strong> and <strong>number of stops</strong> are considered to identify the fastest flight."
    },
    "bestQualityTag": {
      "title": "Best Quality",
      "description": "Sit back. Stretch out.",
      "factors": "<strong>Airline</strong>, <strong>fare class</strong>, and <strong>stops</strong> are considered to find the flight with the comfiest flying experience."
    }
  },
  "frozenPrice": "Frozen Price",
  "loadingFlightDetails": "Loading Flight Details",
  "flightDetailsError": "Something went wrong loading flight details. Please try again.",
  "noFlightsFound": "No flights found",
  "noFlightsAvailable": "There are no flights available",
  "fareClassFlightsNotFound": "There are no flights available in this fare category.",
  "filteredFlightsNotFound": "There are no flights available for this filter set.",
  "genericShopErrorTitle": "Oops… something went wrong!",
  "genericShopErrorSubtitle": "Check to see if you are connected to a network right now or try reloading.",
  "genericShopErrorButton": "Reload",
  "flightShopAdjustDates": "Adjust Dates ",
  "flightShopFooterTitle": "Find more flights",
  "flightShopFooterSubtitle": "Adjust your dates or reset filters to see more results.",
  "flightShopProgress": {
    "departure": "Choose Departure",
    "return": "Choose Return",
    "reviewItinerary": "Review Itinerary",
    "customize": "Customize"
  },
  "combinationFlightTitle": "Flight combination",
  "combinationFlightWarning": "This fare is part of a flight combination",
  "combinationFlightDescription": "Your trip is a combination of 2 one-way fares.",
  "combinationFlightTooltip": "Restrictions may differ between outbound and return flights. Cancellations or changes to one of your flights will not alter the other automatically.",
  "oneWayPerTraveler": "One way trip, per traveler",
  "roundTripPerTraveler": "Round trip, per traveler",
  "taxesIncluded": "taxes incl",
  "viewLess": "View Less",
  "viewDetails": "View details",
  "priceFreezeRefund": {
    "title": "Can't find a similar flight?",
    "subtitle": "If you can't find a similar flight, you can still get a refund.",
    "button": "Get a Refund"
  },
  "change": "Change",
  "updateTravelers": "Update Travelers",
  "flightShopLocationModal": "Update your locations",
  "priceFreezeTermsAndConditions": "<p>The ability to freeze a flight price through $t(brand:portalName) is subject to the following Terms and Conditions. Not all services are available to all customers or on all bookings. The availability of this service is subject to change without prior notice. $t(brand:portalName) may revise these Terms and Conditions at any time by updating this posting.</p><p>Some of the services made available through $t(brand:clientName) are offered by Hopper (USA) Inc. and its affiliated companies (“Hopper”). Your use of the services offered by Hopper, and other third-parties that may be linked to from the Sites, will be governed by their respective Terms and Conditions and Privacy Policies.</p><p>When you pay to freeze a flight price, you purchase the opportunity to buy a selected airline ticket at a specified ticket price for a specified period of time, subject to availability and any applicable maximum service cap, which would detail the limit of your frozen flight price coverage (e.g., $1,000). If you pay to freeze a flight price, we will send you a confirmation email indicating the details of the flight itinerary that you have frozen a price for, as well as the expiration time of the freeze. You can also view all frozen itineraries, with their respective expiration dates and times, under My Trips. By purchasing a frozen flight price, you agree to these Terms and Conditions:</p><ol><li><strong>Purchase price.</strong> The fee to freeze a flight price is a service fee. By purchasing a frozen price, you authorize $t(brand:portalName) to charge your selected payment method for the quoted fee amount. The fee is applicable for each individual passenger that the price is frozen for. All frozen prices are non-transferable and non-refundable, with an exception for cases in which the flight is no longer available, detailed in Section 3 below.</li><li><strong>Exercise Window.</strong> Your frozen price will be available to exercise for a specified period of time that will be disclosed prior to purchasing, referred to as the Exercise Window. This Exercise Window commences upon purchase and expires upon the expiration of the timeframe specified on the confirmation page at time of purchase (e.g., 14 days). If you pay to freeze a flight price, we will send you a confirmation email indicating the details of the flight itinerary that you have frozen a price for, as well as the expiration date and time of the freeze. You can also view all frozen itineraries, with their respective expiration dates and times, under My Trips. $t(brand:clientName) is not responsible for technical issues outside of $t(brand:clientName)'s control that prevent you from purchasing a flight at its frozen price during the Exercise Window.</li><li><strong>Availability.</strong> Freezing a price guarantees the price for a specified ticket (up to a maximum refund cap, if applicable), but does NOT guarantee availability of the frozen flight itinerary at the time of booking the ticket. In the case that a frozen itinerary is canceled, becomes unavailable, or no longer has available seats remaining, you will be notified upon attempting to exercise the frozen itinerary. If available, you will be offered similar flights by $t(brand:portalName) as alternatives to the canceled or unavailable itinerary. You may exercise your frozen price for a suggested similar flight, subject to the maximum service cap and to availability. If you do not accept that offer, or $t(brand:portalName) does not offer an alternative similar flight, $t(brand:portalName) will refund the service fee paid to freeze the original flight price. Upon purchase, you acknowledge and agree that this shall be your sole and exclusive remedy for the unavailability of the selected flight.<br>Upon freezing a price for multiple tickets together, the multiple frozen prices may not be exercised individually and must be exercised together. If a flight does not have sufficient seats available for the frozen prices to be exercised together, you will be offered the same alternatives as detailed in Section 3 for similar flights and a refund.</li><li><strong>Specified tickets.</strong> A frozen price is valid only for the specified airline ticket(s) selected by you and based on the information provided by you at the time of purchasing the frozen price. No changes to flights, times, dates, cabin classes, or number of passengers will be permitted. $t(brand:portalName) is not responsible for errors you make during the process of purchasing a frozen price.</li><li><strong>Exercise process.</strong> You can purchase a flight itinerary at its frozen price under My Trips, so long as the frozen price is valid, has not yet expired, and is still available. When purchasing a flight itinerary at a frozen price, if the price has increased, you will pay the frozen price and, if applicable, any price increase exceeding the maximum service cap. The frozen price is valid only for the number of passengers indicated at the time of freezing the price. Any additional passengers will be billed for the current airline rate. If the airline rate at the time of booking is lower than the frozen price, you will purchase your flights at the lower rate. Following purchase of the specified ticket(s), any refunds, cancellations or exchanges of the purchased ticket will be subject to the fare rules set by the issuing airline.</li><li><strong>Service cap.</strong> When you freeze a flight price, it may be subject to a maximum service cap per passenger (e.g., $1,000 per passenger). The maximum cap will be disclosed prior to purchasing a frozen price and will be stated on the confirmation page and email. Upon exercising the frozen price, if the flight price has increased to be more than the stated maximum service cap per passenger, the benefit of the frozen price will be limited to the stated maximum service cap amount. In this instance, you'll pay the current flight price subtracting the maximum service cap.  In the event that the flight price does not exceed the maximum service cap per passenger, you'll pay the frozen price upon exercise.</li><li><strong>Expiration.</strong> You may elect not to purchase the specified airline ticket(s) during the applicable Exercise Window, in which case the option to purchase the ticket(s) at the frozen price option will expire at the end of the Exercise Window, and $t(brand:portalName) will have no further obligation to sell tickets at the specified price. There is no further charge for allowing a frozen price option to expire. If you elect to purchase the specified airline ticket(s) after the end of the Exercise Window, you will pay in full the ticket price quoted by $t(brand:portalName) at the time of ticket purchase, which may be higher than the price specified in the expired frozen price option. Upon expiration of the frozen price, an option to freeze the price again is presented. You are under no obligation to freeze the price again.</li><li><strong>Not insurance.</strong> The ability to freeze a price is the option to purchase, from $t(brand:portalName), a selected airline ticket at a specified price during the Exercise Window. $t(brand:portalName) provides its customers with the option to freeze a price to provide a more seamless and flexible experience for travel booked through the Sites. The ability to freeze a price is not intended to constitute an offer to insure, does not constitute insurance or an insurance contract, and does not take the place of insurance obtained or obtainable by you.</li><li><strong>Price Drop Protection.</strong> After exercising a frozen price(s), you may still be eligible for the Price Drop Protection benefits subject to any applicable maximum service cap. Price Drop Protection is only available on flights that have a “buy” recommendation at the time of purchase to freeze a price. If the “buy” or “wait” recommendation changes before or at the time of exercise of the frozen price, the initial recommendation at the time of purchase to freeze a price still applies.<br>Price Drop Protection will only provide a refund if the monetary benefit you have received from freezing and exercising the price is less than the applicable maximum service cap for Price Drop Protection.You are eligible for a refund up to the maximum service cap for Price Drop Protection after adding the benefit you have received from freezing and exercising the price.</li></ol>",
  "originalPriceFreeze": {
    "similarFlightTitle": "Choose a Similar Flight",
    "similarFlightSubtitle": "You can exchange your flight at no extra cost. Your original frozen price and the remaining duration of the freeze will be transfered to this new flight.",
    "unavailableReturnTitle": "Unavailable <strong>Return Flight</strong>",
    "unavailableOutboundTitle": "Unavailable <strong>Outbound Flight</strong>",
    "title": "Original frozen price",
    "roundTripCategory": "Round trip, per traveler",
    "oneWayTripCategory": "One-way trip, per traveler"
  },
  "pricePerTraveller": "{{price}} per traveler",
  "roundTripCategoryPassenger": "Round trip, per passenger",
  "oneWayTripCategoryPassenger": "One-way trip, per passenger",
  "roundTripCategoryTotal": "Round trip total",
  "oneWayTripCategoryTotal": "One-way trip total",
  "priceFreezeEntry": {
    "loading": "Loading Price Freeze",
    "detailsHeader": "We selected the flights with the <strong style='display: inline-block;'>current lowest price</strong> for you.",
    "detailsSubheader": "You can also choose your own set of flights and freeze the price when reviewing your itinerary.",
    "priceDuration": "Current price being frozen for <strong>{{timeToLive}}</strong>",
    "continueAriaLabel": "Price freeze checkout",
    "anotherFlight": "Choose Another Flight",
    "anotherFlightAriaLabel": "Choose another flight",
    "termsAndConditionsAriaLabel": "Price freeze terms and conditions",
    "infoHeaderTitleBold": "<strong>Freeze the Price</strong>, Book Later",
    "infoHeaderTitle": "Freeze the price, book later",
    "viewInfo": "View price freeze info",
    "notReadyToBook": "Not ready to book?",
    "cardTitle": "Price Freeze",
    "cardSubtitle": "Freeze the price, book when you’re ready.",
    "cardSubtitleAlt": "Book when you’re ready.",
    "lowestPriceAndDurationDetails": "Pay a fee of <strong>{{price}}</strong> per traveler to freeze the current lowest price of this trip for {{duration}}",
    "priceAndDurationDetails": "Pay a fee of <strong>{{price}}</strong> per traveler to freeze the price of this trip for {{duration}}",
    "freezePriceShort": "Freeze",
    "freezePrice": "Freeze price",
    "freezeThisPrice": "Freeze This Price",
    "moreInformation": "More information"
  },
  "similarFlights": {
    "itineraryUpdated": "Your itinerary has been updated and you can continue booking your flight",
    "success": "Success!",
    "unableToProcess": "We were unable to process your selection, please contact support for further assistance or try again.",
    "somethingWentWrong": "Something went wrong."
  },
  "layoverWithLocation": "{{duration}} layover in {{location}}",
  "flightAirportDetails": "<segmentTime>{{time}}</segmentTime> - {{airportName}} ({{airportCode}})",
  "flightAirportDetailsWithArrivalDate": "<segmentTime>{{time}} [{{arrivalDate}}] </segmentTime> {{airportName}} ({{airportCode}})",
  "inlineChangeFlightAirportDetails": "<original>{{prevTime}}</original> <updated>{{newTime}}</updated> - {{airportName}} ({{airportCode}})",
  "flightArrivalDifferentDay": {
    "flightArrivesOnDate": "This flight arrives on <1>{{arrivalDate}}</1>",
    "flightArrivesNextDay": "This flight arrives the next day on <1>{{arrivalDate}}</1>",
    "flightArrivesPlusDays": "This flight arrives {{plusDays}} days after departure on <1>{{arrivalDate}}</1>"
  },
  "connectingFlightDifferentDay": {
    "flightDepartsOnDate": "Connecting flight departs on <1>{{departureDate}}</1>",
    "flightDepartsNextDay": "Connecting flight departs the next day on <1>{{departureDate}}</1>",
    "flightDepartsPlusDays": "Connecting flight departs {{plusDays}} days after arrival on <1>{{departureDate}}</1>"
  },
  "restrictions": {
    "baggage": {
      "checkedBagAllowance": "Checked Bag Allowance",
      "notAllowed": "Not Allowed",
      "bagCharge": "Bag {{bagPiece}} at {{bagPrice}}",
      "bagChargeWithMass": "Bag {{bagPiece}} at {{bagPrice}}, max {{mass}}",
      "bagsIncluded_one": "{{count}} bag included",
      "bagsIncluded_other": "{{count}} bags included",
      "bagsIncludedWithMass_one": "{{count}} bag included, {{mass}}",
      "bagsIncludedWithMass_other": "{{count}} bags included, {{mass}}"
    },
    "cancellations": {
      "name": "Cancellations"
    },
    "exchanges": {
      "name": "Exchanges"
    },
    "penalties": {
      "withFee": "For a fee of {{price}}",
      "contactSupport": "Contact support",
      "nonRefundable": "Non-refundable",
      "free": "Free",
      "cancelForCredit": "Cancel for a credit",
      "viewEligibility": "Click 'Cancel Flight' above to view eligibility",
      "contactAirline": "Contact airline"
    }
  },
  "additionalLayoverStops": "+ {{remainingStops}} more",
  "operatedBy": "Operated by {{airline}}",
  "flightNextDay": "This flight arrives the next day.",
  "departingOnWithDate": "Departing on {{date}}",
  "assistanceOptions": {
    "blind": "Blind passenger",
    "deaf": "Deaf passenger",
    "stretcher": "Stretcher assistance",
    "wheelchairStairs": "Wheelchair/Passenger can walk up stairs",
    "wheelchairSeat": "Wheelchair/Passenger can walk to seat",
    "wheelchairCarried": "Wheelchair/Passenger must be carried",
    "wheelchairDryBattery": "Wheelchair with Dry Cell Battery",
    "wheelchairWetBattery": "Wheelchair with Wet Cell Battery",
    "wheelchairLithiumBattery": "Wheelchair with Lithium Battery",
    "wheelchairManual": "Wheelchair, manual power",
    "wheelchairOnBoard": "Wheelchair, On-Board"
  },
  "requiredAssistance": "Required assistance",
  "redressNumber": "Redress number",
  "knownTravelerNumber": "Known traveler number",
  "saveFrequentFlyer": "Save Frequent Flyer Details",
  "frequentFlyerProgram": "Frequent flyer program",
  "frequentFlyerNumber": "Frequent flyer number",
  "addAnotherProgram": "Add Another Program",
  "saveFlyerDetails": "Save flyer details",
  "over": "Over",
  "calendarLegend": {
    "lowest": "Lowest",
    "low": "Low",
    "medium": "Medium",
    "high": "High"
  },
  "reviewItinerary": {
    "continueBooking": "Continue booking",
    "freezePrice": "Freeze price",
    "priceFreezeDescriptionTitle": "Hold this fare starting at {{price}}",
    "priceFreezeDescriptionSubtitle": "Book later when you're ready",
    "priceFreezeButton": "Freeze price starting at {{price}}"
  },
  "pricefreeze": {
    "continueToBooking": "Continue to Booking"
  },
  "selectThisOutbound": "Select this outbound",
  "selectThisReturn": "Select this return",
  "gotIt": "Got it",
  "chargedInCurrency": "This booking will be charged in {{currency}}",
  "priceBreakdown": "Price Breakdown",
  "oneWay": "One way",
  "oneWayDescription": "A one-way flight to the final destination.",
  "roundTrip": "Round trip",
  "roundTripDescription": "One-way flight to the final destination and another flight back to the city of origin.",
  "seeMoreInfo": "See more info",
  "originalFlight": "Original flight",
  "selectNewOutbound": "Select a new Outbound flight",
  "rebookFlightNoCost": "Rebook a new flight at no additional cost",
  "flightSearchLoading": {
    "step1Description": "Searching over 300 airlines and 100,000 different flight combinations to get you the best prices",
    "step2Title": "Finding the best deals",
    "step2Description": "Creating the best flight combinations to save you money",
    "step3Title": "Not ready to book just yet?",
    "step3Description": "You can add flights to your watch list so we can notify you when the price drops!"
  },
  "flightDiscountDesktop": "You have flight discounts available! You can apply them once you've selected your flights.",
  "flightDiscountMobile": "You have flight discounts available!",
  "flightDetailsExpandCta": "Tap to review your selected flights",
  "flightDetailsExpandedCta": "Close Flights Summary",
  "displayRestrictions": "Display fare restrictions by airline",
  "hideRestrictions": "Hide fare restrictions by airline",
  "virtualInterline": {
    "flightCombinationBanner": "This fare is part of a flight combination"
  },
  "filter": "Filter",
  "perPerson": "per person",
  "pricePerPerson": "<strong>{{price}}</strong> per person",
  "flightCard": {
    "pricePerPerson": "<0>{{price}}</0> per person",
    "pricePerRoundTripPerPerson": "<0>{{price}}</0> round trip per person"
  },
  "b6Upsell": {
    "title": {
      "blue": "Upgrade to Blue extra for expedited security and priority boarding",
      "blueBasic": "Heads up! This fare is inexpensive but has some restrictions"
    },
    "button": {
      "primary": "Upgrade to {{name}} (+{{price}})",
      "secondary": "Stick with {{name}}"
    },
    "uta": {
      "boarding": "Boarding",
      "carryOn": "Carry-on Bags",
      "checkedBags": "Checked Bags",
      "checkInPriority": "Even More® Speed",
      "change": "Changes",
      "cancellation": "Cancellation",
      "sameDayChange": "Same-day Switches",
      "seatSelection": "Seat Selection"
    },
    "overrides": {
      "generalBoarding": "General",
      "boardsEarly": "Early",
      "boardsLast": "Last",
      "cancelForCredit": "Credit"
    }
  },
  "oneWayPriceSummary": "One way",
  "roundTripPriceSummary": "Round trip",
  "priceUnavailable": "Price unavailable",
  "amountCashBack": "{{amount}} in cash back",
  "flightDuration": {
    "days": "{{count}}d",
    "hours": "{{count}}h",
    "minutes": "{{count}}m"
  },
  "tripdetails": {
    "outboundDateHeaderModal": "Outbound to {{airportcode}} on {{date}}",
    "returnDateHeaderModal": "Return to {{airportcode}} on {{date}}"
  },
  "fareGrid": {
    "moreFares": "+ {{count}} more fares"
  },
  "flightReview": {
    "departureTitle": "Departure",
    "returnTitle": "Return",
    "header": {
      "title": "Ready to book?",
      "subtitle": "Here are some details you should know about."
    },
    "viewDetails": "View details",
    "closeFlightDetails": "Close",
    "itineraryTitle": "<1>{{fromCity}} to {{toCity}}</1> on {{date}}",
    "multiTicketTitle": "Your trip is a combination of 2 one-way fares.",
    "nonMultiTicketTitle": "Ready to book?",
    "multiTicketSubtitle": "Restrictions may differ between airlines.",
    "nonMultiTicketSubtitle": "Here are some details you should know about."
  },
  "passengerLabel": {
    "count_one": "{{count}} Passenger",
    "count_other": "{{count}} Passengers"
  },
  "core-flights": {
    "funnelName": "Flights",
    "exchange": {
      "slicePicker": {
        "chooseFlightsModalTitle": "Which flight would you like to exchange?",
        "confirmButtonLabel": "Confirm and continue"
      }
    },
    "postbooking": {
      "exchangeEligibility": {
        "cancelFlightBtn": "Cancel Flight",
        "canceledBody": "Canceled flights cannot be exchanged",
        "canceledTitle": "This flight was canceled",
        "contactSupportBtn": "Contact Support",
        "contactSupportBody": "This booking cannot be self-serviced",
        "contactSupportTitle": "Please contact support for assistance",
        "continueToExchangeBtn": "View Exchange Options",
        "loadingPolicyMsg": "Loading your flight's exchange policy...",
        "loadFailedBody": "Please try again or contact support",
        "loadFailedTitle": "We couldn't load your flight exchange policy",
        "modalTitle": "Exchange Eligibility",
        "tryAgainBtn": "Try Again",
        "visitAirlineBtn": "Visit {{airlineName}}"
      },
      "scheduleChange": {
        "acceptSuccess": {
          "body": "You will receive a confirmation email with your new itinerary shortly. Thank you for choosing us for your travel needs.",
          "title": "Change complete"
        },
        "badge": "Finding alternatives",
        "badge_major": "Major change",
        "badge_minor": "Minor change",
        "badge_unknown": "Unknown change",
        "contactAirline": {
          "airlineLocatorLabel": "{{airlineName}} Booking Reference",
          "body_one": "Given that you're within 75 hours of departure, please directly verify and manage any changes with {{airlineName}}, using your airline confirmation code found below and in your confirmation email.",
          "body_other": "Given that you're within 75 hours of departure, please directly verify and manage any changes with each airline, using the respective airline confirmation codes found below and in your confirmation email.",
          "closeBtn": "Not now",
          "title": "Contact airline for assistance",
          "visitAirlineBtn": "Go to {{airlineName}}"
        },
        "form": {
          "acceptButtonTitle": "Accept change",
          "acceptDetails": "We will confirm this new flight and send you a confirmation email. ",
          "denyButtonTitle": "Refuse change, contact support",
          "denyButtonTitle_contactAirline": "Refuse change",
          "denyDetails": "Decline the change and find an alternative flight together with one of our agents.",
          "denyDetails_contactAirline": "Given that you are within 75 hours of departure, verify and manage changes directly with the airline. We will provide information to make this process easier for you.",
          "formTitle": "How would you like to proceed with this change?",
          "submitButtonLabel": "Continue",
          "timePreference": "What time do you prefer for your new {{flightType}} flight?",
          "times": {
            "afternoon": "Afternoon",
            "afternoonDetails": "12:00pm - 5:59pm",
            "earlyMorning": "Early morning",
            "earlyMorningDetails": "12:00am - 4:59am",
            "evening": "Evening",
            "eveningDetails": "6:00pm - 11:59pm",
            "morning": "Morning",
            "morningDetails": "5:00am - 11:59am"
          }
        },
        "processing": "Processing your schedule change decision...",
        "updatedItinerary": "Updated Itinerary",
        "updatedBadge": "Updated",
        "originalItinerary": "Original Itinerary"
      }
    },
    "taxBreakdown": {
      "modalTitle": "Breakdown of taxes and fees",
      "defaultTaxLabel": "Tax",
      "closeButton": "Close",
      "viewButtonAriaLabel": "View tax breakdown",
      "noTaxesAvailable": "No taxes available"
    },
    "search": {
      "mobileSearch": {
        "startSearch": "Search for flights",
        "continue": "Continue",
        "title": "Search for flights"
      },
      "locationSelection": {
        "searching": "Searching...",
        "whereFrom": "Where from?",
        "whereTo": "Where to?"
      },
      "dateSelection": {
        "title": {
          "short": {
            "oneWay": "Choose date",
            "roundTrip": "Choose dates"
          },
          "full": {
            "oneWay": "Select your departure date for your flight",
            "roundTrip": "Select the arrival and departure dates for your flight"
          }
        },
        "search": "Search",
        "apply": "Apply",
        "calendarPriceTags": {
          "over": "Over {{price}}",
          "lowest": "Lowest",
          "low": "Low",
          "medium": "Medium",
          "high": "High"
        },
        "chooseDates": "Choose dates",
        "accessibilityToggle": {
          "label": "Toggle accessibility colors",
          "on": "On",
          "off": "Off"
        }
      },
      "passengerSelection": {
        "increaseAmountOfTravelersByCategory": "Increase {{category}} Traveler",
        "decreaseAmountOfTravelersByCategory": "Decrease {{category}} Traveler",
        "apply": "Apply",
        "passengerCount": "{{count}} Passenger",
        "passengerCount_other": "{{count}} Passengers"
      },
      "addFlight": "Add flight",
      "multicityError": "You've reached the maximum number of multi-city flights on a single booking."
    },
    "searchFilter": {
      "outboundTimes": "Outbound times",
      "returnTimes": "Return times",
      "timeSubheader": "Local times",
      "departFrom": "Depart from {{city}}",
      "arriveIn": "Arrive in {{city}}",
      "anytime": "Anytime"
    },
    "checkout": {
      "bookingConfirmation": {
        "title": "Confirmed, your flight is booked!",
        "subtitle": "An email confirmation will be sent to {{email}}",
        "confirmationId": "Your booking confirmation is #{{id}}"
      },
      "editFlights": "Edit flights"
    },
    "itinerary": {
      "status": {
        "confirmed": "Confirmed",
        "canceled": "Canceled",
        "modified": "Modified",
        "pending": "Pending"
      },
      "changes": {
        "major": "Major schedule change",
        "minor": "Minor schedule change",
        "unknown": "Unknown schedule change"
      },
      "card": {
        "itinerary": "{{origin}} to {{destination}}",
        "flight-number": "Flight Number",
        "airline": "Airline",
        "tripType": "Flight",
        "oneWay": "One way",
        "roundTrip": "Round trip",
        "confirmation": "Confirmation: {{number}}",
        "viewDetails": "View details",
        "notificationBanner": {
          "airlineWarning": "If you modify your itinerary through the airline, the status shown here may not be accurate. Check the airline's website for confirmation.",
          "majorLabel": "<0>Your flight has experienced an itinerary change.</0> Review the changes to your itinerary by {{expDate}}.",
          "minorLabel": "<0>The airline made a minor modification to your itinerary.</0>",
          "reviewScheduleChangeBtn": "Review schedule change",
          "cancelledItineraryPeriod": "This itinerary has been canceled.",
          "cancelledItineraryCredit": "This itinerary has been canceled for a travel credit valued at {{formattedCredit}}."
        },
        "slice": {
          "outboundTitle": "<1>Outbound to {{destination}}</1> on {{date}}",
          "returnTitle": "<1>Return to {{destination}}</1> on {{date}}"
        },
        "payments": {
          "title": "Payment info",
          "total": "Total paid",
          "viewDetails": "Details",
          "dialog": {
            "title": "Trip Total",
            "baseFare": "Base Fare",
            "taxes": "Taxes & Fees"
          },
          "generic": {
            "card": "Card",
            "rewards": "Rewards"
          }
        }
      },
      "travelers": {
        "title": "Travelers",
        "viewDetails": "View traveler details",
        "dialog": {
          "title": "Travelers ({{count}})"
        },
        "travelers_one": "{{count}} Traveler",
        "travelers_other": "{{count}} Travelers"
      },
      "confirmation-number": {
        "title": "Confirmation",
        "not-available": "Not yet available",
        "viewDetails": "View all ({{count}})",
        "dialog": {
          "title": "Confirmation Numbers ({{count}})",
          "subtitle": "To manage your trip from your airlines website, click the link next to the portion of the flight to be redirected.",
          "copy": "Copy",
          "copy-and-go": "Copy & go to airline",
          "confirmation-number-outbound": "{{airline}} Outbound: {{origin}} to {{destination}}",
          "confirmation-number-return": "{{airline}} Return: {{origin}} to {{destination}}"
        }
      },
      "detail": {
        "departureArrival": "{{departure}} - {{arrival}}",
        "stops_zero": "Nonstop",
        "stops_one": "{{count}} stop",
        "stops_other": "{{count}} stops",
        "booking-confirmation": {
          "title": "Booking confirmation",
          "dialog": {
            "title": "Manage your booking",
            "subtitle": "Check in and manage your booking directly through the airline using the confirmation code and link below."
          }
        }
      }
    },
    "departurePage": {
      "title": {
        "short": "Choose departure",
        "full": "<1>Choose outbound<1> flight to {{location}}"
      }
    },
    "returnPage": {
      "title": {
        "short": "Choose return",
        "full": "<1>Choose return<1> flight to {{location}}"
      }
    },
    "shopPage": {
      "subtitle": {
        "roundTrip": "Prices are for round trip, per traveler",
        "oneWay": "Prices are for one way, per traveler",
        "multiCity": "Prices are for one way, per traveler"
      },
      "notReadyToBook": "Not ready to book?"
    },
    "rebook": {
      "breadcrumbs": {
        "summary": "Missed Connection Guarantee",
        "choose-flight": "Choose Flight",
        "choose-outbound": "Choose Outbound",
        "choose-return": "Choose Return",
        "review": "Review Itinerary"
      },
      "trips": {
        "rebook-flight": "Rebook Connecting Flight"
      },
      "loading": {
        "price-quote": "Confirming your price...",
        "fulfill": "Rebooking your flight..."
      },
      "errors": {
        "generic": {
          "title": "Oops… something went wrong!",
          "subtitle": "Please try again soon, we should have the issue resolved in no time."
        },
        "network": {
          "title": "Oops… something went wrong!",
          "subtitle": "Check to see if you are connected to a network right now or try reloading."
        },
        "actions": {
          "dismiss": "Dismiss",
          "retry": "Retry"
        }
      },
      "summary": {
        "pageTitle": "Missed Connection Guarantee",
        "title": "Select the connecting flight you missed and we’ll provide you with free rebooking options that get you to <bold>{{destinationName}}</bold> ({{destinationCode}}).",
        "subtitle": "The cost of this rebooking is covered under our <action>Missed Connection Guarantee. <info/></action>",
        "slice-title": "<bold>{{originName}}</bold> ({{originCode}}) to <bold>{{destinationName}}</bold> ({{destinationCode}}) on {{departureDate}}",
        "rebook-button": "Rebook connecting flight",
        "contact-support-button": "Contact support",
        "notice": {
          "title": "Know before you rebook",
          "body": "<item>All rebooking options through $t(brand:portalName) will fly you to <bold>{{destinationName}}</bold> ({{destinationCode}}).</item><item>You will need to collect and re-check any baggage onto your new connecting flight. Additional baggage fees may apply in some cases.</item>"
        },
        "important-info": {
          "title": "Important information",
          "items": "<item>Online rebooking is only available if rebooking for all original travelers. If you would only like to rebook some of the passengers included in your original booking, please call us at <bold>{{supportNumber}}</bold>.</item><item>When rebooking, you’ll choose from flights that depart on the same day or following day of your original flight, arrive at the final intended destination as your original flight, and are the same or a lower fare class.</item><item>You can choose from flights that are within a <bold>{{amountCap}} cap per traveler</bold>.</item>"
        }
      },
      "shop": {
        "book-button": "Select and continue"
      },
      "review": {
        "title": "Review and confirm your new flight",
        "subtitle": "Review the details of your new connecting flight, as well as traveler information before you continue.",
        "travelers-heading": "Travelers on the original itinerary:",
        "button": "Confirm and rebook",
        "notice": {
          "title": "Know before you rebook",
          "bullets": {
            "departure-rebook": "Your return flight from <bold>{{originName}}</bold> ({{originCode}}) to <bold>{{destinationName}}</bold> ({{destinationCode}}) on <bold>{{departureDate}}</bold> is operating as normal.",
            "one-way-flight": "After you confirm and rebook this connecting flight, it will appear as its own one-way flight in my trips.",
            "baggage-recheck": "You will need to collect and re-check any baggage onto your new connecting flight. Additional baggage fees may apply in some cases."
          }
        }
      }
    },
    "vi": {
      "multipleAirlinesNotice": "This flight operates through multiple airlines.",
      "countOther_one": "+{{count}} more",
      "countOther_other": "+{{count}} more",
      "segmentRoute": "<bold>{{originName}} ({{originCode}})</bold> to <bold>{{destinationName}} ({{destinationCode}})</bold>",
      "reviewPage": {
        "missedConnectionGuaranteeCTA": "Missed Connection Guarantee included <info/>",
        "fareRestrictions": {
          "flightSpecificRestrictions": "Compare airline-specific restrictions",
          "dialog": {
            "title": "Fare restrictions",
            "content": "This flight operates through multiple airlines. Below is the breakdown of fare restrictions for each individual flight. Ensure you’ve read and understood the differences in restrictions for each flight so you can plan accordingly.",
            "outboundTitle": "<bold>Outbound</bold> on {{date}}:",
            "returnTitle": "<bold>Return</bold> on {{date}}:",
            "outbound": "Outbound",
            "return": "Return"
          }
        }
      },
      "recheckBags": {
        "banner": {
          "copy": "You are required to claim and re-check baggage during layovers.",
          "learnMore": "Learn more"
        },
        "dialog": {
          "title": "Why do I have to claim and re-check my bags?",
          "instructions": "<title>How it works</title><paragraph>$t(brand:portalName) lets you purchase flights that operate through multiple airlines to provide you with more options to get to your destination, but the airlines aren’t able to coordinate baggage transfers between the flights.</paragraph><section>If you check your baggage, follow these steps during layovers.</section><title>Step 1:</title><paragraph>Pick up your bags from baggage claim and re-check them with the next airline.</paragraph><title>Step 2:</title><paragraph>Re-enter the airport gate through security.</paragraph>",
          "international-flights": "<title>International flights:</title><paragraph>If you’re traveling on an international flight, you may be required to go through customs during layovers.</paragraph>",
          "layover-notice": "This flight includes a <bold>{{duration}}</bold> layover in {{locationName}} ({{locationCode}})."
        }
      },
      "missedConnectionGuarantee": {
        "banner": "Layover protected by our <action>Missed Connection Guarantee <info/></action>",
        "dialog": {
          "title": "Missed Connection Guarantee",
          "whatsIncluded": "<title>What’s included</title><paragraph>If you’re going to miss a connecting flight or have a flight canceled by the airline while traveling, you can book a new flight to your destination on any airline available through $t(brand:portalName). Choose between flights within <bold>a {{amountCap}} cap per traveler</bold>. No validation with the airline required—it’s that simple.</paragraph>",
          "instructions": "<title>How to rebook a flight through $t(brand:portalName)</title><step>Step 1:</step><paragraph>Sign in to $t(brand:portalName) and visit My Trips to rebook your connecting flight <bold>within 24 hours of the flight’s departure</bold>.</paragraph><step>Step 2:</step><paragraph>Choose from flights that depart on the same day or following day of your original flight, arrive at the final intended destination of your original flight, and are the same or a lower fare class.</paragraph>"
        }
      },
      "nearbyDates": {
        "emptyPlaceholder": "no flights"
      }
    },
    "fintechMarketplace": {
      "title": "Customize your trip",
      "subtitle": "Treat yourself to a trip that suits your needs.",
      "addOnsSectionTitle": "Add ons"
    },
    "fixedPricing": {
      "pointsEligibilityBanner": {
        "title": "You need at least {{minimum}} points to redeem",
        "description": "This is why you're only seeing cash pricing. Consider booking with your eligible RBC credit card to earn points for future travel."
      }
    }
  },
  "metaSearch": {
    "breakdown": {
      "mcpProduct": "Missed Connection Guarantee",
      "baseFareAdult": "Base fare per adult",
      "baseFareChild": "Base fare per child",
      "baseFareInfant": "Base fare per infant",
      "totalTaxesAndFees": "Total taxes & fees",
      "adultsAmount_one": "{{count}} adult",
      "adultsAmount_other": "{{count}} adults",
      "childrenAmount_one": "{{count}} child",
      "childrenAmount_other": "{{count}} children",
      "infantsAmount_one": "{{count}} infant",
      "infantsAmount_other": "{{count}} infants"
    }
  },
  "stars_one": "{{count}} star",
  "stars_other": "{{count}} stars",
  "nights_one": "{{count}} Night",
  "nights_other": "{{count}} Nights",
  "nStarHotelRating": "{{numOfStars}}/5 stars",
  "priceForNightsWithTaxesAndFees_one": "{{price}} for {{count}} night taxes & fees incl.",
  "priceForNightsWithTaxesAndFees_other": "{{price}} for {{count}} nights taxes & fees incl.",
  "priceForNightsWithTaxesAndFees_checkout_title": "Hotel price",
  "priceForNightsWithTaxesAndFees_checkout_value": "({{price}} x {{count}} night(s))",
  "tripAdvisorReviewCount_one": "(1 review)",
  "pricePerNight": "{{price}} <span class=\"per-night\">per night</span>",
  "pricePerNightBeforeFees": "Price per night before fees and taxes",
  "reserveForPricePerNight": "Reserve for {{price}} per night",
  "tripAdvisorReviewCount_other": "({{count}} reviews)",
  "tripAdvisorReviewCountNoParentheses_other": "{{reviewsCount}} reviews",
  "tripAdvisorSummary_other": "<strong>{{average}}</strong> average - {{reviewsCount}} reviews",
  "tripAdvisorBadge": "{{scoreOneDecimalPlace}} of 5 bubbles",
  "customerReviews": "Customer Reviews",
  "guestReviews": "Guest Reviews",
  "recentGuestReviews": "Recent Guest Reviews",
  "moreReviews": "More reviews",
  "searchThisArea": "Search this area",
  "openGalleryButton": "See all photos",
  "mediaCategory": {
    "primary": "Primary",
    "lobby": "Lobby",
    "guestRoom": "Guest Room",
    "pool": "Pool",
    "fitness": "Fitness",
    "spa": "Spa",
    "sportsFacility": "SportsFacility",
    "amenity": "Amenity",
    "dining": "Dining",
    "bar": "Bar",
    "interior": "Interior",
    "exterior": "Exterior",
    "view": "View",
    "pointOfInterest": "Point Of Interest",
    "uncategorized": "Other",
    "allPhotos": "All photos",
    "allPhotosLowercase": "all photos"
  },
  "roomSelectionTitle": "Select Room",
  "chooseRoomButtonLabel": "Select room",
  "viewRoomsButtonLabel": "View rooms",
  "viewingCategory": "Viewing <strong>{{category}}</strong>",
  "hotelImageAltWithCategory": "Hotel view of {{category}}",
  "whereAreYouStaying": "Where are you staying?",
  "viewingHotels": "Viewing hotels",
  "searchingHotels": "Searching <b>hotels…</b>",
  "loadingMoreHotels": "Loading more hotels",
  "viewingHotelsInDestination": "Viewing hotels in <b>{{destination}}</b>",
  "hotelsIn": "Hotels in {{destination}}",
  "hotelsOnMap": "Hotels on map",
  "freeCancellation": "Free cancellation",
  "preferredHotel": "Hopper Picks",
  "priceForNights_one": "{{price}} for {{count}} night",
  "priceForNights_other": "{{price}} for {{count}} nights",
  "taxesAndFeesIncluded": "taxes & fees incl.",
  "Location": "Locations",
  "Market": "Markets",
  "Place": "Places",
  "room": "Room",
  "checkin": "Check-in",
  "checkout": "Check-out",
  "checkinTime": "Check-in after {{time}}",
  "checkoutTime": "Check-out before {{time}}",
  "checkinDateAtTime": "{{date}} at {{time}}",
  "hotelCalendarHeaderTitle": "Select the dates of your stay",
  "roomFitsGuests_one": "Room fits 1 guest",
  "roomFitsGuests_other": "Room fits {{count}} guests",
  "viewDetailsAndAmenities": "View Details and Amenities",
  "viewExtraAmenities_one": "View {{count}} amenity",
  "viewExtraAmenities_other": "View {{count}} amenities",
  "roomAmenities": "Room amenities",
  "roomDescription": "Room description",
  "noRoomDetails": "The hotel hasn't provided any others details about this room.",
  "continueRoomBooking": "Continue your booking with this room",
  "allFilters": "All filters",
  "filters": "Filters",
  "closeModal": "Close modal",
  "closeFiltersModal": "Close filters modal",
  "clearAllFilters": "Clear all filters",
  "applyAllFilters": "Apply filters",
  "userRating": "User rating",
  "starRating": "Star rating",
  "any": "Any",
  "veryGood": "Very good",
  "excellent": "Excellent",
  "starsAndUp": "{{stars}} stars and up",
  "price": "Price",
  "priceRange": "Price Range",
  "tripAdvisorBade": "TripAdvisor rating badge",
  "amenities": "Amenities",
  "about": "About",
  "reviews": "Reviews",
  "rooms": "Rooms",
  "includesAllSelectedAmenities": "Includes All Selected Amenities",
  "backToResults": "Back to results",
  "soldOut": "Sold out",
  "noAvailabilityForDates": "Unavailable for your dates",
  "emptyStateTitle": "There is no availability for this specific date range in this area.",
  "emptyStateDescription": "Please try adjusting filters to view available accommodations.",
  "emptyStateDescriptionSearch": "Please try adjusting your dates and/or location to view available accommodations",
  "hotelAmenities": "Hotel Amenities",
  "amenitiesHeader": "Amenities",
  "amenityIconAlt": "hotel amenity icon",
  "moreAmenities": "More Amenities ({{count}})",
  "aboutProperty": "About the property",
  "hotelMapImageAlt": "Static google map image of {{hotelName}}",
  "readMore": "Read more",
  "sortBy": "Sort by",
  "mostRecommended": "Most Recommended",
  "starRatingHighestFirst": "Star Rating (highest first)",
  "userRatingHighestFirst": "User Rating (highest first)",
  "priceLowestFirst": "Price (lowest first)",
  "tripReview": "Trip Review",
  "reviewTripBeforeBook": "Review your trip before you confirm and book.",
  "dueToday": "Due today",
  "earnHotelLoyalty": "Earn hotel loyalty",
  "pointsApplied": "Awards points applied",
  "totalAfterPoints": "Total after points",
  "total": "Total",
  "LodgingCfar": "Cancel for any reason",
  "paymentInformation": "Payment Information",
  "hotelSearchPage": {
    "travellersWarning": "You can search for up to 4 rooms",
    "searchSubtitle": "Search by country, city or hotel name",
    "selectHotels": "Select hotels",
    "selectAge": "Select age",
    "underOneAge": "Under 1"
  },
  "guestCount": {
    "childrenSubtitle": "Under 18",
    "adultSubtitle": "Age 18 or above",
    "roomsSubtitle": "Max 4",
    "childrenAgeMessage": "To ensure the most accurate rates, please enter the exact age of the children on this booking.",
    "childrenAgePlaceholder": "Child {{index}} age",
    "modalTitle": "Edit Travelers",
    "adultTitle": "Adults",
    "childrenTitle": "Children",
    "roomsTitle": "Rooms",
    "warningMessage_one": "You can search for up to {{count}} traveller",
    "warningMessage_other": "You can search for up to {{count}} travellers",
    "apply": "Apply"
  },
  "lodgingShopDetails": {
    "startingPrice": "Starting at {{priceWithSymbol}} per night for {{numberOfRooms}} room",
    "includingFees": "inc. taxes & fees",
    "totalPrice": "{{cashPriceWithSymbol}} for {{numberOfNights}} nights / <span id=\"point\">{{pointPrice}} points</span>",
    "perNightPrice": "<span class=\"cash\">{{priceWithSymbol}}</span> per night - {{numberOfRooms}} room",
    "continue": "Continue",
    "mobileMoreAmenities": "+ {{count}} more",
    "tripAdvisorSummary": "{{average}}/5 avg - {{reviewsCount}} reviews",
    "chooseCancellationPolicy": "Choose your cancellation policy",
    "selectOptionToContinue": "Select an option to continue"
  },
  "guestCountLabel": {
    "adultCount_one": "{{count}} adult",
    "adultCount_other": "{{count}} adults",
    "childCount_one": "{{count}} child",
    "childCount_other": "{{count}} children"
  },
  "searchHotels": "Search hotels",
  "noAvailableRoomsDescription": "This hotel is not available for the dates selected. Please try different dates.",
  "stays_one": "{{count}} stay",
  "stays_other": "{{count}} stays",
  "chooseAStarRating": "Choose a star rating",
  "chooseAUserRating": "Choose a user rating",
  "soldOutButtonLabel": "Sold out",
  "photoGallery": "Photo gallery",
  "roomPhotoGallery": "Picture {{currentIndex}} of {{count}}",
  "totalPricingPerNight_one": "Total for {{count}} night",
  "totalPricingPerNight_other": "Total for {{count}} nights",
  "hotelDetails": "Hotel details",
  "hotelDatesDescription": "{{fromDate}} - {{untilDate}}",
  "cancellationPolicyCopy": "Cancellation policy",
  "refundable": "Refundable",
  "nonrefundable": "Non-refundable",
  "loadingRoomsButtonLabel": "Loading rooms...",
  "pricePerNightLabel": "Price per night",
  "totalPriceLabel_one": "Total price for {{count}} night",
  "totalPriceLabel_other": "Total price for {{count}} nights",
  "guestCountLabel_one": "1 guest",
  "guestCountLabel_other": "{{count}} guests",
  "bookingDetails": "Booking details",
  "anytime": "Anytime",
  "roomDetails": "Room details",
  "cancellation": {
    "NonRefundable": {
      "primaryText": "Non-refundable",
      "secondaryText": "If you choose to change or cancel this booking you will not be refunded any of the payment."
    }
  },
  "hotelPriceChange": {
    "priceIncreaseTitle": "The price has increased by {{price}}",
    "priceDecreaseTitle": "The price has decreased by {{price}}",
    "priceDecreaseSubtitle": "You're in luck! Sometimes hotels change the prices unexpectedly. You can review the new total on the trip review page.",
    "priceIncreaseSubtitle": "Sometimes hotels change the prices unexpectedly. Sorry about that! You can review the new total on the trip review page.",
    "changeHotel": "Change hotel"
  },
  "showList": "Show List",
  "showMap": "Show Map",
  "core-hotels": {
    "funnelName": "Hotels",
    "search": {
      "startSearch": "Search for hotels",
      "location": {
        "label": "Where are you staying?"
      },
      "date": {
        "startDate": "Check-in",
        "endDate": "Check-out",
        "applyButton": "Done"
      },
      "guestPicker": {
        "buttonLabel_one": "1 Traveler",
        "buttonLabel_other": "{{count}} Travelers",
        "increaseGuestAmount": "Increase {{guestType}} amount",
        "decreaseGuestAmount": "Decrease {{guestType}} amount",
        "child": {
          "title": "Child",
          "subtitle": "Under 18",
          "selectPlaceHolder": "Select age",
          "childIndexLabel": "Child {{index}} age*",
          "underOneAge": "Under 1",
          "ageDialog": {
            "title": "Select age",
            "applyButton": "Done"
          }
        },
        "adult": {
          "title": "Adult",
          "subtitle": "Age 18 or above"
        },
        "rooms": {
          "title": "Rooms",
          "subtitle": "Max 10"
        },
        "applyButton": "Done",
        "modalTitle": "Guests"
      },
      "button": "Search",
      "summary_one": "{{fromDate}} - {{untilDate}}, {{count}} Traveler",
      "summary_other": "{{fromDate}} - {{untilDate}}, {{count}} Travelers"
    },
    "shop": {
      "title": "Hotel details",
      "amenities": {
        "title": "Amenities",
        "moreAmenities": "More amenities ({{count}})"
      },
      "hotelDescription": {
        "title": "About the property",
        "readMore": "Read more"
      },
      "customerReviews": {
        "title": "Customer Reviews",
        "averageRating": "{{averageRating}}",
        "reviewCount_one": "{{count}} review",
        "reviewCount_other": "{{count}} reviews",
        "moreReviews": "More reviews",
        "reviewInfo": "{{name}}, {{date}}"
      },
      "checkInPolicy": {
        "title": "Check-in policies",
        "readMore": "Read more"
      },
      "checkInInformation": {
        "title": "Check-in information",
        "checkinTitle": "Check-in:",
        "checkoutTitle": "Check-out:",
        "checkinTime": "Check-in after {{time}}",
        "checkinAnytime": "Check-in anytime",
        "checkoutTime": "Check-out before {{time}}"
      },
      "price": {
        "unavailable": "Hotel unavailable",
        "startingAt": "Starting at",
        "pricePerNight": "{{price}} per night",
        "priceForNightsWithTaxesAndFees_one": "{{price}} for {{count}} night taxes & fees incl.",
        "priceForNightsWithTaxesAndFees_other": "{{price}} for {{count}} nights taxes & fees incl.",
        "priceForNightsAndRoomsWithTaxesAndFees_one": "{{price}} for {{count}} night, {{roomCount}} room taxes & fees incl.",
        "priceForNightsAndRoomsWithTaxesAndFees_other": "{{price}} for {{count}} nights, {{roomCount}} rooms taxes & fees incl.",
        "roomCTA": "Choose room"
      }
    },
    "availabilityPage": {
      "title_one": "Viewing {{count}} hotel in {{location}}",
      "title_other": "Viewing {{count}} hotels in {{location}}",
      "results": {
        "hotelCard": {
          "carousel": {
            "next": "Next",
            "previous": "Previous"
          },
          "save": "Save {{amount}}%",
          "moreTags": "+{{count}} more",
          "tripAdvisorContent": {
            "reviews": "Reviews {{tripAdvisorReviewCount}}"
          },
          "price": {
            "pricePerNight": "{{price}} per night",
            "priceForNights_one": "{{price}} for {{count}} night",
            "priceForNights_other": "{{price}} for {{count}} nights",
            "numberOfRooms_one": "{{count}} room",
            "numberOfRooms_other": "{{count}} rooms",
            "taxesAndFeesIncluded": "Incl. taxes & fees"
          },
          "notAvailableLodging": "Not Available",
          "tryDifferentDates": "Try selecting different dates",
          "features": {
            "freeCancellation": "Free cancellation",
            "breakfastAvailable": "Breakfast available",
            "breakfastFree": "Free breakfast"
          },
          "rating": {
            "star": "{{count}}"
          }
        },
        "noResults": {
          "hotelUnavailable": "Hotel is unavailable for your dates",
          "noHotelsFound": "No hotels found",
          "changeDates": "Change dates",
          "filteredHotelsNotFound": "There are no hotels available for this filter set.",
          "noHotelsAvailable": "Please select new dates or try again."
        }
      },
      "filters": {
        "resetFilters": "Reset filters",
        "starRating": {
          "title": "Star rating"
        },
        "cancellation": {
          "title": "Cancellation",
          "description": "View hotels that include free cancellation policies"
        },
        "price": {
          "title": "Price",
          "subtitle": "Per night",
          "description": "Price per night"
        },
        "amenities": {
          "title": "Amenities",
          "description": ""
        },
        "payLater": {
          "title": "Pay later",
          "description": "View only hotels that allow you to pay at the property"
        },
        "hotelName": {
          "title": "Hotel Name",
          "label": "What hotel are you looking for?",
          "description": "Looking for a specific hotel? Enter the name of the hotel you'd like to stay at in this area."
        },
        "mealPlan": {
          "title": "Meal Plan",
          "description": "View only hotels with the selected meal plans",
          "kind": {
            "breakfast": "Free breakfast",
            "allInclusive": "All-inclusive",
            "breakfastFor1": "Breakfast for 1",
            "breakfastFor2": "Breakfast for 2",
            "dinner": "Dinner",
            "fullBoard": "Full board",
            "halfBoard": "Half board",
            "lunch": "Lunch",
            "roomOnly": "Room only"
          }
        },
        "userRating": {
          "title": "Customer Rating",
          "any": "Any",
          "veryGood": "Very Good",
          "excellent": "Excellent"
        }
      },
      "sort": {
        "dropDownLabel": "Sort:",
        "option": {
          "recommended": "Most Recommended",
          "recommendedShortened": "Recommended",
          "price": "Price (Low to High)",
          "priceShortened": "Price",
          "starRating": "Star Rating (Highest first)",
          "starRatingShortened": "Star Rating",
          "userRating": "User Rating (Highest first)",
          "userRatingShortened": "User Rating"
        }
      },
      "loadingScreen": {
        "title": "Searching for hotels",
        "subtitle": "Unlocking the best stays in the world's top destinations"
      },
      "shopModeButton": {
        "map": "Map",
        "list": "List"
      },
      "map": {
        "title": "Map"
      }
    },
    "roomSelection": {
      "title": "Choose your room",
      "roomFitsGuests_one": "Room fits {{count}} guest",
      "roomFitsGuests_other": "Room fits {{count}} guests",
      "viewDetails": "View details",
      "seeMoreDetails": "See more details",
      "chooseRooms": "Choose room",
      "roomDescriptionTitle": "Room description",
      "amenitiesTitle": "Room amenities",
      "benefitsTitle": "Room benefits",
      "roomDetailsTitle": "Room details",
      "refundable": "Refundable",
      "noAvailableRooms": {
        "title": "Uh oh, there are no rooms available for those dates.",
        "subtitle": "Please try again with different dates, or search for a new hotel."
      }
    },
    "mealPlan": {
      "title": "Meal Plan",
      "AllInclusive": "All meals included",
      "Breakfast": "Breakfast included",
      "BreakfastFor1": "Breakfast for 1 included",
      "BreakfastFor2": "Breakfast for 2 included",
      "Lunch": "Lunch included",
      "Dinner": "Dinner included",
      "HalfBoard": "Half board included",
      "FullBoard": "Full board included",
      "RoomOnly": "Room only"
    },
    "image": {
      "altWithCategory": "Hotel view of {{category}}",
      "altWithNoCategory": "Hotel view",
      "showAllImages": "Show all images",
      "imageGallery": {
        "title": "Viewing all photos - {{hotelName}}"
      }
    },
    "checkout": {
      "checkInTitle": "Check-in",
      "checkOutTitle": "Check-out",
      "numberOfGuests": "Number of guests",
      "confirmationPage": {
        "title": "Confirmed, your hotel is booked!",
        "email": "An email confirmation will be sent to {{email}}.",
        "confirmation": "Your confirmation is <0>#{{confirmationNumber}}</0>."
      },
      "cancellation": "Cancellation"
    },
    "postBooking": {
      "product": "Hotel",
      "summaryCard": {
        "location": "{{city}}, {{country}}",
        "dates": "{{fromDate}} - {{untilDate}}",
        "confirmation": "Confirmation: {{reservationId}}"
      },
      "reservation": {
        "dates": "{{checkInDate}} - {{checkOutDate}}",
        "checkInLabel": "Check-in",
        "checkOutLabel": "Check-out",
        "reservationDetails": {
          "title": "Reservation details",
          "roomTitle": "Room type",
          "numberOfGuestsTitle": "Number of guests",
          "primaryGuestTitle": "Primary guest",
          "confirmationTitle": "Confirmation",
          "checkInPolicyTitle": "Check-in Instructions"
        },
        "roomFitsGuests_one": "Room fits {{count}} guest",
        "roomFitsGuests_other": "Room fits {{count}} guests",
        "payment": {
          "title": "Payment details",
          "cta": "View payment breakdown"
        }
      }
    },
    "reservationState": {
      "CancellationFailure": "Cancelled",
      "Cancelled": "Cancelled",
      "Confirmed": "Confirmed",
      "Pending": "Pending"
    },
    "paymentBreakdown": {
      "label": {
        "hotel_one": "Price for {{count}} night",
        "hotel_other": "Price for {{count}} nights",
        "taxes": "Taxes and fees",
        "total": "Trip total",
        "payments": {
          "card": "Card"
        }
      }
    },
    "map": {
      "clusterLabel": "{{count}} stays",
      "searchThisArea": "Search this area"
    },
    "fintechMarketplace": {
      "title": "Customize your stay",
      "subtitle": "Treat yourself to a trip that suits your needs."
    },
    "breadcrumbs": {
      "availability": "Hotel results",
      "shop": "Hotel details",
      "book": "Book"
    },
    "lodgingCancellationPolicyModal": {
      "title": "Cancellation policy",
      "footer": "Times are based on the property’s local time.",
      "cancelButtonText": "Cancel"
    }
  },
  "core-hotels-price-freeze": {
    "priceFreeze": "Price Freeze™",
    "priceFreezeNoSymbol": "Price Freeze",
    "purchase": {
      "entryPointCTA": {
        "title": "Freeze price for {{price}}/night",
        "subtitle": "Book later when you're ready"
      },
      "hotelPriceFreezeOfferGeneralInfo": {
        "title": "Freeze this price",
        "ifPriceGoesUp": "<0>If the price goes up,</0> we'll cover the difference, up to {{hotelPriceFreezeCap}} total",
        "ifPriceGoesDown": "<0>If the price goes down,</0> you pay the lower price",
        "roomUnavailable": "<0>We'll give you a refund of the fee you pay today if there are no rooms available at your hotel.</0> <1 />Holding this price doesn’t reserve a room."
      },
      "hotelPriceFreezeOfferDurationSelector": {
        "title": "Select Price Freeze™ duration",
        "hoursLabel_one": "{{count}} hour",
        "hoursLabel_other": "{{count}} hours",
        "daysLabel_one": "1 day",
        "daysLabel_other": "{{count}} days",
        "expiry": "Return any time before <0>{{expiryDate}}</0> to complete your booking.",
        "returnWithin": "Return any time within {{duration}} to complete your booking."
      },
      "hotelPriceFreezePayment": {
        "title": "Review Price Freeze™ Payment",
        "hotelInfoTitle": "Price Freeze™ for {{duration}}"
      },
      "hotelPriceChange": {
        "increase": {
          "title": "Room price increased by {{price}}",
          "subtitle": "Hotels will sometimes change prices unexpectedly. Freeze this new price now for {{pricePerNight}}/night."
        },
        "decrease": {
          "title": "Room price decreased by {{price}}",
          "subtitle": "You scored an even better deal on this room! Freeze this new price now for {{pricePerNight}}/night."
        }
      },
      "hotelPriceFreezeConfirmation": {
        "title": "Price frozen for {{duration}}!",
        "confirmationEmail": "An email confirmation will be sent to {{email}}.",
        "charge": {
          "creditCardWithoutInfo": "A fee of {{price}} was charged to your credit card.",
          "creditCard": "A fee of {{price}} was charged to your {{cardType}} ending in {{last4}}.",
          "appleOrGooglePay": "A fee of {{price}} was charged to {{appleOrGooglePay}}.",
          "googlePay": {
            "label": "Google Pay"
          },
          "applePay": {
            "label": "Apple Pay"
          }
        },
        "FAQ": {
          "one": {
            "question": "Where can you find this Price Freeze™?",
            "answer": "In the Account section of the app under Bookings."
          },
          "two": {
            "question": "Need help?",
            "answer": "Contact support from our Help Center in app."
          }
        }
      },
      "checkoutContinue": {
        "priceBreakdown_one": "Due Today ({{price}} x {{count}} night)",
        "priceBreakdown_other": "Due Today ({{price}} x {{count}} nights)",
        "paymentContinueCard": "Freeze price"
      },
      "refundableRoomDisclaimer": "<0>Friendly reminder</0> • This is a fully refundable room, so you can book today and get a refund if you cancel until {{date}}. Or, proceed with Price Freeze according to the terms above."
    },
    "exercise": {
      "voucher-pill": {
        "active": "Active",
        "expired": "Expired",
        "exercised": "Exercised",
        "canceled": "Canceled",
        "pending": "Pending",
        "refunded": "Refunded"
      },
      "missionControl": {
        "title": "Your Hotel Price Freeze™",
        "reference": "Reference code: {{voucherId}}"
      },
      "expiry": "Price Freeze™ expiration: <0>{{expiryDate}}</0>",
      "reviewAndBook": "Review & book",
      "lineItem_one": "Price Freeze ({{price}} x {{count}} night)",
      "lineItem_other": "Price Freeze ({{price}} x {{count}} nights)",
      "frozenPriceCoverage": {
        "maximumSaved": "<0>{{amountSaved}} saved •</0> Prices have gone up. You hit the maximum coverage of {{amountSaved}} for the stay.",
        "saved": "<0>{{amountSaved}} saved •</0> You saved with Price Freeze™",
        "cheaper": "<0>{{amountSaved}} cheaper •</0> The current price is cheaper than your frozen price.",
        "default": "You were protected from price changes while you planned your trip!"
      }
    },
    "refund": {
      "title": "Sorry, that room is no longer available.",
      "subtitle": "If you wish to receive a refund, your price will no longer be frozen and the payment method you used to purchase the freeze will be refunded {{price}} in the next 5-10 business days.",
      "amount": "Amount refundable",
      "disclaimer": "Refunds are issued to the same payment method used for the original booking.",
      "button": "Refund Prize Freeze",
      "success": {
        "title": "Refund successful",
        "subtitle": "An email confirmation will be sent to {{email}}. <0>Your refund of {{price}} will be processed in 5-10 business days.</0>",
        "button": "Done"
      },
      "error": {
        "title": "Oops!",
        "subtitle": "Something went wrong, but we're not sure what. Please try again or contact support.",
        "button": "Try again"
      }
    },
    "checkout": {
      "lineItem": "Price Freeze™ discount"
    },
    "offerPanel": {
      "frozenPriceTitle": "Frozen price",
      "offerPriceTitle": "Price Freeze™ Fee",
      "currentPriceTitle": "Current price"
    },
    "pricePerNight": "{{price}} / night",
    "tripDetails": {
      "hotelTitle": "Price Freeze™ details",
      "title": "Trip cost",
      "totalNights_one": "{{count}} night ({{checkInDate}} - {{checkOutDate}})",
      "totalNights_other": "{{count}} nights ({{checkInDate}} - {{checkOutDate}})"
    },
    "dateRange": "{{checkInDate}} - {{checkOutDate}}",
    "hotelLocation": "{{city}}, {{country}}",
    "terms": {
      "termsLink": "View terms & conditions",
      "taxesAndFees": "Price Freeze™ does not include taxes and fees, they will be calculated at booking.",
      "priceFreezeFee": "The Price Freeze™ fee will not apply to the price of the room."
    },
    "priceIncludesTaxesAndFees": "incl. taxes & fees",
    "priceExcludesTaxesAndFees": "excl. taxes & fees"
  },
  "inCashBack": "{{amount}} <0>in cashback</0>",
  "core-cars": {
    "funnelName": "Cars",
    "car": "Car",
    "search": {
      "startSearch": "Search for cars",
      "pickup": "Pick-up location",
      "dropoff": "Drop-off location",
      "sameLocationLabel": "Drop-off at the same location",
      "differentLocationLabel": "Drop off at a different location",
      "dropoffSameLocation": "Same as pick-up",
      "searchPlaceholder": "Search by country, city, or street name",
      "pickupDate": "Pick-up date",
      "pickupTime": "Pick-up time",
      "dateApply": "Done",
      "dropoffDate": "Drop-off date",
      "dropoffTime": "Drop-off time",
      "driverAge": "Driver's age",
      "searchButton": "Search",
      "driverAgeValidation": "Driver must be at least 18 years old",
      "category": {
        "airports": "Airports",
        "cities": "Cities",
        "emptyMatch": "No matches found",
        "featuredGetaways": "Featured Getaways",
        "hotelMarkets": "Hotel Markets",
        "nearby": "Nearby Locations",
        "places": "Places",
        "recentSearches": "Recent Searches"
      },
      "driverAgeInfo": "Drivers must be <bold>over the age of 18</bold> to rent a car. Rental car companies may charge an underage driver fee at pick-up if the driver is <bold>under the age of 25</bold>.",
      "selectDates": "Select your pick-up and drop-off dates for your car rental",
      "continue": "Continue"
    },
    "availabilityPage": {
      "loadingScreen": {
        "title": "Searching for cars",
        "subtitle": "Unlocking the best car rentals in the world's top destinations"
      }
    },
    "postbooking": {
      "product": "Car",
      "changeCarHeading": "Change Car Reservation",
      "cancelCarHeading": "Cancel Car Reservation",
      "cancelCar": "Cancel reservation",
      "cancelBooking": "Cancel Booking",
      "confirmCancel": "Confirm Cancellation",
      "close": "Close",
      "tryAgain": "Try Again",
      "cancellationPending": "Cancellation Pending",
      "cancellationSuccessCopy": "A confirmation email will be sent shortly, and 'My Trips' will be updated within a few minutes.",
      "cancellationSuccessTitle": "Cancellation Complete",
      "loadingCarPolicy": "Loading car details and cancellation policy…",
      "processingCancellation": "Processing cancellation…",
      "contactSupportSubtitle": "To change this car booking, please contact our customer support team and someone will assist you.",
      "contactSupport": "Contact Support",
      "managedBySupplierHeading": "This booking is managed by the car rental company. To cancel this reservation, please contact the rental company directly.",
      "cancel": "Cancel",
      "done": "Done",
      "continueToProviderWebsite": "Continue to provider website",
      "backToTripsButton": "Back to My Trips",
      "somethingWentWrong": "Something went wrong",
      "pickUp": "Pick-up",
      "dropUp": "Drop-off"
    },
    "vehicleAttributes": {
      "bags_one": "{{count}} bag",
      "bags_other": "{{count}} bags",
      "passengers_one": "{{count}} passenger",
      "passengers_other": "{{count}} passengers",
      "transmission": {
        "automatic": "Automatic",
        "manual": "Manual"
      },
      "airConditioning": "Air conditioning",
      "mileage": {
        "unlimited": "Unlimited mileage"
      }
    },
    "pickup": {
      "airport": "Pick-up at airport",
      "shuttle": "Free airport shuttle to pick-up location",
      "meetAndGreet": "Meet and greet"
    },
    "distanceFromLocation": "<distance>{{distance}}</distance> away from {{location}}",
    "cancellation": {
      "free": "Free cancellation",
      "nonRefundable": "Non-refundable",
      "conditional": "Free cancellation until {{date}}",
      "steppedCancellation": "Flexible cancellation"
    },
    "cancellationPolicy": "Cancellation policy",
    "steppedCancellation": {
      "free": "Free cancellation available until {{date}}.",
      "nonRefundable": "Non-refundable.",
      "nonRefundableLast": "There will be no refund for cancellations made after that or no shows.",
      "flatFee": "Cancellations made until {{date}} are subject to a fee of {{amount}}.",
      "flatFeeFirst": "Cancellation available with fee of {{amount}} until {{date}}.",
      "numberOfDays": "Free cancellation for {{days}} days until {{date}}.",
      "percentageTotal": "Cancellations made until {{date}} are subject to a fee of {{percentage}} of the total price.",
      "combinedFeeOrTotal": "Cancellations made until {{date}} are subject to a fee of {{amount}} or the total reservation amount, whichever is lesser.",
      "combinedFeeOrPercentage": "Cancellations made until {{date}} are subject to a fee of {{amount}} or {{percentage}} of the total price, whichever is lesser.",
      "combinedFeeOrTotalAfter": "After that, cancellations are subject to a fee of {{amount}} or the total reservation amount, whichever is lesser, until {{date}}."
    },
    "totalPrice": "Total including taxes and fees",
    "vehicleClass": {
      "EV": "EV",
      "MiniCompact": "Mini/Compact",
      "Standard": "Standard",
      "Fullsize": "Fullsize",
      "PremiumLuxury": "Premium/Luxury",
      "MinivanWagon": "Minivan/Wagon",
      "SUVSpecialty": "SUV/Specialty",
      "Special": "Supplier's Choice"
    },
    "transmission": {
      "Automatic": "Automatic",
      "Cvt": "CVT",
      "Manual": "Manual"
    },
    "carCard": {
      "name": "<name>{{name}}</name> or similar",
      "orSimilar": "or similar",
      "select": "Select"
    },
    "totalPrice_one": "<price>{{price}}</price> <days>({{count}} day)</days>",
    "totalPrice_other": "<price>{{price}}</price> <days>({{count}} days)</days>",
    "locationCard": {
      "title": "Pick-up and drop-off location",
      "pickupTime": "Pick-up time: <time>{{time}}</time>",
      "dropoffTime": "Drop-off time: <time>{{time}}</time>",
      "locationDetailsLink": "Rental location details"
    },
    "availability": {
      "title_one": "Showing {{count}} rental car",
      "title_other": "Showing {{count}} rental cars",
      "subtitle": {
        "options": {
          "recommended": "Sorted by recommended",
          "price": "Sorted by best price first"
        }
      },
      "searchSummary": {
        "dates": "{{startDate}} - {{endDate}}"
      }
    },
    "filters": {
      "specifications": {
        "title": "Specifications",
        "options": {
          "airConditioning": "Air conditioning",
          "automaticTransmission": "Automatic transmission",
          "manualTransmission": "Manual transmission",
          "unlimitedMileage": "Unlimited mileage",
          "damageWaiver": "Collision damage waiver"
        }
      },
      "type": {
        "title": "Car type",
        "options": {
          "CompactCar": "Compact Car",
          "CompactSUV": "Compact SUV",
          "Convertible": "Convertible",
          "EconomyCar": "Economy Car",
          "EconomySUV": "Economy SUV",
          "Electric": "Electric",
          "FullSizeCar": "FullSize Car",
          "FullSizeSUV": "FullSize SUV",
          "Hybrid": "Hybrid",
          "LuxuryCar": "Luxury Car",
          "LuxurySUV": "Luxury SUV",
          "MidSizeCar": "MidSize Car",
          "MidSizeSUV": "MidSize SUV",
          "MiniCar": "Mini Car",
          "MinivanVan": "Minivan Van",
          "PickupTruck": "Pickup Truck",
          "PremiumCar": "Premium Car",
          "PremiumSUV": "Premium SUV",
          "RecreationalVehicle": "Recreational Vehicle",
          "SportsCar": "Sports Car",
          "StandardCar": "Standard Car",
          "StandardSUV": "Standard SUV",
          "MysteryCar": "Mystery Car"
        }
      },
      "cancellation": {
        "title": "Cancellation",
        "description": "View rental cars that include free cancellation policies."
      },
      "rentalCompany": {
        "title": "Rental company"
      },
      "minimumBags": {
        "title": "Number of bags",
        "options": {
          "bags_zero": "Any number of bags",
          "bags_other": "{{count}} or more bags"
        }
      },
      "passengers": {
        "title": "Passengers",
        "options": {
          "upToFive": "2 to 5 passengers",
          "sixOrMore": "6 or more passengers"
        }
      },
      "price": {
        "title": "Price"
      }
    },
    "noCarsFound": "No cars found",
    "filteredCarsNotFound": "There are no cars available for this filter set.",
    "shopPage": {
      "cancellationPolicy": {
        "title": "Cancellation policy",
        "Conditional": "Conditional",
        "ConditionalAfterBooking": "Conditional after booking",
        "Free": "Free cancellation",
        "NonRefundable": "Non refundable",
        "Paid": "Cancellation fee applies",
        "SteppedCancellationRule": "Stepped cancellation"
      }
    },
    "priceBreakdown": {
      "baseFare": "Base fare",
      "taxesAndFees": "Taxes and fees",
      "total": "Total",
      "payNow": "Pay now",
      "payAtDesk": "Pay at the desk",
      "payAtDeskInfo": "The rental car agency will charge the amount due at pick-up in local currency."
    },
    "checkout": {
      "carCard": {
        "pickupDate": "<label>Pick-up date:</label> <date>{{date}}</date>",
        "dropoffDate": "<label>Drop-off date:</label> <date>{{date}}</date>"
      },
      "completeCarRentalBooking": "Complete car rental booking"
    },
    "bookingConfirmation": {
      "title": "Confirmed, your car is booked!",
      "subtitle": "An email confirmation will be sent to {{email}}",
      "confirmationId": "Your booking confirmation is #{{id}}"
    },
    "breadcrumbs": {
      "availability": "Choose Car",
      "shop": "Extras",
      "book": "Book"
    }
  },
  "modalClose": {
    "label": "Close",
    "ariaLabel": "Close button icon"
  },
  "mixedCabin": {
    "tooltip": "You will not be seated in the same fare class across all of your connecting flights. Airlines may choose to put you in a different fare class for shorter connecting flights due to pricing and availability in order to give you the best price possible.",
    "icon": "Mixed cabin"
  },
  "viewRoomAmenities": "View Room Amenities",
  "noOptions": "No options",
  "changeFee": "Change Fee",
  "frozenBaseFare": "Frozen Base Fare",
  "endingInWithLastFour": "Ending in {{lastFour}}",
  "appliedWithAccountName": "{{accountName}} applied",
  "addNewTraveler": "Add New Traveler",
  "newTravelerTitle": "New traveler",
  "addNewPassenger": "Add another passenger",
  "enterAValidBirthDate": "Enter a valid birthdate",
  "enterAValidExpiry": "Enter a valid expiry date",
  "passportExpires": "Expiry date of passport must be more than 90 days following the arrival date",
  "firstName": "First name",
  "middleNameOptional": "Middle name (if applicable)",
  "middleName": "Middle name",
  "lastName": "Last name",
  "birthDate": "Birthdate",
  "birthDateWithDateFormat": "Birthdate {{format}}",
  "dateOfBirth": "Date of Birth",
  "nationality": "Nationality",
  "passportInformation": "Passport Information",
  "countryOfIssue": "Country of Issue",
  "passportNumber": "Passport #",
  "expiration": "Expiration (yyyy-mm-dd)",
  "saveTraveler": "Save Traveler",
  "savePassenger": "Save passenger",
  "saveChanges": "Save changes",
  "emptyLineItems": "Select a traveler to show a more accurate price breakdown",
  "flightChangeIn": "Flight change in {{location}}",
  "selectSeat": "Select Seat",
  "editSeat_one": "Edit Seat",
  "editSeat_other": "Edit Seats",
  "seatSelectionUnavailableMobile": "Selection Unavailable",
  "seatSelectionUnavailable": "Seat Selection Unavailable",
  "seatUnavailableDetail": "Seat selection is currently unavailable for this segment of your journey.",
  "seatNotSelectedMobile": "Not Selected",
  "seatNotSelected": "Seat Not Selected",
  "noSeatSelected": "No seats selected yet",
  "seatNotSelectedDetail": "You have not selected seats for this passenger and flight. Edit your selection to add seats to your journey.",
  "continueFor": "Continue for {{price}}",
  "showMore": "Show more",
  "showLess": "Show less",
  "totalPerTraveler": "Total, per traveler",
  "maintenanceTitle": "Service is currently unavailable",
  "maintenanceSubtitle": "Please try again later.",
  "core-ui": {
    "filters": {
      "dialog": {
        "openerLabel": "All filters",
        "title": "Filters",
        "clear": "Clear all",
        "apply": "Apply filters"
      },
      "price": {
        "title": "Price",
        "min": "Min",
        "max": "Max",
        "description": "Set the price range"
      }
    }
  },
  "accountTitle": "Apply $t(brand:merchantPayments)",
  "accountSubtitle": "Only the balance from your main $t(brand:merchantPayments) can be applied per transaction.",
  "addCard": "Add a card",
  "addAdditionalPaymentMethodCTA": "Add another payment method",
  "addFundsLink": "Add funds now",
  "noBalanceAccessNotification": "We are unable to confirm your balance right now. Please try again later.",
  "noBalancePermissionsNotification": "We cannot confirm your $t(brand:merchantPayments) balance will cover the total. Remember to validate that you have enough money for the ticket in your available balance.",
  "addFundsNotification": "Your balance is not enough to book your ticket 😞 You are {{owing}} short.  You must recharge your $t(brand:merchantPayments) to be able to make the purchase.",
  "addFundsNotificationPlusCredit": "You are missing {{owing}} for your flight. Recharge your $t(brand:merchantPayments) account or add a card for the balance.",
  "addPaymentAgain": "Please add your payment method again",
  "addPaymentFormHeader": "<p>Add your {{cardName}} credit card</p>",
  "addPaymentMethodCTAMultipleAccounts": "Add a valid credit or debit card",
  "addPaymentMethodModalTitle": "Add a credit card",
  "allAccountsDoNotMeetMinimumRequirement": "Your $t(brand:clientName) account does not meet the minimum redemption amount. To continue with this booking, please use your a Credit Card to complete this transaction.",
  "hotelBackToDetailsCTA": "Back to hotel details",
  "backToCardSelectionCTA": "Back to card selection",
  "cardEndingIn": "Card ending in {{last4}}",
  "desktopPaymentStepTitle": "Step 2: Payment",
  "editPaymentMethod": "Edit Payment Method",
  "emptyBalance": "Your $t(brand:clientName) balance is empty",
  "invalidCreditCardSubtitle": "Ensure you are using an valid credit card.",
  "invalidCreditCardTitle": "It looks like you're trying to add an invalid credit card.",
  "oneAccountDoesNotMeetMinimumRequirement": "One of your $t(brand:clientName) accounts does not meet the minimum redemption amount.",
  "paymentAfterSeatSelectionTitle": "Step 3: Payment",
  "paymentMethodDescription": "If you don't have enough money in your $t(brand:merchantPayments) account, you can pay the remaining balance with a credit card",
  "paymentMethodSubtitle": "Add a credit card to pay your remaining balance",
  "paymentMethodSubtitleAmount": "Amount due",
  "paymentMethodSubtitlePaymentSecure": "Payments on Hopper are 100% secure.",
  "paymentMethodTitle": "Payment Method",
  "step3RewardsAndPayment": "Step 3: Rewards and payment",
  "paymentMethodReviewSubtitle": "View or edit your chosen payment method",
  "paymentStepSubtitle": {
    "splitpay": "Pay using your $t(brand:merchantPayments), a credit or debit card, or a combination of both!",
    "creditCard": "Pay using a valid credit or debit card.",
    "merchantPay": "Pay using your $t(brand:merchantPayments)!"
  },
  "paymentStepTitle": "Payment",
  "rewardsAndPaymentStepTitle": "Rewards and payment",
  "passenger": "Passenger",
  "passengers": "Passengers",
  "passengersCounterTitles": {
    "modalTitle": "Travelers",
    "adultTitle": "Adults",
    "adultSubtitle": "",
    "childrenTitle": "Children",
    "childrenSubtitle": "Ages 2-11",
    "infantSeatTitle": "Infants in seat",
    "infantSeatSubtitle": "Under the age of 2",
    "infantLapTitle": "Infants on lap",
    "infantLapSubtitle": "Under the age of 2"
  },
  "passengersCounterCta": "Change",
  "singleAccountAddCardCTA": "Add your credit card",
  "splitPayApply": "Applying",
  "splitPayApplyBalance": "Apply $t(brand:merchantPayments) balance",
  "splitPayCancel": "Cancel",
  "splitPayCoversTotalCostNotification": "Your $t(brand:merchantPayments) balance covers the total cost of your booking.",
  "splitPayCustomAmountTooHigh": "Invalid amount. Enter an amount that is lower then your available balance.",
  "splitPayCustomAmountGenericError": "Invalid Pocket balance. Please enter a valid amount.",
  "splitPayDoNotApply": "Do not apply my $t(brand:merchantPayments) balance",
  "splitPayEdit": "Edit Amount",
  "save": "Save",
  "applyBalance": "Apply Balance",
  "splitPaySaveNotification": "To apply this amount, Save before you continue.",
  "pleaseTryAgain": "Please try again.",
  "pleaseGoBackTryAgain": "Please go back to the previous step and try again.",
  "unableToListPayment": "We are unable to retrieve your payment methods",
  "unableToAddPayment": "We are unable to add your payment method",
  "unableToDeletePayment": "We are unable to delete your payment method",
  "deletePaymentAgain": "Please try deleting the payment method again",
  "unableToGetBalance": "We are unable to access your $t(brand:merchantPayments) account right now",
  "passengerInformation": {
    "title": "Step 1. Add Travelers",
    "travelerDetailsTitle": "Traveler Details",
    "subtitle": "Make sure the information you add matches each traveler's ID. You can't change this information once you add a traveler.",
    "passengerSubtitle": "Make sure the information you add matches each passenger's ID. You can't change this information once you add a passenger.",
    "passengerSelectSubtitle": "Please select the traveler(s).",
    "noPassengerSelectSubtitle": "Please add your passenger information for the airline. Make sure the information you add matches each passenger's ID.",
    "lodgingSubtitle": "Enter the name of the traveler that the reservation will be made under.",
    "frequentFlyerTitle": "Frequent Flyer Details",
    "addTravelerInfoText": "Add Traveler Information",
    "addPassengerInfoText": "Add passenger information",
    "editPassengerInfoText": "Edit passenger information",
    "additionalInfo": "Additional Information",
    "adult": "Adult",
    "child": "Child",
    "infant": "Infant",
    "adultsTitle": "Adult",
    "childrenTitle": "Children (aged 2 -11)",
    "infantsTitle": "Infant (under the age of 2)",
    "updatingPassengers": "Updating Passengers",
    "validatingPassengers": "Validating Passengers",
    "addTravelers": "Add Travelers",
    "addTraveler": "Add Traveler",
    "addPassengers": "Add passengers",
    "addPassenger": "Add passenger",
    "step1AddTravelers": "Step 1: Add Travelers",
    "selectOrAddTravelers": "Select or add travelers",
    "guests": "Guests",
    "guestCount_one": "{{count}} guest",
    "guestCount_other": "{{count}} guests",
    "adultCount_one": "{{count}} adult",
    "adultCount_other": "{{count}} adults",
    "childCount_one": "{{count}} child",
    "childCount_other": "{{count}} children",
    "yearsOld": "{{age}} years old"
  },
  "infantModal": {
    "title": "Infant Onboard",
    "subtitle": "Please select a seat type",
    "onLap": "On lap",
    "ownSeat": "Own seat",
    "perInfantDescription": "per infant, round-trip",
    "freeDescription": "Free, no additional cost",
    "continue": "Continue",
    "loading": "Validating travelers"
  },
  "merchantBalance": "Your current balance in $t(brand:merchantPayments) is",
  "checkoutWarning": {
    "selectedPassengersPriceChangeSubtitle": "Price has been updated to reflect passenger changes.",
    "searchPassengerNumDifferentFromSearch": {
      "title": "You didn’t select the number of passengers you originally searched for.",
      "subtitle": "Are you sure you want to continue with the currently selected passengers?"
    }
  },
  "checkoutError": {
    "acknowlegement": "OK",
    "invalidPassenger": "Invalid Passengers",
    "invalidPassengerSubtitle": "It looks like your information is incorrect. Please go back and confirm all of your traveler information is correct.",
    "infantOnlySubtitle": "Lap infants must be accompanied by at least one adult",
    "noPassengersSubtitle": "No passengers have been selected",
    "genericErrorTitle": "There was an error.",
    "updateTraveler": "Update Travelers",
    "updateContactInformation": "Update Contact Information",
    "genericErrorSubtitle": "There was an error, please try again or reload the page.",
    "checkInMinimumAgeNotMetTitle": "Invalid Passengers",
    "checkInMinimumAgeNotMetSubtitle": "Minors must be accompanied by at least one adult.",
    "paymentFailedTitle": "Payment failed",
    "paymentFailedSubtitle": "Try again, or use a different card or method.",
    "rewardsPaymentFailedTitle": "Rewards payment failed",
    "rewardsPaymentFailedSubtitle": "Try again, or use a different rewards account or payment method.",
    "duplicateBookingTitle": "Duplicate Booking Attempt",
    "duplicateBookingSubtitle": "Your first booking was successful! Please check your email for your booking confirmation. Contact our support if you have any additional questions. ",
    "expiringPassportTitle": "Passenger Validation",
    "expiringPassportSubtitle": "Your passport expiration is too close to the departure date and is not valid for this flight.",
    "expiredPassportTitle": "Passenger Validation",
    "expiredPassportSubtitle": "Your passport has an expired expiration date. Ensure all information matches your Travel ID and is up to date. ",
    "genericCardError": "Oops! It looks there is something wrong with your card at the moment. Please try again in a few hours.",
    "illegalLapInfantKTNTitle": "Invalid Passenger",
    "illegalLapInfantKTNSubtitle": "It looks like you've added a known traveler number for a lap infant, but lap infants cannot have known traveler numbers.",
    "illegalLapInfantRedressTitle": "Invalid Passenger",
    "illegalLapInfantRedressSubtitle": "It looks like you've added a redress number for a lap infant, but lap infants cannot have redress numbers.",
    "invalidPassportNumberTitle": "Passenger Validation Error",
    "invalidPassportNumberSubtitle": "Your passport number is not valid. Ensure all information matches your Travel ID and is up to date",
    "lapInfantsUnsupportedTitle": "Invalid Passenger",
    "lapInfantsUnsupportedSubtitle": "Lap infants are not supported on this flight. Please go back and select a seated infant to continue with the purchase. ",
    "onlyLapInfantsSupportedTitle": "Infant Onboard",
    "onlyLapInfantsSupportedSubTitle": "Only lap infants are allowed on this flight.",
    "malformedKnownTravelerNumberTitle": "Passenger Validation Error",
    "malformedKnownTravelerNumberSubtitle": "Your known traveler number format is incorrect. Please ensure that your information matches your correct known traveler number. ",
    "malformedRedressNumberTitle": "Passenger Validation Error",
    "malformedRedressNumberSubtitle": "Your redress number format is incorrect. Please ensure that your information matches your correct known traveler number. ",
    "missingAirlineLocatorTitle": "Unable to complete your booking",
    "missingAirlineLocatorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "missingPassportTitle": "Passenger Validation",
    "missingPassportSubtitle": "Enter Passport details for all passengers. Ensure all information matches your Travel ID. ",
    "missingPassportNumberTitle": "Passenger Validation",
    "missingPassportNumberSubtitle": "Enter Passport details for all passengers. Ensure all information matches your Travel ID. ",
    "missingPassportOrNationalIdTitle": "Passenger Validation",
    "missingPassportOrNationalIdSubtitle": "Enter Passport or National ID details for all travelers. Ensure all information matches their Travel IDs. ",
    "noAdultPassengerTitle": "Invalid Passengers",
    "noAdultPassengerSubtitle": "Minors must be accompanied by at least one adult",
    "notEnoughBalance": "Oops! It looks like there may be insufficient balance to complete this transaction.",
    "providerErrorTitle": "Unable to complete your booking",
    "providerErrorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "seatedInfantsUnsupportedTitle": "Invalid Passenger",
    "seatedInfantsUnsupportedSubtitle": "Seated infants are not supported on this flight. Please go back and select a lap infant to continue with the purchase. ",
    "ticketingNotStartedTitle": "Your booking is pending",
    "ticketingNotStartedSubtitle": "Hang tight, we're talking with the airline and will be sending you a confirmation email soon. If you don't hear from us within 3 days, please reach out to our support team.",
    "ticketingUnconfirmedTitle": "Your booking is pending",
    "ticketingUnconfirmedSubtitle": "Hang tight, we're talking with the airline and will be sending you a confirmation email soon. If you don't hear from us within 3 days, please reach out to our support team.",
    "ticketingUnknownTitle": "Your booking is pending",
    "ticketingUnknownSubtitle": "Hang tight, we're talking with the airline and will be sending you a confirmation email soon. If you don't hear from us within 3 days, please reach out to our support team.",
    "tooManyLapInfantsTitle": "Invalid Passengers",
    "tooManyLapInfantsSubtitle": "There are too many lap infants. Please make sure you have an adult passenger for every lap infant.  ",
    "tooManyPassengersTitle": "Too Many Passengers",
    "tooManyPassengersSubtitle": "Oops! The airline only allows you to book 6 passengers in a single reservation. Please go back and make separate reservations if you have more than 6 passengers. ",
    "transientServiceErrorTitle": "Unable to complete your booking",
    "transientServiceErrorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "unknownSabreAppErrorTitle": "Unable to complete your booking",
    "unknownSabreAppErrorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "noAvailabilityTitle": "No Availability",
    "noAvailabilitySubtitle": "Unfortunately we can no longer find any availability for this flight(s). Please select a new flight or try again.",
    "inActivityTitle": "Oops! Your session timed out. Please login again.",
    "inActivitySubtitle": "Oops! Your session timed out. Please login again.",
    "maintenanceTitle": "Sorry, our system is in maintenance",
    "maintenanceSubtitle": "Please try again later.",
    "flightsInActivityTitle": "These prices may have changed.",
    "flightsInActivitySubtitle": "It's been a few minutes since we last checked this price. Please search again for the most up to date prices.",
    "expiredFulfillTokenTitle": "Unable to complete your booking",
    "expiredFulfillTokenSubtitle": "Unfortunately we can no longer find any availability for this flight(s). Please select a new flight or try again.",
    "invalidSessionTitle": "Oops! Your session timed out. Please login again.",
    "invalidSessionSubtitle": "Oops! Your session timed out. Please login again.",
    "paymentErrorTitle": "Oh no, we were unable to process your payment",
    "paymentErrorSubtitle": "Your payment didn't go through. Please confirm your payment details and try again",
    "productErrorTitle": "Unable to complete your booking",
    "productErrorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "unavailableQuoteTitle": "The price has changed for your flight.",
    "unavailableQuoteSubtitle": "The price has changed for your flight. ",
    "closedSessionTitle": "Oops! Your session timed out. Please login again.",
    "closedSessionSubtitle": "Oops! Your session timed out. Please login again.",
    "serviceErrorTitle": "Unable to complete your booking",
    "serviceErrorSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "fulfillFailureTitle": "Unable to complete your booking",
    "fulfillFailureSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support. ",
    "authorizeFailureTitle": "Oh no, we were unable to process your payment",
    "authorizeFailureSubtitle": "Your payment didn't go through. Please confirm your payment details and try again",
    "captureFailureTitle": "Oh no, we were unable to process your payment",
    "captureFailureSubtitle": "Your payment didn't go through. Please confirm your payment details and try again",
    "fraudFailureTitle": "Oh no, we were unable to process your payment",
    "fraudFailureSubtitle": "Your card was declined, please contact your bank to confirm that your card is valid and then try again.",
    "invalidCustomerTitle": "Invalid Passengers",
    "invalidCustomerSubtitle": "It looks like your information is incorrect. Please go back and confirm all of your passenger information is correct.",
    "invalidPassengersTitle": "Invalid Passengers",
    "invalidPassengersSubtitle": "It looks like your information is incorrect. Please go back and confirm all of your passenger information is correct.",
    "invalidPassengerName": "Please enter valid alphabetic name as per your passport or id proof.",
    "lapInfantTooOldTitle": "Invalid Passengers",
    "lapInfantTooOldSubtitle": "This passenger is too old to sit on a lap. Please go back and select a seated infant or child. ",
    "missingNationalityTitle": "Invalid Passengers",
    "missingNationalitySubtitle": "It looks like we're missing your nationality. Please go back and add your country of citizenship in your passenger information.",
    "noContactInformationTitle": "Missing Contact Information",
    "noContactInformationSubtitle": "We're missing your contact information in case we need to notify you about changes to your booking. Please fill out your phone number and your email address. ",
    "noTicketlessResponseTitle": "Unable to complete your booking",
    "noTicketlessResponseSubtitle": "We tried to complete your booking, but encountered a technical error on our end. Please try making the booking again. If the issue keeps happening, contact customer support.",
    "upgradeRequiredTitle": "Upgrade is required",
    "upgradeRequiredSubtitle": "You can't book two different fare classes for this trip. Please go back and select the same fare level for both legs of your journey.",
    "maximumPriceIncreaseTitle": "The price changed for your flight",
    "maximumPriceIncreaseSubtitle": "It looks like the airline changed the price of the flight you were looking at. Please reselect your flight to confirm the price change or choose another one. ",
    "searchAgain": "Search Again",
    "updatePayment": "Update Payment",
    "invalidPhoneNumber": "Invalid Phone Number",
    "invalidPhoneNumberSubtitle": "Please enter a valid phone number",
    "tryAgain": "Try again",
    "findNewFlight": "Find a new flight",
    "searchPassengerNumNotReachedTitle": "Number of passengers not reached",
    "searchPassengerNumNotReachedSubtitle": "You didn’t select the number of passengers you originally searched for. Are you sure you want to continue with the currently selected passengers?",
    "searchPassengerNumNotReachedCta": "Yes, continue",
    "passengerNameTooShortSubtitle": "Passenger name should be at least 2 characters without spaces.",
    "unsupportedNameCharactersSubtitle": "Name contains an unsupported special character. Please remove the special character and try again.",
    "passengerValidationTitle": "Passenger Validation",
    "missingNationalIdSubtitle": "Enter Passport or National ID details for all travelers. Ensure all information matches their Travel IDs.",
    "unexpectedPassengersSubtitle": "You tried to book a flight for more passengers than the initial search, and the offer is no longer available. Please search again.",
    "genericErrorRetrySubtitle": "There was an error, please try again.",
    "oopsSomethingWrongTitle": "Oops, something went wrong",
    "pleaseSearchAgainSubtitle": "Please search again",
    "findNewHotel": "Find a new hotel",
    "findNewCar": "Find a new car",
    "hotelPaymentFailedTitle": "Payment failed",
    "hotelPaymentFailedSubtitle": "Try again, or use a different card or method.",
    "hotelInvalidQuoteTitle": "Room rate has timed out",
    "hotelInvalidQuoteSubtitle": "Search again to see if this room and rate are still available.",
    "hotelRateNotAvailableTitle": "We can no longer find any availability for this room",
    "hotelRateNotAvailableSubtitle": "Please select a new room or try again.",
    "hotelLackOfInventoryTitle": "Room no longer available",
    "hotelLackOfInventorySubtitle": "Someone just booked this one, but there are other great rooms available.",
    "hotelCheckInMinimumAgeNotMetTitle": "Age requirement for check-in",
    "hotelCheckInMinimumAgeNotMetSubtitle": "The traveler checking in to this hotel does not meet the minimum age requirement.",
    "driverAgeNotMetTitle": "Driver age requirement for rental",
    "driverNotMetSubtitle": "The driver booking this car does not meet the minimum age requirement.",
    "invalidLoyaltyNumberTitle": "Invalid loyalty number",
    "invalidLoyaltyNumberSubtitle": "The loyalty number attached to the selected traveler is invalid.",
    "carRateNotAvailableTitle": "We can no longer find any availability for this car",
    "carRateNotAvailableSubtitle": "Please select a new car or try again.",
    "selectAnotherRoom": "Select another room",
    "expiredNationalIdTitle": "Invalid Passengers",
    "expiredNationalIdSubtitle": "Your national ID has expired. Ensure all information matches your Travel ID and is up to date.",
    "expiringNationalIdTitle": "Invalid Passengers",
    "expiringNationalIdSubtitle": "Your national ID expiration is too close to the departure date and is not valid for this flight.",
    "duplicatedPassportTitle": "Invalid Passengers",
    "duplicatedPassportSubtitle": "It looks like your passport information is incorrect. Please go back and confirm all of your traveler information is correct.",
    "duplicatedNationalIdTitle": "Invalid Passengers",
    "duplicatedNationalIdSubtitle": "National ID must be unique for all selected passengers.",
    "passengerInformation": {
      "updatePassengerTitle": "We are unable to update your traveler",
      "fetchPassengersTitle": "We are unable to retrieve your travelers",
      "deletePassengerTitle": "We are unable to delete your traveler"
    }
  },
  "savingTraveler": "Saving passenger and checking availability",
  "checkingAvailability": "Checking availability",
  "bookingFlight": "Booking your flight",
  "bookingHotel": "Booking hotel",
  "flightSliceDescription": "to {{location}} on {{date}}",
  "checkoutBreakdown": "Checkout Breakdown",
  "offers": "Offers",
  "offerAppliedWithAmount": "Offer applied - {{amount}} off limited up to {{limit}}",
  "offerPercentageOff": "({{amount}} off)",
  "bookingConfirmation": {
    "banner": "Confirmed, your flight is booked!",
    "title": "An email confirmation will be sent to {{email}}",
    "subtitle": "Your booking confirmation is #{{id}}",
    "whatsNext": "What's next?",
    "documentTitle": "Booking Confirmation",
    "youAlsoPurchasedHeader": "You also purchased",
    "seatsTitle": "Seat selection",
    "seatsSubtitle": "You booked seats ahead for your journey. A detailed confirmation will be sent to you by email.",
    "flightPriceMonitoring": "The price of this flight will be monitored for the next {{duration}} days with",
    "airCfarTitle": "Cancel For Any Reason",
    "airCfarSubtitle": "You added Cancel For Any Reason. A detailed confirmation will be sent to you by email.",
    "airChfarTitle": "Change for any reason",
    "airChfarSubtitle": "You added Change for any reason. A detailed confirmation will be sent to you by email.",
    "disruptionProtectionTitle": "Premium Disruption Assistance",
    "disruptionProtectionSubtitle": "Quickly rebook a delayed or canceled flight, or get a refund if you are not happy with the rebooking options.",
    "disruptionScheduleChangeTitle": "Flight delay guarantee",
    "disruptionScheduleChangeSubtitle": "You added flight delay guarantee. A detailed confirmation will be sent to you by email.",
    "disruptionMissedConnectionTitle": "Missed connection protection",
    "disruptionMissedConnectionSubtitle": "You added missed connection protection. A detailed confirmation will be sent to you by email.",
    "status": "Confirmation #{{id}}"
  },
  "passportInfo": {
    "passport": "Passport",
    "title": "Passenger Validation ({{currentIndex}} of {{total}})",
    "subtitle": "Enter Passport details for all travelers. Ensure all information matches your Travel ID.",
    "saveTraveler": "Saving traveler details"
  },
  "editTraveler": "Edit Traveler",
  "removeTraveler": "Remove Traveler",
  "passengerContactHelper": "You must add at least one traveler and enter your contact information to continue.",
  "contactInformation": "Contact Information",
  "reviewContactInformation": "Contact details",
  "reviewContactInfoSubtitle": "This information is used to notify you about any updates or changes to your trip.",
  "contactInfoSubtitle": "This information is used to notify you about any updates or changes to your trip.",
  "contactInfoEmailError": "Enter a valid email address",
  "contactInfoPhoneError": "Enter a valid phone number",
  "tripReviewSubtitle": "Review your details before you confirm and book.",
  "travelerInformation": "Traveler Information",
  "passengerInformationTitle": "Passenger information",
  "travelerInformationSubtitle": "Make sure the information you add matches each traveler's ID. You can't change this information once you add a traveler.",
  "passengerInformationSubtitle": "Name corrections are not permitted after booking. Be sure your passenger details match your travel ID.",
  "confirmAndBook": "Confirm and Book",
  "continueToPayment": "Continue to payment",
  "reviewMyTrip": "Review my trip",
  "itinerary": "Itinerary",
  "paymentForm": {
    "invalidCardError": "Invalid Card Number",
    "invalidCVV": "Invalid CVV",
    "cardNumber": "Card Number",
    "cardNumberPlaceholder": "Card Number",
    "nameOnCard": "Name on Card",
    "nameOnCardPlaceholder": "Name on Card",
    "expiryDate": "Expiry Date",
    "cvv": "CVV",
    "cvvPlaceholder": "CVV",
    "zipCodePlaceholder": "Zip Code",
    "country": "Country",
    "countrySelectPlaceholder": "Select country",
    "zipCode": "Zip Code",
    "addingPaymentMethod": "Adding your payment method",
    "removingPaymentMethod": "Removing your payment method",
    "loadingPaymentMethod": "Loading your payment method",
    "amountEditButtonSrOnlyText": "Amount edit button added just after this radio button",
    "save": "Save",
    "close": "Close"
  },
  "zipErrorInvalid": "Given postal code is invalid",
  "zipErrorRequired": "$t(requiredField)",
  "zipErrorInvalidUS": "Zip code must contain 5 digits.",
  "zipErrorInvalidCA": "Postal code must be in A0A0A0 format.",
  "zipErrorInvalidCO": "Zip code must contain 6 digits.",
  "expiryDateRequired": "$t(requiredField)",
  "expiryDateInvalid": "Invalid expiry date format",
  "expiryDateInvalidDate": "Given expiry date is invalid.",
  "expiryDateIsBefore": "Expired card is not accepted.",
  "enterAllRequiredFields": "Enter all required fields",
  "notAvailable": "Not available",
  "bookingSuccess": {
    "title": "Successful Booking",
    "subtitle": "Find confirmation details below"
  },
  "seats": {
    "seatMap": {
      "legend": "Seat legend"
    },
    "unavailableWarning": "Seat selection is currently unavailable for your journey.",
    "chooseSeats": "Choose Seats",
    "iframeTitle": "seat map popup",
    "subtitle": "Book seats ahead for your journey.",
    "buttonText": "Select Your Seats",
    "skipSeatsSubtitle": "Skip seats, seats will be assigned at check-in.",
    "freeCheapestString": "<strong>Free</strong> seat selection",
    "cheapestSeatPerTraveler": "Starting from <strong>{{price}}</strong> per traveler",
    "totalSeatPricing_one": "You've reserved seats for 1 passenger for <span class='total-pricing-fiat'><strong>{{price}}</strong></span>.",
    "totalSeatPricing_other": "You've reserved seats for {{count}} passengers for <span class='total-pricing-fiat'><strong>{{price}}</strong></span>.",
    "title": "Seat Selection",
    "loadingMessage": "Fetching seat information",
    "selectedSeats": "Selected Seats",
    "validateLoadingMessage": "Saving seat selection",
    "selectYourSeats": "Select your seats",
    "continueWithoutSeats": "Continue without seats",
    "errorFailedAddToCartTitle": "Uh oh! Failed saving your seats",
    "errorFailedAddToCartSubtitle": "Continue without seats or search again",
    "cityToCity": "{{originCity}} to {{destinationCity}}",
    "flightChangeWarning": "Flight change in {{cityName}} ({{airportCode}})",
    "outboundFlights": "Outbound flights",
    "returnFlights": "Return flights"
  },
  "priceFreezePurchase": {
    "documentTitle": "Price freeze",
    "fulfillLoaderCopy": "Freezing prices",
    "offerCard": {
      "title": "Stay safe from price increases while you plan your trip!",
      "frozenPrice": "Frozen price",
      "costOfFreeze": "Cost of Freeze",
      "traveler": "traveler",
      "freezeDurationTitle": "Select freeze duration:",
      "freezeDurationConfirmationTitle": "Freeze duration:",
      "expiresOn": "Expires on",
      "continueToPayment": "Continue to payment",
      "day": "day",
      "days": "days",
      "hours": "hours",
      "hourCode": "h",
      "dayCode": "d"
    },
    "termsOfService": {
      "saveText1": "Save up to {{capAmount}} per traveler if the price goes up.",
      "saveText2": "If the price goes down, pay the new low price.",
      "protectText1": "Protect yourself from price increases.",
      "protectText2": "Pay this one time fee, book later when you are ready.",
      "cta": "Terms & Conditions",
      "termsAndConditions": "Terms and conditions",
      "termsTitle": "Terms and Conditions: Hopper Price Freeze™",
      "termsText": "<p>Hopper's Price Freeze™ grants the purchaser (you) the right to purchase from Hopper a selected airline ticket(s) at a specified price for a specified period of time, subject to availability and any applicable Savings Cap. By purchasing a Hopper Price Freeze, you agree to these Terms and Conditions.  By purchasing the Service, you agree to these Service Terms, Hopper's <a href='https://www.hopper.com/legal/terms-and-conditions'>Terms of Service</a> and Hopper's <a href='https://hopper.com/legal/privacy-policy'>Privacy Policy</a>.</p><p>The Service is subject to the following requirements and restrictions: </p><ol><li><b>Price Freeze Purchase Price.</b> By selecting the purchase of a Price Freeze  within the Hopper mobile app, you authorize Hopper to charge your stored payment method for the quoted Price Freeze purchase amount (the <b>Fee</b>). The Fee to freeze a flight price is a non-refundable service fee paid to Hopper that is not applied towards the price of your flight ticket. All Price Freeze sales are non-transferable and non-refundable in all circumstances regardless of changes to your purchased flight ticket status made by you or the airline after your decision to exercise your Price Freeze, subject to Section 7 below. All Price Freeze purchase amounts are per person. If there is more than one person in your flight booking for whom you would like to purchase a Price Freeze, you must purchase a Price Freeze for each individual in the booking. </li><li><b>Exercise Window.</b> Your frozen price will be available for a specified period of time that will be made clear prior to purchasing. This time window commences upon purchase and expires upon the expiration of the timeframe specified on the confirmation page at the time of purchase  (e.g., 3, 5, or 7 days). If you pay to freeze a flight price, you will receive a confirmation email indicating the details of the flight itinerary that you have frozen a price for, as well as the expiration time of the freeze. All flight prices are inclusive of applicable taxes and fees, unless otherwise indicated. You can also view all frozen itineraries, with their respective expiration dates and times, on the Home screen in the Hopper mobile app. Hopper is not responsible for technical issues outside of Hopper's control that prevent you from utilizing the Hopper mobile app to exercise a Price Freeze during the Exercise Window.</li><li><b>Specified Tickets.</b> A Price Freeze  is valid only for the specified airline ticket(s) selected by you and based on the information provided by you at the time of purchasing the Price Freeze. No changes to flights, times, dates, cabin classes, number of passengers, or passenger names will be permitted. Hopper is not responsible for errors made by you during the Price Freeze purchase process.</li><li><b>Exercise.</b> In order to purchase the frozen flight during the applicable Exercise Window, you may select the Price Freeze on the Home screen in the Hopper mobile app. At the time of exercise, when the current ticket price is higher than the price indicated in your Price Freeze, you will only pay the frozen price, in accordance with Section 5 and, if applicable, any price increase exceeding the Savings Cap.  All flight prices are inclusive of applicable taxes and fees, unless otherwise indicated. Following purchase of the specified ticket(s), any refunds, cancellations or exchanges of the purchased ticket will be subject to the fare rules set by the issuing airline. Hopper bookings must contain one passenger over 18 years of age in order to be considered valid.</li><li><b>Savings Cap.</b> Price Freeze may be subject to a maximum amount that Hopper will pay for (<li><b>Savings Cap</b>). The Savings Cap will be made clear prior to purchasing and will be stated on the confirmation screen and email. Hopper will only pay for the amount of a price increase up to the stated Savings Cap amount. If the price of your Price Freeze flight has increased more than the Savings Cap amount, your stored payment method will be charged the current airline ticket price less the Savings Cap. If there is no stated Savings Cap, then Hopper will pay the full amount of any price increase upon exercise.</li><li><b>Expiration.</b> You may elect not to purchase the specified airline ticket(s) during the applicable Exercise Window, in which case the Price Freeze will expire at the end of the Exercise Window, and Hopper will have no further obligation to sell tickets at the specified price. There is no further charge for allowing a Price Freeze to expire. If you elect to purchase the specified airline ticket(s) after the end of the Exercise Window, you will be required to pay in full a new ticket price quoted by Hopper at the time of ticket purchase, which may be higher than the price specified in the expired Price Freeze.</li><li><b>Ticket and Cabin Class Availability.</b> A Hopper Price Freeze guarantees a price for a specified ticket, but does NOT guarantee the availability of any ticket or cabin class. In the event that you select to exercise a Price Freeze and the ticket or cabin class specified in a valid Price Freeze is canceled or sells out, we will notify you and refund your Fee. Hopper may, in its discretion, offer to substitute a different ticket(s) on the same or different airline that is similar to the original ticket(s) specified in a purchased Price Freeze. Should you accept that offer, Hopper will pay for the difference in fare between your Price Freeze and the new ticket price (subject to any Savings Cap). If you do not accept that offer, or if Hopper does not offer an alternative, Hopper will refund your Fee, which you acknowledge and agree shall be your sole and exclusive remedy for the unavailability of the selected flight.</li><li><b>Price Freeze Not Available for Certain Ticket Types.</b> Due to limitations in airline reservation systems, Hopper is currently unable to honor any Hopper Price Freezes purchased by or on behalf of minors. If a Hopper Price Freeze has been purchased by or on behalf of a minor, Hopper will refund you the full amount of the Fee paid to purchase that Price Freeze. This refund of the Fee will be the sole and exclusive compensation offered by Hopper, and Hopper will be under no obligation to honor the frozen price of the flight.</li><li><b>Not Insurance.</b> Hopper's Price Freeze is the option to purchase from Hopper a selected airline ticket(s) at a specified price during the Exercise Window. Hopper provides its customers with Price Freeze to provide a more seamless and flexible experience for travel booked on the Hopper mobile app. The Service Terms are not intended to constitute an offer to insure, do not constitute insurance or an insurance contract, and do not take the place of insurance obtained or obtainable by you.</li><li><b>Contact.</b> For any questions, please contact Hopper's Customer Support via the Hopper App.</li></ol><p>Version 1.4; Date Published: November 23, 2022</p>"
    },
    "details": {
      "title": "Details"
    },
    "confirmation": {
      "title": "Your price is frozen!",
      "subtitle": "We’ve sent an email confirmation.",
      "cta": "Done"
    }
  },
  "deletePassenger": "Delete passenger",
  "reviewDetails": "Review details",
  "viewTrip": "View trip",
  "priceFreezeExercise": {
    "priceFreezeExerciseError": {
      "title": "There’s no availability for ({{numberOfTravelers}}) travelers on this flight.",
      "subtitle": "You will be refunded the amount you paid of {{currencyAmount}} for {{numberOfTravelers}} travelers.",
      "primaryButton": "Get a refund",
      "secondaryButton": "Try again"
    },
    "priceFreezeRefundSuccess": {
      "title": "Your refund is on its way!",
      "subtitle": "Your refund can take up to 1-2 billing cycles to appear on your original method of payment.",
      "primaryButton": "Continue"
    },
    "priceFreezeRefundFail": {
      "title": "Something went wrong",
      "subtitle": "We were unable to process your refund, please contact support for further assistance with your refund or try again.",
      "primaryButton": "Try again",
      "secondaryButton": "Contact Support"
    },
    "loading": "loading..."
  },
  "priceFreezeExerciseSavingText": "Price Freeze saved you {{amount}}!",
  "priceFreezeDiscountText": "Price Freeze savings",
  "chfarDiscountText": "Change for any reason discount",
  "voucherDiscountText": "Voucher applied",
  "promotionDiscountText": "Promotion applied",
  "paymentMethod": "Payment Method",
  "amountDue": "Amount due",
  "creditPaymentText": "Wallet Savings and added funds",
  "priceChange": {
    "priceIncreaseTitle": "The total price for your trip has increased to {{amount}}",
    "priceDecreaseTitle": "You're in luck! The total price for your trip has decreased to {{amount}}",
    "priceDecreaseSubtitle": "Sometimes airlines change the prices unexpectedly. You can review the new trip total on the final screen before checkout.",
    "priceIncreaseSubtitle": "Sometimes airlines change the prices unexpectedly. Sorry about that! You can review the new trip total on the final screen before checkout."
  },
  "insufficientBalance": "Insufficient funds",
  "rechargeBalance": "Your balance is not enough to book your ticket 😞 You must recharge your $t(brand:merchantPayments) to be able to make the purchase.",
  "AirDisruptionProtection": "Disruption Protection",
  "AirDisruption": "Disruption Protection",
  "airPriceDrop": "Price Drop Protection",
  "AirCfar": "Cancel for Any Reason",
  "AirChfar": "Change for any reason",
  "Seats": "Seats",
  "emptySeatsDescription": "Seat selection is available for your flight. Otherwise your seats can be added directly with the airline.",
  "addSeats": "Add seats",
  "reviewFareDetailsTitle": "See what's included in your fare",
  "reviewFareDetailsButton": "View fare details",
  "bookingFlightSubtitle": "This may take a couple of minutes. Do not leave this screen.",
  "pollQuoteLoading": {
    "step1Title": "Saving passengers",
    "step1Description": "Checking the final details takes some time, so please bear with us while we make sure all the fares are calculated properly!",
    "step2Title": "Checking seats",
    "step2Description": "Now checking if seats are available on this flight."
  },
  "scheduleFulfillLoading": {
    "title": "Confirming your booking!",
    "description": "Hold tight, we're confirming your booking with the airline. This should take a few seconds.",
    "step1Title": "Completing authorization",
    "step2Title": "Almost there...",
    "step3Title": "Done!",
    "hotel": {
      "description": "Hold tight, we're confirming your booking with the hotel. This should take a few seconds."
    }
  },
  "paymentContinue": "Save card and continue to trip review",
  "paymentStepSelectorSubtitle": "You previously saved this payment method in your account. You can continue with it, delete it or choose a different payment method.",
  "creditCardEndingText": "Ending in {{last4}}",
  "addPaymentMethodButton": "Add a different payment method",
  "continueToReview": "Continue to trip review",
  "flightCheckoutTitle": "Flight Checkout",
  "signInQuestion": "Do you have an account?",
  "contactInformationBreadcrumb": "Contact Information",
  "lodgingBookingConfirmation": {
    "title": "Confirmed, your hotel is booked!",
    "subtitle": "An email confirmation will be sent to <strong>{{bookingEmail}}</strong>",
    "confirmationNumber": "<strong>Your confirmation number is #{{confirmationNumber}}</strong>",
    "passportBunnyAlt": "Booking Confirmed Bunny"
  },
  "homesBookingConfirmation": {
    "title": "Confirmed, your vacation rental is booked!"
  },
  "lodgingPriceBreakdown": {
    "roomPriceWithTaxesAndFees": "Room price with taxes & fees",
    "paymentSchedule": "Payment Schedule",
    "payNow": "Pay now",
    "payAtProperty": "Pay at property",
    "cityTaxes": "City taxes",
    "resortFees": "Resort fees",
    "hotelFees": "Hotel fees",
    "additionalFees": "Additional Fees",
    "hotelDueUponCheckIn": "Fees due upon check-in"
  },
  "contactInformationDetails": "Fill in your details",
  "ifApplicable": "If applicable",
  "flightConfirmation": "Flight Confirmation",
  "priceDetails": "Price details",
  "selectPassengers": "Select passengers",
  "deletePassengerModalTitle": "Delete passenger?",
  "deletePassengerButton": "Yes, delete",
  "deletePassengerModalDescription": "Delete passenger and information? This can’t be undone.",
  "fetching-latest-price": "Fetching latest price",
  "modifyPassengersButtonText": "Modify",
  "goToPayment": "Go to payment",
  "taxesAndFees": "Taxes & Fees",
  "signInToSave": "Sign in to save",
  "checkoutSection": {
    "contactInformation": {
      "title": "Your contact information",
      "subtitle": "This information is used to notify you about any updates or changes to your trip."
    },
    "deleteTravelerDialog": {
      "title": "Delete Traveler",
      "description": "This will delete all the information associated with this traveler."
    },
    "passenger": {
      "title": "Select or add travelers",
      "subtitle": "Make sure the information you add matches each traveler’s ID. You can’t change this information after booking.",
      "button": "Add new traveler"
    },
    "steps": {
      "step1": "Step 1: Passenger information",
      "step2": "Step 2: Payment",
      "step3": "Step 3: Trip review"
    },
    "travelerForm": {
      "errors": {
        "genderRequired": "Gender required",
        "firstNameRequired": "First name required",
        "lastNameRequired": "Last name required",
        "dateOfBirthRequired": "Date of birth required"
      }
    },
    "primaryParticipant": {
      "title": "Step 2: Primary participant",
      "subtitle": "Select the primary participant for your booking.",
      "subtitleHidden": "Fill out the previous step to move onto the Primary Participant step.",
      "selectedLabel": "Selected participant"
    },
    "activityInformation": {
      "title": "Step {{step}}: Activity details",
      "subtitleHidden": "Fill out the previous step to move onto the Activity Details step."
    }
  },
  "invalidPassportNumber": "Invalid passport number",
  "core-checkout": {
    "priceBreakdown": {
      "baseFare": "Base fare",
      "taxesFees": "Taxes and fees",
      "taxesAndFeesTooltip": "This charge includes estimated amounts the travel service provider (eg: hotel) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us and/or a fee that the travel service provider retains as part of the compensation for their services, which varies based on factors such as location, the amount, and how you booked. Hopper does not retain any of these amounts as compensation. For more details, please see the terms and conditions.",
      "product": "Product",
      "baggage": "Baggage",
      "seats": "Seats",
      "cfar": "Cancel For Any Reason",
      "disruption": "Premium Disruption Assistance",
      "total": "Total"
    },
    "contactInformation": {
      "title": "Contact information",
      "note": "You must add one traveler and enter your contact information to continue."
    },
    "review": {
      "title": "Review and book",
      "subtitle": "Review your trip before you confirm and book.",
      "confirm": "Confirm booking"
    },
    "passenger": {
      "button": "Save & Continue",
      "edit": "Edit Traveler Information"
    },
    "confirmation": {
      "title": "Booking Confirmed",
      "subtitle": "Find confirmation details below",
      "confirmationNumber": "Confirmation number: {{confirmationNumber}}",
      "continue": "Continue",
      "email": "An email confirmation will be sent to {{email}}"
    }
  },
  "travelerForm": {
    "title": "Traveler information",
    "subtitle": "Ensure the details matches traveler ID or passport. Depending on the airline, traveler may not be able to make changes after booking.",
    "middleNameLabel": "Middle name",
    "dateOfBirthLabel": "Date of birth",
    "travelerDetails": "Traveler details",
    "passportDetails": {
      "title": "Passport information",
      "subtitle": "Some airlines require passport information for domestic/international flights. In order to save traveler details, you must fill in all fields of your passport.",
      "passportExpiryDateLabel": "Passport expiration date",
      "passportIssuanceCountryLabel": "Passport issuance country"
    },
    "frequentFlyer": {
      "title": "Frequent flyer membership (optional)",
      "addMembership": "Add membership"
    },
    "additionalInfo": {
      "title": "Additional information (optional)",
      "selectAssistanceLabel": "Select assistance",
      "assistanceRequiredLabel": "Assistance needed",
      "assistanceRequiredInfo": "Provision of support, services, and guidance to travelers to ensure a safe, convenient, and enjoyable journey. It encompasses various aspects of travel, including transportation, accommodation, information, and emergency support. If you have difficulty walking, a wheelchair will be provided for you by your airline. You must request these services in advance. If you are blind or if you are deaf someone from your airline will assist you to ensure you catch your correct flight.",
      "travelerNumberInfo": "A Known Traveler Number (KTN) is issued to all individuals approved to receive TSA PreCheck® expedited screening. The KTN must be added in the KTN field when booking airline travel reservations to have the TSA PreCheck® indicator appear on your boarding pass.",
      "redressNumberInfo": "The Redress number is a unique seven-digit identifier issued by the Department of Homeland Security Traveler Redress Inquiry Program (DHS TRIP) and is used by the Transportation Security Administration's (TSA) Secure Flight program to match travelers with the results of their redress case.",
      "knownTravelerNumberLabel": "Known Traveler Number"
    },
    "driverLicense": {
      "title": "Driver's license information",
      "issuingCity": "Issuing City",
      "issuingCityPlaceholder": "City name",
      "issuingCountry": "Issuing Country",
      "zipCode": "Postal Code"
    },
    "errors": {
      "firstNameRequired": "First name required.",
      "lastNameRequired": "Last name required.",
      "dateOfBirthRequired": "Date of birth required.",
      "genderRequired": "Gender required.",
      "passportRequired": "Passport number required",
      "nationalityRequired": "Nationality required",
      "issueCountryRequired": "Passport issuance country required",
      "passportExpirationRequired": "Expiration date required",
      "driverLicenseaddressRequired": "Driver's license address required",
      "driverLicenseissueCityRequired": "Driver's license issuing city required",
      "driverLicenseissueCountryRequired": "Driver's license issuing country required",
      "driverLicensezipCodeRequired": "Driver's license postal code required"
    }
  },
  "spreedly": {
    "error": {
      "invalidYear": "Expiration year was invalid.",
      "invalidMonth": "Expiration month was invalid.",
      "invalidCardType": "Card type was invalid.",
      "invalidFirstName": "Firstname may contain disallowed characters.",
      "invalidLastName": "Lastname may contain disallowed characters.",
      "invalidNumber": "Card number was invalid.",
      "blankFirstName": "Firstname cannot be blank.",
      "blankLastName": "Lastname cannot be blank.",
      "blankCardType": "Number is invalid. Unable to determine the card type."
    }
  },
  "fintechCartUpdateError": {
    "title_one": "Unable to add service",
    "title_other": "Unable to add services",
    "description_one": "We encountered an issue adding {{productNames}} to your booking. Please try again or continue without this service.",
    "description_other": "We encountered an issue adding {{productNames}} to your booking. Please try again or continue without these services.",
    "retryButton": "Try again",
    "continueButton_one": "Continue without this service",
    "continueButton_other": "Continue without these services"
  },
  "core-self-serve": {
    "resend-email": {
      "error": {
        "subtitle": "Your email was not sent!",
        "title": "There was an error"
      },
      "form": {
        "subtitle": "Tell us where you'd like your email resent to",
        "title": "Resend Email"
      },
      "processing": "Sending email...",
      "success": {
        "subtitle": "Your email has been resent.",
        "title": "Success!"
      },
      "submit": "Resend",
      "try-again": "Try again"
    },
    "supportChat": {
      "toggleBtn": "Chat with a virtual assistant"
    }
  },
  "addOnsTitle": "Add Ons",
  "backToTrips": "Back to My Trips",
  "baseFare": "Base Fare",
  "bookAFlight": "Book A Flight",
  "bookAHotel": "Book A Hotel",
  "bookWithCredit": "Book With Credit",
  "cancellationInfoTitle": "Cancellation Information",
  "cancelled": "Cancelled",
  "cancelledItinerary": "This itinerary has been cancelled",
  "completedItinerary": "Itinerary completed",
  "departingLabel": "Departing",
  "returningLabel": "Returning",
  "tripTypeLabel": "Trip",
  "help": "Help",
  "reservationNumbers": "Reservation numbers",
  "multiAirlineTrip": "This itinerary combines different airlines. Cancellation or changes to one of your flights will not alter the other automatically.",
  "multipleAirlines": "Multiple airlines",
  "bagAllowance": {
    "title": "Checked Bags Allowance",
    "notAllowed": "Not Allowed",
    "alloweAt": "Bag {{bagNumber}} at {{price}}"
  },
  "cancellationPolicy": {
    "title": "Cancellations",
    "contactAirline": "Contact airline"
  },
  "exchangePolicy": {
    "title": "Exchanges",
    "chfarTitle": "Advance Change",
    "nonRefundable": "Non-refundable",
    "free": "Free",
    "forAFee": "For a fee of {{fee}}"
  },
  "chat": {
    "csatForm": {
      "freeformInput": {
        "placeholder": "I liked/disliked about the chat experience",
        "title": "Anything else you would like to add?"
      },
      "rating": {
        "title": "Rate your chat conversation",
        "subtitle": "Help us create the best service for you.",
        "label_1": "Very bad",
        "label_2": "Bad",
        "label_3": "Okay",
        "label_4": "Good",
        "label_5": "Excellent"
      },
      "submit": "Submit",
      "skipCsat": "Not now"
    },
    "fabTitle": "Help",
    "header": {
      "title": "Travel Customer Support",
      "subtitle": "Helping you 24/7",
      "minimize": "Minimize Chat",
      "close": "Close Chat"
    },
    "chatTodayDivider": "Today",
    "chatDescriptionBadge": "AI",
    "chatDescription": "Virtual Assistant connected",
    "AIAgentName": "Virtual Assistant",
    "copyConversationId": "Copy Conversation ID",
    "messageStatus_failed": "Failed to send",
    "messageStatus_pending": "Pending",
    "messageStatus_sent": "Received",
    "contactSupport": {
      "deepLinkContactSupportButtonLabel": "Select contact method",
      "deepLinkTripCancellationButtonLabel": "View cancellation options",
      "deepLinkTripDetailsButtonLabel": "View trip details",
      "title": "Contact Support",
      "subtitle": "Get instant 24/7 support from our chat assistant or connect with one of our expert agents for urgent cases.",
      "supportIdLabel": "Your support ID",
      "chatOptionTitle": "Start a chat",
      "chatOptionSubtitle": "24/7 virtual assistant",
      "callOptionTitle": "Call us",
      "callOptionTitleIntl": "Call from abroad",
      "callOptionHOOP": "Available 24/7",
      "callOptionHOOP_limited": "Available {{startHour}} to {{endHour}} {{timezone}}",
      "callOptionHOOP_unavailable": "Available again from {{startHour}} to {{endHour}} {{timezone}}",
      "callOptionPhoneNumberLocal": "{{phoneNumber}} (Toll-free)",
      "callOptionPhoneNumberIntl": "{{phoneNumber}} (Potential fees)"
    },
    "additionalInfo": "<0>For additional information, visit our</0> <1>Travel Help Center & FAQs<1/>",
    "inputPlaceholder": "Type a message..."
  },
  "selfServe": {
    "cancelErrorSubtitle": "Please contact the airline for further assistance.",
    "cancelErrorTitle": "Error while loading flight's cancellation info.",
    "contactAirlineButton": "Continue to the airline's website",
    "cancelLoading": "Loading flight details and cancellation policy...",
    "cancelPendingTitle": "Your previous cancel request is currently being processed",
    "cancelPendingSubtitle": "Within a few minutes, you'll receive an email confirmation and Upcoming Trips will reflect the new status.",
    "cancelEmailConfirmation": "<b>Within a few minutes</b>, you'll receive an email confirmation at {{email}} and Upcoming Trips will reflect the new trip status.",
    "cancelationComplete": "Your cancellation is complete",
    "cancelationConfirmation": "Cancellation confirmation",
    "cancelProcessing": "Your cancellation is being processed...",
    "cancelDepartedTitle": "This flight has departed",
    "cancelDepartedSubTitle": "Please contact the airline for further assistance.",
    "ftcInfoTitle": "About FTC Credits",
    "ftcInfoCta": "How Airline Travel Credits Work",
    "ftcInfo": "Travel Credits can be used to book flights via My Trips, and must be redeemed within the timeframe set by the airline (generally within 1 year of the original flight purchase).",
    "confirmCancel": "Confirm Cancellation",
    "contactSupport": "Contact support",
    "cancelForAnyReason": "Cancel for any reason",
    "continueToAirline": "Continue to {{airline}}'s website",
    "continueToAirline_endsWithS": "Continue to {{airline}}' website",
    "changeFlightHeader": "Change {{flightType}} flight",
    "openCancellationInfo": "Open cancellation info",
    "continueToExchange": "Continue to exchange",
    "howTcWorks": "How does a travel credit work?",
    "slicePickerInfo": "One or more of these flights is ineligible for changes. Please contact our customer support team for assistance.",
    "supportSubtitle": "Unfortunately this type of booking cannot be managed via self-service, please contact us and we'd love to assist!",
    "multiProviderSupportSubtitle": "This booking includes flights from multiple airlines and can only be cancelled by a support agent. Please contact us and we'll take care of it for you.",
    "supportTitle": "Contact our support team for assistance",
    "tryAgainBtn": "Try again",
    "visitAirline": "Visit the airline's website",
    "backToTrips": "Back to My Trips",
    "contactAirline": "Contact airline",
    "header": "Cancel my trip"
  },
  "cancelledItineraryCredit": "This itinerary has been cancelled for a travel credit valued at {{currency}} {{credit}}.",
  "cancelledItineraryPeriod": "This itinerary has been cancelled.",
  "cancelFlight": "Cancel Flight",
  "cancelForAnyReason": "Cancel For Any Reason",
  "cancelForAnyReasonDescription": "Cancel this trip at least 24 hours before your trip from My Trips.",
  "changeForAnyReason": "Change for Any Reason",
  "missedConnection": "Missed Connection",
  "delayDisruption": "Delay Disruption",
  "premiumDisruptionAssistance": "Premium Disruption Assistance",
  "premiumDisruptionAssistanceDescription": "You can rebook a delayed or canceled flight immediately or get a refund.",
  "cancellationPending": "Cancellation Pending",
  "cancelFlightModal": {
    "cancelBtn": "Cancel my flight",
    "cancelAnotherBtn": "Cancel another flight",
    "confirmBtn": "Confirm cancellation",
    "departedSubtitle": "Contact the airline for assistance",
    "departedTitle": "This flight has departed already",
    "error": {
      "bookingPendingTitle": "This booking is still pending",
      "canceledTitle": "This booking has already been canceled",
      "cancelTitle": "Oh no! There was an issue while canceling",
      "policyTitle": "Oh no! We couldn't retrieve your policy!",
      "subtitle": "Try again in a few minutes, or feel free to reach out to our support team who'd be happy to assist."
    },
    "infoItemsTitle": "Cancellation information",
    "loadingContext": "Loading your flight details and cancellation policy...",
    "multiProviderTitle": "Cancel your flight booking",
    "pendingSubtitle": "Once complete, you'll receive a confirmation email and your trip status will be updated in My Trips.",
    "pendingTitle": "Your prior cancel request is underway!",
    "processingCancel": "Cancelling your flight...",
    "refreshPolicyBtn": "Refresh policy",
    "slicePickerTitle": "Select which flight you'd like to cancel",
    "slicePickerSubtitle": "Your trip is on separate airlines and requires canceling them individually. Cancellations to one flight will not alter others automatically. For flexibility, you may choose the flight you wish to cancel.",
    "successSubtitle": "A confirmation email will be sent shortly and My Trips will be updated within a few minutes.",
    "successSubtitleMultiTicket": "Your booking has more flights that are eligible for cancellation.",
    "successTitle": "We've cancelled your booking!",
    "tryAgainBtn": "Try again",
    "disclaimer": "The free cancellation period is displayed in the local time of the outbound flight."
  },
  "cancelHotelModal": {
    "cancelHeader": "Cancel my booking",
    "cancelBtn": "Cancel my hotel",
    "confirmBtn": "Confirm cancellation",
    "error": {
      "alreadyCanceled": {
        "title": "This booking has already been canceled",
        "subtitle": "Our records indicate that this booking has already been canceled. If this is incorrect, please contact our customer support team for assistance."
      },
      "cancelTitle": "Oh no! There was an issue while canceling",
      "policyTitle": "Oh no! We couldn't retrieve your policy!",
      "subtitle": "Try again in a few minutes, or feel free to reach out to our support team who'd be happy to assist."
    },
    "importantInfoTitle": "Cancellation information",
    "loadingContext": "Loading your hotel details and cancellation policy...",
    "pendingSubtitle": "This cancellation is in progress, a confirmation email will be sent within 1-2 hours",
    "pendingTitle": "Cancellation pending",
    "processingCancel": "Processing cancellation...",
    "successSubtitle1": "A confirmation email will be sent shortly.",
    "successSubtitle2": "'My Trips' will be updated within a few minutes.",
    "successTitle": "We've cancelled your booking!"
  },
  "changeHotelModal": {
    "cancelAndRebookTitle": "You should cancel and rebook!",
    "cfarEligible": {
      "subtitle1": "Although changes aren't permitted, you purchased <b>Cancel For Any Reason</b>.",
      "subtitle2": "Feel free to cancel before {{expDate}} and make a new reservation."
    },
    "error": {
      "title": "Oh no! We couldn't retrieve your policy!",
      "subtitle": "Try again in a few minutes, or feel free to reach out to our support team who'd be happy to assist."
    },
    "fullyRefundable": {
      "subtitle1": "Although changes aren't permitted, your booking is <b>Fully Refundable until {{expDate}}</b>.",
      "subtitle2": "Cancel free of charge and make a new reservation."
    },
    "hopperRefundable": {
      "subtitle1": "Although changes aren't permitted, your booking is <b>Refundable by Hopper</b>.",
      "subtitle2": "Feel free to cancel before {{expDate}} and make a new reservation."
    },
    "loadingContext": "Loading your hotel details and change policy...",
    "nonRefundable": {
      "subtitle1": "Unfortunately the hotel doesn't allow changes for this type of reservation under any circumstance.",
      "subtitle2": "<b>Your booking is non-refundable.</b>",
      "title": "This reservation can't be changed"
    },
    "partiallyRefundable": {
      "subtitle1": "Although changes aren't permitted, your booking is <b>Partially Refundable until {{expDate}}</b>.",
      "subtitle2": "Feel free to cancel and make a new reservation."
    },
    "viewCancelPolicyBtn": "View cancel policy"
  },
  "checkInModal": {
    "notificationHeader": "Separate check-in required.",
    "notificationLabel": "You will need to individually check-in for each leg before your departure.",
    "subtitle": "Check in for your flight by clicking the copy & go link below. You will be redirected to the airlines website.",
    "title": "Check-in for your flight"
  },
  "cfarButtonAriaText": "Open change-for-any-reason modal",
  "chfarExercise": {
    "header": "Change for any reason",
    "title": {
      "detailsTitle": "You added Change For Any Reason to your trip",
      "selectRebookTitle": "These flight(s) will be rebooked"
    },
    "description": "You can change your flight up until {{departureDate}}. Here are the details under your plan.",
    "changeConditions1": "You will need to rebook your entire trip. If you only want to rebook one leg, you will need to contact ",
    "customerSupport": "<u><b>customer support</b></u>.",
    "changeConditions2": "<li>You can book your new trip on any airline for up to 1 year from your original departure date.</li>",
    "changeConditions3": "<li>You'll only pay the difference between your two tickets; we cover up to your original ticket cost, including change fees.</li>",
    "changeConditions4": "<li>You will be changing the itinerary for all passengers on your original booking.</li>",
    "changeConditions5": "<li>Baggage and/or seat fees and other trip extras added to your original booking are non-transferrable.</li>",
    "cta": {
      "continue": "Continue",
      "searchFlights": "Search Flights"
    }
  },
  "cfarExercise": {
    "title": "Cancel For Any Reason added to your trip",
    "cancelFlightTitle": "Cancel your flight",
    "cancelBookingVoid": "Cancel your booking free of charge and get a full refund for the fee you paid to <0>Cancel For Any Reason</0> as you are in the free cancellation window for your flight.",
    "cancelBookingNoExpiry": "Cancel your booking free of charge and get a full refund for the fee you paid to <b>cancel for any reason</b>",
    "termsAndConditionsVerbose": "Terms and Conditions",
    "cancellationConfirmedTitle": "Your cancellation is confirmed!",
    "completeCancellationForAllPax": "Complete the cancellation of your flight for all passengers.",
    "confirmCancellation": "Confirm cancellation",
    "confirmation": {
      "ftc": {
        "details": "After cancelling the flights for all passengers, you’ll receive an airline travel credit worth {{refundAmount}} that you can use to book a future trip with {{airline}}.\nWhen you're ready to use your travel credit to make a new reservation, start a chat with Hopper Flights Support.",
        "detailsNoAirline": "After cancelling the flights for all passengers, you’ll receive an airline travel credit worth {{refundAmount}} that you can use to book a future trip.\nWhen you're ready to use your travel credit to make a new reservation, start a chat with Hopper Flights Support."
      },
      "cash": {
        "details": "After cancelling the flights for all passengers, you’ll receive a refund of <0>{{refundAmount}}</0> to your original payment method. You should receive your refund within 5 to 7 business days, but in some cases it may take longer."
      }
    },
    "learnMore": "Learn more",
    "termsAndConditions": "Terms & Conditions",
    "processingCancellation": "Your cancellation is being processed...",
    "cancellationConfirmation": "Cancellation confirmation",
    "cancellationInformation": {
      "title": "Important Information",
      "expirationDuration": "Cancellations are allowed up to 3 hours before your first scheduled departure.",
      "allPassengers": "All passengers will be canceled from this booking. Cancellations cannot be reversed.",
      "refunds": "Refunds will be issued using the same method of payment as the original booking (e.g., credit card, rewards and/or travel credits), up to the benefit maximum. Please allow 5 to 7 business days for credit card refunds to appear in your account.",
      "email": "You will receive a confirmation email and the status of your trip will be updated in the portal.",
      "questions": "If you have any questions about canceling your trip please <0>contact support</0>."
    },
    "completedCancellation": "<b>Within a few minutes</b> you’ll receive an email confirmation at {{email}} and Upcoming Trips will reflect the new trip status.",
    "loadingMessage": "Fetching your cancellation info...",
    "pendingMessage": "Your cancellation is being processed...",
    "cta": {
      "cancelFlight": "Cancel flight",
      "confirmCancellation": "Confirm cancellation",
      "goBack": "Go back",
      "completedCancellation": "Done",
      "continue": "Continue",
      "close": "Close",
      "back": "Back"
    },
    "error": {
      "title": "Oops, something went wrong.",
      "subtitle": "We were unable to cancel your booking, please try again.",
      "primaryButton": "OK",
      "secondaryButton": "Contact support",
      "somethingWentWrong": "Something went wrong",
      "unableProcessRequest": "We were unable to process your request. Please try again or contact support.",
      "contactSupport": "Please contact support if you need additional assistance.",
      "contractExpired": {
        "title": "Your Cancel for Any Reason has expired",
        "cfarWindow": "You are not able to use your Cancel for Any Reason starting <b>3 hours before your first departure</b>.",
        "airlineCancellationPolicy": "If you still want to cancel, airline cancellation policy will apply. Most airlines do not allow cancellations within 3 hours of departure."
      },
      "exercised": {
        "title": "Your flight is cancelled",
        "alreadyUsed": "You have already used Cancel for Any Reason for this trip."
      }
    },
    "complete": {
      "title": "Cancellation complete",
      "paragraph1": "Your booking has been canceled and your refund has been processed.",
      "paragraph2": "A confirmation email will be sent shortly.",
      "cta": "Close"
    }
  },
  "disruptionExercise": {
    "delayTitle": "You added disruption guarantee to your trip",
    "delaySubtitle": "If your flight is delayed for more than 90 minutes or cancelled by the airlines during your trip, your flight becomes free.",
    "airlineAgreementDelaySubtitle": "If your flight is delayed for more than 90 minutes or cancelled by the airline during your trip, your flight is free. Hopper Travel will cover the cost of a new flight on {{airline}} or refund you immediately.",
    "missedConnectionTitle": "You added missed connection guarantee to your trip",
    "missedConnectionSubtitle": "If you miss a connecting flight or your flight is cancelled by the airline during your trip, your flight becomes free. We’ll cover the cost of a new flight or refund you immediately.",
    "airlineAgreementMissedConnectionSubtitle": "If you miss a connecting flight or your flight is cancelled by the airline during your trip, your flight is free. Hopper Travel will cover the cost of a new flight on {{airline}} or refund you immediately.",
    "rebookTitle": "Rebook a new flight for free",
    "rebookSubtitle": "Choose from same and next day flights",
    "refundTitle": "Get a refund",
    "refundSubtitle": "A refund to your original payment method",
    "refundConfirmationHeader": "Refund confirmation",
    "loadingMessage": "Your disruption protection is being processed...",
    "refundLoadingMessage": "Your refund is being processed...",
    "refundLoadingMessageSubtitle": "Please do not exit until the process is complete.",
    "loadingReview": "Searching for refund",
    "loadingFlightSelect": "Fetching your flights...",
    "loadingFlightSearch": "Searching for flights...",
    "flightSelectTitle": "Select the flight(s) to rebook",
    "flightSearchToday": "Today",
    "flightSearchTomorrow": "Tomorrow",
    "flightSelectDescriptionTitle": "Know before you rebook",
    "flightSelectDescription1": "Please confirm that the airline has not already rebooked you on a new flight.",
    "flightSelectDescription2": "Use our rebooking tool to book a new connection flight to your destination.",
    "flightSelectDescription3": "After rebooking your new connection you’ll need to collect and check any non-carry-on luggage on your new flight.",
    "refundReviewTitle": "Confirm your refund request",
    "refundReviewDescriptionDelay": "Complete the refund for your Disruption Guarantee for all passengers.",
    "refundReviewDescriptionMissedConnection": "Complete the refund for your Missed Connection Guarantee for all passengers.",
    "refundConfirmationTitle": "Your refund is confirmed!",
    "refundConfirmationDescription": "We’ve sent an email confirmation to {{email}}",
    "confirmationTag": "Confirmation #{{confirmationNumber}}",
    "refundPaymentDetails": "Refund to {{label}}",
    "luggageLearnMoreHeader": "Luggage",
    "luggageLearnMoreTitle": "More about your luggage",
    "luggageLearnMoreDescription": "<p>After rebooking your new connection you’ll need to collect and check any non-carry-on luggage onto your new flight. Here are a few steps you should take:</p><ul><li>Speak with the airline of your original flight and ask them how you can claim your luggage. Note: If you need to collect it at the baggage claim make sure you will have enough time to make it to your new connection.</li><li>Once you have your luggage, check it onto your new flight and pay any applicable baggage fees using your personal payment method.</li></ul><p>If you still have questions, please contact us via chat at any time.</p>",
    "error": {
      "title": "Oops, something went wrong.",
      "subtitle": "We were unable to refund your trip, please try again.",
      "rebookingSubtitle": "We were unable to process your rebooking, please try again.",
      "ineligibleTitle": "Your trip is currently ineligible for a refund",
      "ineligibleSubtitle": "We were unable to refund your trip, please contact the support team for more details.",
      "alreadyExercisedTitle": "This offer has already been redeemed",
      "alreadyExercisedSubtitle": "You have already received a refund for this trip, please contact the support team for more details.",
      "rebookAlreadyExercisedSubtitle": "You have already redeemed disruption protection for this trip, please contact the support team for more details.",
      "alreadyExercisedDelaySubtitle": "You have already exercised Disruption Guarantee. You're still able to rebook with Missed Connection Guarantee. Please contact the support team for more details.",
      "alreadyExercisedMissedConnectionSubtitle": "You have already exercised Missed Connection Guarantee. You're still able to rebook with Disruption Guarantee. Please contact the support team for more details.",
      "shopErrorSubtitle": "We were unable to fetch new flights, please try again or contact support.",
      "planErrorSubtitle": "We were unable to fetch your flights, please try again or contact support.",
      "primaryButton": "Back to trip details",
      "secondaryButton": "Contact support"
    },
    "rebookReviewTitle": "Review and confirm new booking",
    "rebookReviewSubtitle": "Review your flight itinerary and passenger information before you rebook your new flight.",
    "rebookReviewCta": "Confirm and rebook",
    "rebookReviewAlert": "The flight you’ve selected is a lower fare class than your original booking",
    "rebookConfirmation": {
      "title": "Your rebooking is confirmed!",
      "subtitle": "We’ve sent an email confirmation to {{email}}",
      "nextSteps": {
        "luggage": "Collect and recheck any luggage",
        "departure": "Visit the nearest flight information display system and confirm the departure time and gate of your new flight",
        "return": "If needed, rebook your return flight"
      },
      "aboutTitle": "About your return flight",
      "aboutContent": "Speak with the airline to find out if your return flight will be canceled. In case it does, <0>rebook with us for free at any time.</0>",
      "returnModalHeader": "Your return flight",
      "returnModalTitle": "Rebooking your return flight",
      "returnModalContent": "Once you book your new connecting flight connecting flight with us, you may need to rebook your return flight.<ul><li><b>Why would I have to rebook my return flight?</b> The airline may cancel your return flight if you do not show up for the new connection they booked for you. Some airlines may not do this so it is always good to check first.</li><li><b>How and when should I rebook my return flight?</b> It's easy! Book them with us right in the app. You should book them as soon as possible.</li><li><b>Do I have to pay for rebooked my return flight?</b> No, under your Missed Connection Rebooking plan we will cover the costs of your return flight home.</><li><b>Can I rebook my original return flight?</b> We cannot guarantee that you will be able to rebook your original return flight.</li></ul>",
      "loading": "Rebooking your trip"
    },
    "ineligible": {
      "title": "Get help with a disrupted flight",
      "subtitle": "If your flight is delayed by over 1 hour or cancelled by the airline on the day of travel your flight becomes free.",
      "infoText": "We haven't detected a flight delay or cancellation, but come back here if you do experience one. <span style='color:#01AAE4;font-weight:bold;cursor:pointer;'>You can also submit a question here</span> if you think this is an error and talk to an agent."
    }
  },
  "confirmation": "Confirmation",
  "problem": "Problem",
  "confirmed": "Confirmed",
  "viewAllConfirmation": "View all ({{count}})",
  "confirmationModal": {
    "subtitle": "To manage your trip from your airlines website, click the link next to the portion of the flight to be redirected.",
    "title": "Confirmation Numbers",
    "confirmationCodeLabel": "Hopper Travel"
  },
  "contactSupportSubtitle": "For any questions regarding your trip, please contact our support team and we'd be happy to help.",
  "copyAndGo": "Copy & Go",
  "departsOn": "Departs on",
  "expiresOn": "Expires on ",
  "CreatedOn": "Created on ",
  "priceFreezeExpiredOn": "Expired on {{date}} at {{time}}",
  "priceFreezeExpiresOn": "Expires on {{date}} at {{time}}",
  "dateAtTime": "{{date}} at {{time}}",
  "faq": "FAQs",
  "faqCta": "View FAQs",
  "fetchingTrips": "Fetching Trips",
  "fetchingWatches": "Fetching Watched Flights",
  "flightCancelledSubtitle": "Cancelled flights cannot be exchanged",
  "flightCancelledTitle": "This flight was cancelled",
  "itineraryDetailsHeader": "{{airport}} {{destination}} on {{date}}",
  "itineraryDetailsHeaderSimpleReturn": "<0>Return</0> to {{destination}} on {{date}}",
  "itineraryDetailsHeaderSimpleOutgoing": "<0>Outgoing</0> to {{destination}} on {{date}}",
  "itineraryModified": "Itinerary Modified",
  "itineraryNotFoundSubtitle": "We could not find your itinerary, please contact support",
  "itineraryNotFoundTitle": "Itinerary not found",
  "noBookings": "You haven't made any bookings yet",
  "noPastBookings": "You have no past bookings",
  "noFlightBookings": "You haven't booked any flights yet",
  "noHotelBookings": "You haven't booked any hotel reservations yet",
  "noWatches": "You haven't watched any trips",
  "noFrozenPrices": "You haven't frozen any prices",
  "noTrips": "You have no upcoming trips",
  "noTripsFound": "No Trips Found",
  "noTripsSubtitle": "Start planning for your next trip now.",
  "noTripsButtonTitle": "Book a trip",
  "oneWayFlight": "One-way Flight",
  "originToDestination": "{{origin}} to {{destination}}",
  "departureToReturn": "{{departureDate}} to {{returnDate}}",
  "pastFilterButton": "Past",
  "pastTripsSubtitle": "Items in this list are ordered based on the most recent past departure, check-in and pick up dates.",
  "pastTripsTitle": "Past Trips",
  "pastTripsLoadErrorTitle": "Unable to load past/cancelled trips.",
  "tripsLoadErrorSubtitle": "Please try again.",
  "tripsLoadErrorButtonTitle": "Try again",
  "pending": "Pending",
  "pendingCancellation": "This cancellation is in progress, a confirmation email will be sent within 1-2 hours",
  "priceFreezeSubtitle": "Items in this list are ordered based on the most upcoming departure dates.",
  "priceFreezeTitle": "Frozen Prices",
  "redeemFtcButton": "Your travel credit is worth <b>{{creditValue}}</b>.",
  "infoBanner": "Please visit the Hopper App if you experience difficulty using any self-service tools, this booking type is not yet fully supported",
  "resendEmailModal": {
    "cancel": "Cancel",
    "emailType": {
      "cancellation": "Cancellation",
      "confirmation": "Confirmation",
      "label": "Email Type"
    },
    "failure": {
      "title": "There was an error.",
      "subtitle": "Your email was not sent!"
    },
    "instructions": "Tell us where you’d like your email resent to",
    "processing": "Resending email...",
    "success": {
      "title": "Success!",
      "subtitle": "Your email has been resent."
    },
    "submit": "Resend",
    "title": "Resend Email"
  },
  "retry": "Retry",
  "reviewNewItinerary": "Review your new itinerary",
  "roundTripFlight": "Round-trip Flight",
  "scheduleChange": {
    "badge_major": "Major change",
    "badge_minor": "Minor change",
    "badge_alternatives": "Finding alternatives",
    "majorChangeModalDescription": "Your booking has been modified by the airline. Please confirm the alternative flight or select a new time preference by {{expDate}} when we will automatically accept the update on your behalf. This change is free for you.",
    "majorLabel": "<b>Your flight has experienced an itinerary change.</b> Review the changes to your itinerary by {{expDate}}.",
    "majorLabel_outbound": "<b>Your outbound flight has experienced an itinerary change.</b> Review the changes to your itinerary by {{expDate}}.",
    "majorLabel_return": "<b>Your return flight has experienced an itinerary change.</b> Review the changes to your itinerary by {{expDate}}.",
    "majorChangeModalDesc": "Your booking has been modified by the airline. Please confirm the alternative flight or select a new time preference by {{expDate}} when we will automatically accept the update on your behalf. This change is free for you.",
    "minorLabel": "<b>The airline made a minor modification to your itinerary.</b>",
    "minorTooltipModification": "A modification has been made to your itinerary. Your {{flightType}} from <strong>{{origin}}</strong> to <strong>{{destination}}</strong> has changed. This flight now departs at <strong>{{departure}}</strong> and returns at <strong>{{return}}</strong>",
    "minorTooltipCancellation": "A modification has been made to your itinerary. Your {{flightType}} flight has been cancelled",
    "originalFlight": "Original itinerary",
    "originalFlight_outbound": "Original outgoing flight",
    "originalFlight_return": "Original return flight",
    "reviewChange": "Review change",
    "reviewScheduleChange": "Review schedule change",
    "subtitle": "A change was made by the airline to your upcoming booking. Review and confirm to approve the change. If you refuse, you will be invited to select a new time. You have 24 hours to accept or refuse the change. If you do not make a selection during this time frame, the new itinerary will be accepted on your behalf.",
    "updatedFlight": "Updated itinerary",
    "updatedFlight_outbound": "Updated outgoing flight",
    "updatedFlight_return": "Updated return flight",
    "minorScheduleChangeDescription": "The airline has made a modification to your itinerary. Your departing flight from <b>{{origin}}</b> to <b>{{destination}}</b> has changed. An updated itinerary has been sent to your email address <b>{{email}}</b>, all conditions of your booking remains unchanged you do not need to do anything."
  },
  "scheduleChangeFormTitles": {
    "acceptButtonTitle": "Accept this change",
    "acceptDetails": "We will confirm this new flight and send you a confirmation email. ",
    "denyButtonTitle": "Deny this change",
    "denyDetails": "An agent will try to find a comparable flight. If unsuccessful, we'll cancel the ticket and seek a refund, subject to airline approval.",
    "headingCopy": "How would you like to proceed with this change?",
    "headingOutboundAndReturn": "<strong>Accept</strong> or <strong>Refuse</strong> the change to your new <strong>Outbound</strong> and <strong>Return</strong> Flights",
    "headingOutboundOrReturn": "<strong>Accept</strong> or <strong>Refuse</strong> the change to your new <strong>{{flightType}}</strong> Flight",
    "subheading": "You have 24 hours to accept or refuse the change. If you do not make a selection during this time frame, the new itinerary will be accepted on your behalf.",
    "timePreference": "What time do you prefer for your new {{flightType}} flight?"
  },
  "scheduleChangeRequestedModal": {
    "acceptedSubtitle": "A confirmation email will be sent shortly.",
    "acceptedTitle": "Change complete!",
    "confirmationSubtitle": "A customer service agent will contact you within 24 hours to help find a comparable flight.",
    "confirmationTitle": "We've received your new flight time request.",
    "contactSupportSubtitle": "For assistance with resolving the schedule change to your booking, please contact our support team by {{expiryDate}}.",
    "contactSupportTitle": "We are here to help you with your schedule change",
    "failureSubtitle": "We were unable to process your schedule update."
  },
  "times": {
    "afternoon": "Afternoon",
    "earlyMorning": "Early Morning",
    "evening": "Evening",
    "morning": "Morning"
  },
  "tooltip": {
    "cancelled": "The airline has cancelled this flight. $t(tooltip.viewSchedule)",
    "modified": "The airline has modified this flight. $t(tooltip.viewSchedule)",
    "pending": "Your booking is still being processed. You'll receive an email when your booking is confirmed.",
    "viewSchedule": "View schedule update to accept or refuse your new itinerary. If you refuse, you will be invited to select a new itinerary. You have 24 hours to accept or refuse the change. If you do not make a selection during this time frame, the new itinerary will be accepted on your behalf.",
    "problem": "There was a problem with your booking. For any questions regarding your trip, please contact our support team and we'd be happy to help."
  },
  "travelerInformationModal": {
    "guestInformation": "Guest Information"
  },
  "travelerSummaryLabel": "Travelers",
  "tripReviewLinks": {
    "cancelFlight": "Cancel Flight",
    "cancelCar": "Cancel Car Reservation",
    "changeFlight": "Change Flight",
    "checkInForFlight": "Check-in for your flight",
    "contactSupport": "Contact Support",
    "getHelp": "Get help",
    "manageTrip": "Manage trip",
    "resendEmail": "Resend Email",
    "disruptionExercise": "Get help with a disrupted flight",
    "missedConnectionExercise": "Get help with a missed connection"
  },
  "tripTotal": "Trip Total",
  "priceBreakdownDescription": "Round-trip fare per traveler (including taxes and fees *Child/Infant calculated at checkout)",
  "confirmationSent": "Confirmation will be sent to:",
  "checkInViaAirline": "Check in via airline",
  "airportNameAndCode": "{{airportName}} ({{airportCode}})",
  "itineraryBookingInfoDatetime": "{{date}} {{time}}",
  "departureDateAndDuration": "{{departureDate}} ({{duration}})",
  "trips": "My Trips",
  "tripsListErrorSubtitle": "Refresh and try again.",
  "tripsListErrorTitle": "We are having trouble loading this page",
  "tripsLoading": "Loading exchange policy...",
  "tripsLoadFailedSubtitle": "Please try again or contact support.",
  "tripsLoadFailedTitle": "We couldn't load your flight change information",
  "tripsSubtitle": "View and manage upcoming and past trips",
  "upcomingFilterButton": "Upcoming",
  "upcomingTripsSubtitle": "Items in this list are ordered based on the most upcoming departure, check-in, and pickup dates.",
  "upcomingTripsTitle": "Upcoming Trips",
  "upcomingTripsLoadErrorTitle": "Unable to load upcoming trips.",
  "viewPreviousItinerary": "View previous itinerary",
  "viewing": "Viewing",
  "voidable": "Cancel this flight free of charge",
  "voidableSubtitleDefault": "Avoid change fees by canceling and making a new booking.",
  "voidableSubtitleEndDate": "Avoid change fees by canceling before {{endDate}} and making a new booking.",
  "watchedTripsSubtitle": "Items in this list are ordered based on the most upcoming departure dates",
  "watchedTripsTitle": "Watched Trips",
  "watchedTripsLoadErrorTitle": "Unable to load watched trips.",
  "tripCategoryFromOrigin": "{{tripCategory}} from {{origin}}",
  "tripPriceFreezeDetails": {
    "title": "Your Active Price Freeze",
    "subtitle": "Ready to book your flight? This Price Freeze expires on",
    "currentPrice": "Current price",
    "frozenPrice": "Frozen price",
    "passengerTitle": "Frozen for",
    "confirmationTitle": "Confirmation number",
    "copy": "Copy",
    "continueCta": "Continue to booking",
    "fareCapReached": "You hit the maximum savings of {{capAmount}} per ticket. If you book now, your ticket price will be <i>{{chargedTripPricePerPax}}</i>."
  },
  "manageMyTrip": "Manage my trip",
  "passengerCount_one": "{{count}} Passenger",
  "passengerCount_other": "{{count}} Passengers",
  "tripSummary": "Trip summary",
  "disruptionProductDelay": "delay",
  "disruptionProductMissedConnection": "missed connection",
  "payment": "Payment",
  "priceFreezeButton": "Price freeze",
  "priceWatchButton": "Price watch",
  "fetchWatchDetails": "Fetching watch details",
  "fetchWatchDetailsErrorTitle": "Failed to load Flight Watch",
  "fetchWatchDetailsErrorSubtitle": "Oops! Looks like we failed to load your price watch details, please go back and try again.",
  "watch": {
    "bookNowCTA": "Book now",
    "bookNowTagLabel": "Book now",
    "waitTagLabel": "Wait",
    "errorModalTitle": "Something went wrong.",
    "stopWatchSuccessModal": "You are no longer watching this flight.",
    "stopWatchModalTitle": "Flight watch notification",
    "stopWatchButtonLabel": "Yes, stop watching this flight",
    "cancelWatch": "Cancel watch",
    "emailAddress": "Email address",
    "changeEmailConfirmationModalTitle": "Change email address",
    "changeEmailConfirmationModalSubtitle": "You are currently watching this trip. Enter your email address to receive notifications for this trip.",
    "changeEmailSuccessModalTitle": "Email updated",
    "changeEmailSuccessModalSubtitle": "We have successfully updated your email address. Notifications will now be sent to {{email}}. Changing the email for this trip does not have an impact on the other trips being watched.",
    "flightWatchChangeEmailButtonLabel": "Change email",
    "flightWatchStopWatchingButtonLabel": "Stop watching",
    "changeEmailMessage": "You are currently watching this trip. Enter your email address to receive notifications for this trip.",
    "unwatchMessage": "Are you sure you want to stop watching this flight? You will no longer receive notifications when the price changes.",
    "flightWatchSearchFlightButtonLabel": "Search flight",
    "flightWatchStopsLabel": "Stops"
  },
  "reservationCanceled": "This reservation has been canceled.",
  "checkIn": "Check-in",
  "checkOut": "Check-out",
  "hotel": "Hotel",
  "howRefundsWorkTitle": "How do refunds work?",
  "howRefundsWorkSubtitle": "If eligible, a refund will be issued to your original payment method and should be received within the next 1-2 billing cycles.",
  "hotelTripsLinks": {
    "changeReservation": "Change Hotel Reservation",
    "cfar": "Cancel For Any Reason",
    "cancelReservation": "Cancel Hotel Reservation"
  },
  "hotelCard": {
    "cfarCancellationPrimaryText": "{{percentage}}% refundable",
    "cfarCancellationSecondaryText": "Your room is refundable. Cancel For Any Reason up until your scheduled check-in time and get a refund for {{percentage}}% of your hotel base rate and taxes and fees. Cancellations made after this period are subject to a penalty according to the hotel's policy.",
    "premierCollectionBenefitsTitle": "Premier Collection Benefits",
    "premierCollectionBenefitsList": "<ul class='benefits-list'><li class='benefits-list-item'><span>Enjoy a <strong>{{credit}} experience credit</strong></span></li><li class='benefits-lis-item'><span>Daily <strong>breakfast for 2</strong> and complimentary <strong>WiFi</strong></span></li></ul>",
    "roomType": "Room Type"
  },
  "night_one": "{{count}} night",
  "night_other": "{{count}} nights",
  "roomCapacityGuest_one": "Room fits 1 guest",
  "roomCapacityGuest_other": "Room fits {{count}} guests",
  "tripSearch": {
    "findBooking": "Find booking",
    "findBookingTitle": "Look up your booking without signing in",
    "lastName": "Last name",
    "confirmationCode": "Confirmation code",
    "resConfirmCode": "Reservation Confirmation Code",
    "searchResultsHeader": "Search results for",
    "errorTitle": "Sorry, we couldn’t retrieve any trip details.",
    "errorMessage": "It looks like the trip lookup timed out. Please refresh your page and try again.",
    "emptyStateTitle": "Sorry, we couldn’t find any trip associated with those details.",
    "emptyStateMessage": "Please check the last name and confirmation code and try again.",
    "deletedUserMessage": "It looks like we can't find your account, please contact our support team for assistance finding your trip.."
  },
  "contactSupportModal": {
    "title": "Get in touch and we'd love to help!",
    "subtitle": "For information regarding seats, baggage, changes, cancellations, and refunds",
    "helpCenterLink": "Visit the Help Center",
    "helpCenterUrl": "https://help.hopper.com",
    "forOtherEnquiries": "For other enquiries, please contact our support team",
    "basicSupportId": "Your Priority Support ID",
    "vipSupportId": "Your VIP Priority Support ID",
    "loginForSupportId": "Please login and contact support from 'My Trips' to receive a Priority Support ID for this booking",
    "chatTitle": "Live chat with an agent",
    "tollFreeNumTitle": "Toll-Free from US / Canada / Skype",
    "tollFreeNumTitle_wrap": "Toll-Free from <br />US / Canada / Skype",
    "tollFreeNum": "+1-833-933-HOP1",
    "tollFreeNumFull": "(+1-833-933-4671)",
    "intlNumTitle": "International Customers",
    "intlNum": "+1-347-695-4555"
  },
  "paidAtBooking": "Paid at time of booking",
  "additionalServiceFee": "Additional Service Fee (Due at check-in)",
  "confirmationNumber": "Confirmation number",
  "copy": "Copy",
  "airlineConfirmationNumber": "Airline confirmation number",
  "dates": "Dates",
  "flightsTripPricingModalHeader": "Trip total",
  "flightsTripPricingModalSubheader": "Trip total",
  "address": "Address",
  "chatTitle": "Chat",
  "contactSupportMethod": "How would you like to contact support today?",
  "contactSupportChangeOrCancel": "To change or cancel this reservation, please contact our customer support team and someone will assist you.",
  "offerApplied": "Offer applied",
  "hotelDetailsViewMapButtonLabel": "View map",
  "tripsPaymentMethodTitle": "Payment method",
  "tripsItineraryTitle": "Itinerary",
  "bookingConfirmationTitle": "Booking confirmation:",
  "core-trips": {
    "breadcrumbs": {
      "home": "Home"
    }
  },
  "estimatedRefundAmount": "Estimated refund amount",
  "baggage": "Extra checked baggage",
  "baggageCount_one": "{{count}} piece of baggage",
  "baggageCount_other": "{{count}} pieces of baggage",
  "invoiceGeneration": {
    "title": "Issue receipt",
    "recipientName": "Recipient name",
    "recipientNamePlaceholder": "John Doe",
    "recipientNameHint": "Provide recipient name or company name",
    "generateButton": "Generate receipt",
    "submitButton": "Issue receipt",
    "informationListBulletOne": "A receipt that meets the requirements of the invoice system will be issued",
    "informationListBulletTwo": "Please be careful not to make any mistakes",
    "faqLinkDescription": "For details about receipts, please check the FAQ page. <0>\"I want to issue a receipt\"</0>",
    "addressInclusion": "Include property's address on the receipt"
  },
  "invoice": {
    "title": "Receipt",
    "date": "Publication date: {{date}} ",
    "customerName": "Attn: {{name}} ",
    "paymentAmount": "Payment amount",
    "paymentAmountDisclaimer": "Inclusive of service usage fees, etc.",
    "breakdownTitle": "Breakdown",
    "creditCardPaid": "Credit card payment amount",
    "pointsPaid": "Point usage amount",
    "tripCreditPaid": "Trip credit usage amount",
    "walletOfferPaid": "Coupon usage amount",
    "taxableTitle": "Taxable",
    "notSubjectToTax": "Not subject to tax",
    "tenPercentSubject": "10% taxable",
    "reservationTitle": "Reservation information",
    "reservationDate": "Reservation date",
    "airline": "Airline",
    "rentalCarCompany": "Rental car company",
    "accommodation": "Accommodation",
    "accommdationAddress": "Accommodation address",
    "checkInDate": "Check-in date",
    "checkOutDate": "Check-out date",
    "pickUpDate": "Pick-up date",
    "dropOffDate": "Drop-off date",
    "departureDate": "Departure date",
    "returnDate": "Return date",
    "numberOfGuests": "Number of guests",
    "signOff": "Thank you for using our service"
  },
  "ryanairBooking": {
    "title": "Ryanair booking",
    "subtitle": "To make changes or check in, you'll be directed to Ryanair's website, where you'll need to log in.",
    "actionText": "Visit Ryanair.com"
  },
  "uber": "Uber",
  "confirmationCodeLabelAndCode": "Confirmation code: <0>{{code}}</0>",
  "manageBooking": {
    "title": "Manage booking"
  },
  "perPaxDisclaimerText": "Prices shown are on a per passenger basis.",
  "costPerTraveler": "<b>+ {{cost}}</b>/traveler",
  "disruptionPurchase": {
    "header": "Delay + cancellation guarantee",
    "MissedConnection": "Missed Connection",
    "Delay": "Delay",
    "Cancellation": "Cancellation",
    "Guarantee": "Guarantee™",
    "description": "1 in 4 flights gets delayed or cancelled",
    "subtitle": "If your flight is delayed for more than 90 minutes or cancelled by the airline during your trip, your flight is free.",
    "airlineAgreementSubtitle": "If your flight is delayed for more than 90 minutes or cancelled by the airline during your trip, your flight is free. Hopper Travel will cover the cost of a new flight on {{airline}} or refund you immediately.",
    "rebookTitle": "Rebook a new flight on any airline",
    "rebookDescription": "Rebook a new flight on any airline, choosing from same or next day flights",
    "refundTitle": "Or get a full refund of your ticket cost",
    "refundDescription": "Get a full refund of your ticket cost, no forms or waiting in line required",
    "fullCoverageDescription": "Rebook a new flight on any airline, or get a full refund of your ticket cost",
    "costPerPassenger": "{{cost}} per passenger",
    "acceptCta": "Add to trip",
    "declineCta": "No thanks",
    "fullCoverage": "Full coverage",
    "noCoverage": "No coverage"
  },
  "disruptionProtection": {
    "header": "Premium Disruption Assistance",
    "description": "If you experience a delay of more than {{hours}} hours or if your flight is canceled on the day of travel, you can:"
  },
  "flightDelayGuarantee": {
    "header": "Flight Delay Guarantee",
    "mobileHeader": "1 in 5 flights gets delayed or canceled",
    "headerSubtext": "<b>Did you know?</b> 1 in 5 flights gets delayed or canceled",
    "fullCoverageTitle": "Delays and Cancellations",
    "partialCoverageTitle": "Delays only",
    "noCoverageTitle": "I do not want to purchase Flight Delay Guarantee",
    "description": "If your flight is delayed for more than 1 hour or cancelled by the airline on the day of travel, your flight becomes free. Hopper will cover the cost of a new flight or refund you immediately.",
    "customerReview": "“My flight was delayed over an hour and Hopper came through as promised! Definitely recommended it to my family and friends.”",
    "customerName": "Lauren",
    "customerSavings": "saved $598",
    "recommended": "Recommended",
    "noCoverageDescription": "Decline Delay Guarantee",
    "learnMoreTitle": "If any of your flights are delayed or canceled on the day of travel, we can help!",
    "learnMoreContent": "With Hopper’s Flight Delay Guarantee™ if any of your flights are delayed for more than 90 minutes or canceled by the airline while traveling, you can book a new flight to your destination on any airline directly on the Hopper website with a 100% satisfaction guarantee. We cover the full ticket cost (up to $2,000 USD). <p>If you are not happy with the rebooking options provided we will instantly refund you the cost of your original ticket.</p>For additional details, please review the",
    "termsAndConditions": "Terms & Conditions"
  },
  "cfar": {
    "header": "Cancel For Any Reason",
    "description1": "<b>Cancel up to 3 hours before departure</b> - truly for any reason",
    "description2": "<span style='font-weight:bold; color:#4C9C35;'>Get {{percent}}% cash refund</span> of your flight base fare and taxes",
    "description3": "Cancel the trip yourself via our self-serve option",
    "fullCoverageTitle": "100% ticket cost covered",
    "partialCoverageTitle": "80% ticket cost covered",
    "noCoverageTitle": "I do not want to purchase Cancel For Any Reason",
    "noCoverageDescription": "Decline Cancel For Any Reason",
    "mostPopular": "Most popular",
    "learnMoreTitle": "Add the flexibility to cancel your flight - truly for any reason!",
    "learnMoreContent": "Booking a flight is easy. Canceling a flight should be too. That's why we offer <b>Cancel For Any Reason</b>. If you decide to cancel your flight you will get 100% of your flight cost back as an airline credit with no rebooking fees. If airline credit is not available you'll get a refund for 100% or 80% of your flight back on your original form of payment. Psst - <b>Cancel For Any Reason<b> is only available at booking. For additional details on the plan, please review the ",
    "termsAndConditions": "Terms & Conditions",
    "informationalDisclaimer": "Your flight is non-refundable in cash, but you may be eligible for travel credit from the airline if you cancel (less any cancellation penalties). Flex It provides an alternative refund option."
  },
  "traveler": "traveler",
  "disruptionDisclaimerText": "Prices shown are on a per passenger basis.",
  "providedBy": "provided by",
  "disruptionInfoModal": {
    "header": "About delay + cancellation guarantee",
    "title": "If any of your flights are delayed or cancelled on the day of travel, we can help!",
    "description": "<p>With Flight Delay Guarantee if any of your flights are delayed for more than 90 minutes or canceled by the airline while traveling, you can book a new flight to your destination on any airline directly in the Uber Travel portal with a 100% satisfaction guarantee. We cover the full ticket cost (up to $t(brand:currency.symbol)3,000). If you are not happy with the rebooking options provided we will instantly refund you the cost of your original ticket.<p>",
    "descriptionAdditional": "For additional details, please review the <0>Terms and Conditions</0>"
  },
  "missedConnectionInfoPopup": {
    "header": "Missed connection guarantee",
    "title_one": "Your trip has {{count}} connection",
    "title_other": "Your trip has {{count}} connections",
    "description": "If you miss a connecting flight or your flight is cancelled by the airline during your trip, your flight becomes free.",
    "airlineAgreementDescription": "If you miss a connecting flight or your flight is cancelled by the airline during your trip, your flight is free. Hopper Travel will cover the cost of a new flight on {{airline}} or refund you immediately.",
    "extendProtection": "Extend your protection to connecting flights with Missed Connection Guarantee™",
    "moreInformation": "<p>With our Missed Connection Guarantee™, if you miss a connecting flight or have a flight canceled by the airline while traveling, you can book a new flight to your destination on any airline directly in the Uber Travel portal with a 100% satisfaction guarantee. We cover the full ticket cost (up to $t(brand:currency.symbol)3,000). If you are not happy with the rebooking options, we will instantly refund you the cost of your original ticket.</p><p>Flight Delay Guarantee and Missed Connection Guarantee cover different things. If you experience multiple eligible disruptions on your multi-flight trip (such as a delay of more than 90 minutes that causes you to miss your connection) you can use both products to rebook two flights. However you can only receive one service satisfaction guarantee refund of the entire multi-flight trip per booking.</p>",
    "noCoverageDescription": "Flights subject to change fees"
  },
  "customizeYourTrip": "Customize your trip",
  "howItWorks": "How it works",
  "viewTerms": "View Terms",
  "costPerPassenger": "<p><b>{{cost}}</b> per passenger</p>",
  "learnMore": "Learn more",
  "learnMoreAdditional": "about how Flight Delay Guarantee and Missed Connection Guarantee work together to give you maximum protection!",
  "acceptCta": "Add to trip",
  "declineCta": "Next",
  "descriptionAdditional": "For additional details, please review the ",
  "disruptionTerms": {
    "title": "Terms and conditions: delay + cancellation guarantee"
  },
  "missedConnectionTerms": {
    "title": "Terms and conditions: missed connection guarantee™"
  },
  "termsLink": "here",
  "flightsDisruptionGuaranteeHeader": "Flight Disruption Guarantee",
  "flightDisruptionGuaranteeSubtitle": "We're here to help if you experience a flight disruption while traveling.",
  "ScheduleChangeDisruptionProtection": "Flight Delay Guarantee",
  "MissedConnectionDisruptionProtection": "Missed Connection Guarantee",
  "VipSupport": "Vip Support",
  "unavailableProductSingle": "{{products, list}} was not added to the trip. You can still continue booking the flight without the additional product, or go back to select a different flight to add the additional product again.",
  "unavailableProductsMultiple": "{{products, list}} were not added to the trip. You can still continue booking the flight without the additional products, or go back to select a different flight to add the additional products again.",
  "vipSupport": {
    "header": "Support",
    "vipTitle": "Skip the line with VIP",
    "vipSubtitle": "Instant response times",
    "basicTitle": "Basic",
    "basicSubtitle": "No overnight response times"
  },
  "cfarOffers": {
    "title": "Cancel For Any Reason",
    "learnMore": "Learn more",
    "subtext": "Add the flexibility to cancel your flight for any reason up until 3 hours before departure.",
    "fullCoverageTextNoFtc1": "100% refund of your ticket cost",
    "fullCoverageTextNoFtc2": "Instant resolution in the Uber app",
    "fullCoverage": "Full coverage",
    "partialCoverage": "Partial coverage",
    "noCoverage": "No coverage",
    "fullCoverageText1": "100% refund in airline travel credit",
    "fullCoverageText2": "If not available, get 100% cash refund",
    "fullCoverageText3": "Instant resolution in the Uber app",
    "partialCoverageTextNoFtc1": "80% refund of your ticket cost",
    "partialCoverageTextNoFtc2": "Instant resolution in the Uber app",
    "partialCoverageText1": "100% refund in airline travel credit",
    "partialCoverageText2": "If not available, get 80% cash refund",
    "partialCoverageText3": "Instant resolution in the Uber app",
    "noCoverageText": "Flights subject to cancellation fees",
    "offerTitle": "{{coveragePercentage}}% ticket cost covered",
    "offerText": "{{currency}}{{coverageCost}}/passenger",
    "disclaimerText": "Prices shown are on a per passenger basis.",
    "coverageButtonText": "Add to trip",
    "declineCoverageButtonText": "Next",
    "loadingText": "Cancel For Any Reason...",
    "errorButtonText": "Try again",
    "restrictionsCfarText": "You added Cancel For Any Reason to your trip",
    "learnMoreHeader": "About Cancel For Any Reason",
    "learnMoreTitle": "Add the flexibility to cancel your flight - truly for any reason!",
    "learnMoreDescription": "<p>Booking a flight is easy. Cancelling a flight should be too. That's why we offer <b>Cancel For Any Reason</b>. </p><p>If you decide to cancel your flight you will get 100% of your flight cost back as an airline credit with no rebooking fees. If airline credit is not available you'll get a refund for 100% or 80% of your flight back on your original form of payment. </p><p>Psst - <b>Cancel For Any Reason</b> is only available at booking.</p>",
    "learnMoreDescription2": "For additional details on the plan, please review the <0>Terms and Conditions</0>"
  },
  "selectAnOption": "Select an option",
  "chOffer": {
    "title": "Change for any reason",
    "subtext": "Change your dates, origin, destination, airline, or trip type up until departure.",
    "fullCoverageText1": "100% original ticket cost covered",
    "fullCoverageText2": "Instantly change your flight in the app",
    "noCoverageText": "Flights subject to change fees",
    "coverageButtonText": "Add to trip",
    "declineCoverageButtonText": "Next",
    "learnMoreHeader": "About Change for any reason",
    "learnMoreTitle": "Add the flexibility to change your flight - truly for any reason!",
    "learnMoreDescription": "With Change for any reason from Uber Travel, you can change the date or time of your flight <b>for any reason</b> up to departure. If you make a change Uber Travel will cover up to the cost of your original ticket with <b>any airline</b>.</p><p>Change your flight to depart within <b>1 year</b> before or after your original departure date.</p><p><b>How do I make a change to my booking? </b>It's easy! With just a few taps on your phone you can change your flight without talking to customer support or the airline.</p><p>Psst, this option is only available at booking.",
    "learnMoreDescription2": "For additional details on the plan, please review the <0>Terms and Conditions</0>",
    "fullCoverage": "Full coverage",
    "noCoverage": "No coverage",
    "restrictionsChfarText": "You added Change for any reason to your trip"
  },
  "howItWorksDialog": {
    "dialogTrigger": "How it works"
  },
  "core-disruption": {
    "productName": "Premium Disruption Assistance",
    "bodyOne": "If your flight is canceled or delayed for {{hours}}+ hours on the day of travel, we'll proactively notify you and then:",
    "bodyTwo": "<0>We'll rebook you on a new flight</0> on any airline (up to {{maxAmountCovered}} per traveler); or",
    "bodyThree": "Get a <0>{{maxAmountRefunded}} refund per traveler</0> and keep your original reservation, if you are not happy with the rebooking options",
    "bodyFour": "Use our self-serve tools or speak to an agent!",
    "addToTrip": "Add to my trip",
    "costPerTraveler": "<0>+ {{cost}}</0>/traveler",
    "noThanks": "No, thanks",
    "noThanksDescription": "I don’t want to add this option",
    "addedForPerTraveller": "Added for <0>+ {{cost}}</0>/traveler",
    "addedForTravellerLeadIn": "Added for ",
    "declined": "No thanks, I don’t want to add this option",
    "offerCTA": {
      "continueWithSelectedOffer": "Add and continue",
      "continueWithSelectionShowingPrice": "Add to my trip | +{{cost}}",
      "continueWithoutSelection": "Continue",
      "pleaseMakeSelectionToContinue": "Please select an option to continue"
    },
    "edit": "Edit",
    "howItWorksDialog": {
      "title": "We’re here to help with flight disruptions – satisfaction guaranteed!",
      "subtitle": "If you experience a delay of more than {{minDelayHoursThreshold}} hours or if your flight is canceled on the day of travel, you can:",
      "portalName": "Portal",
      "bullets": {
        "one": "<0>Rebook on any airline</0> through {{portalName}} (up to {{maxAmountCovered}} per traveler).",
        "two": "If you are not happy with the available rebooking options, {{portalName}} will <0>refund 100%</0> of your trip cost (base fare + taxes) – no questions asked. Getting a refund does not impact your original reservation with the airline.",
        "three": "Get help using our self-serve tools or speak to an agent!"
      },
      "importantInformation": {
        "title": "Important information before you book:",
        "one": "The service may only be used <0>once per trip booking</0>.",
        "two": "You may already be entitled to certain <0>benefits from the airline</0> if your flight is disrupted without purchasing the service."
      },
      "footer": {
        "one": "<0>{{productName}}</0> is a rebooking service and is not an insurance product; for more information, please <1>see here.</1>",
        "two": "For additional details on the service, please review the full <0>Terms & Conditions.</0>"
      },
      "close": "Close"
    },
    "disruptionUniversalExercise": {
      "termsAndConditions": "Terms & Conditions",
      "needHelp": "Need help?",
      "contactSupport": "Contact support",
      "requestRefund": "Request a refund",
      "continue": "Continue",
      "learnMore": "Learn more",
      "or": "or",
      "defaultLoadingMessage": "Loading...",
      "hours": "{{numberOfHours}} hours",
      "notEligiblePage": {
        "hours": "hours",
        "hour": "hour",
        "title": "We've got your back if your flight is delayed or cancelled",
        "subtitleWithRebookingLimit": "If your flight is delayed +{{delayHours}} {{numberOfHours}} or cancelled on the day of travel, you can rebook on any airline for free (up to {{rebookLimit}} per traveler) using our rebooking tool. If you are not happy with our rebooking options, get a 100% refund of your trip cost (base fare + taxes) and keep your original reservation.",
        "faqSection": {
          "title": "Frequently asked questions:",
          "question1": "What type of disruptions allow me to use the service?",
          "answer1": "&nbsp;&nbsp;&nbsp;• A delay for more than the time specified on your service, measured from the original scheduled departure time of your flight.<br/>&nbsp;&nbsp;&nbsp;• An involuntary cancellation of your flight.<br/><br/>The disruption must occur in the 24 hours prior to your flight’s originally scheduled departure.",
          "question2": "How will I be notified in the case of a disruption?",
          "answer2": "We will monitor your flight and, if you experience a disruption, will notify you via email to present your options:<br/><br/>&nbsp;&nbsp;&nbsp;• A rebooking on one of the alternatives offered through our self-serve solution or directly from our support team. <br/>&nbsp;&nbsp;&nbsp;• A refund if you don’t like the rebooking options. In that case, you can keep your original flight and/or any other solution provided to you by the airline.",
          "footer2": "Questions about notifications?",
          "question3": "What rebooking alternatives will be offered?",
          "answer3": "You will be presented with a set of alternative flight options:<br/><br/>&nbsp;&nbsp;&nbsp;• From the same origin city to the same destination city<br/>&nbsp;&nbsp;&nbsp;• On the same day or next day following your initial flight departure<br/>&nbsp;&nbsp;&nbsp;• In the same or similar corresponding fare class as the original booking<br/>&nbsp;&nbsp;&nbsp;• With a price per passenger below the service cap<br/><br/>In some circumstances, there may be no alternative flight options available. In that case, you may choose to receive a refund of your base fare and taxes.",
          "footer3": "Questions about service expiration?",
          "question4": "Does the service expire?",
          "answer4": "If unused, the service will expire 24 hours after the last flight of your booked trip. The service may be used only once on each itinerary; if you experience a disruption on your originally scheduled flight and elect to use the service, you will not be able to use it again if you experience a disruption on a different flight later in your trip.",
          "footer4": "Questions about service expiration?",
          "question5": "I have experienced a disruption, but have not received any notification. What should I do?",
          "answer5": "If you believe you have experienced a disruption, but have not received a notification from us, please contact us by clicking on “Contact support” below.<br/><br/> Please keep in mind that the disruption event must occur within 24 hours from your original scheduled departure to be able to use the service. If that's not the case, please contact the airline to discuss your rebooking options.",
          "footer5": "Report a flight disruption?",
          "question6": "I have received a disruption notification, but I can't access my options. What should I do?",
          "answer6": "If you have been notified about a flight disruption, but you are not able to access your options from this page, please contact us by clicking on 'Contact support' below.<br/><br/> Please keep in mind that the disruption event must occur within 24 hours from your original scheduled departure to be able to use the service. If that's not the case, please contact the airline to discuss your rebooking options.",
          "footer6": "Questions about your options?",
          "question7": "Is the service fee refundable?",
          "answer7": "If you purchased the service by accident and would like to request a refund, please contact us by clicking on 'Contact support'.",
          "footer7": "Purchased the service by accident?"
        }
      },
      "landingPage": {
        "title": "We've detected a delay or cancellation",
        "subtitleWithRebookingLimit": "Rebook on any airline for free (up to {{rebookLimit}} per traveler) using our rebooking tool. If you are not happy with our rebooking options, get a 100% refund of your trip cost (base fare + taxes) and keep your original reservation.",
        "chooseBetween": "Choose between:",
        "rebookOptionHeader": "Use your Premium disruption assistance:",
        "rebookOptionTitle": "Rebook my flight",
        "exerciseOptionDivider": "Or",
        "rebookAndKeepOptionHeader": "Not happy with these rebooking options?",
        "rebookAndKeepOptionTitle": "Get a refund and keep your reservation",
        "refundOptionTitle": "Get a refund",
        "refundOptionSubtitle": "Get a refund of your flight base fare and taxes and keep your original reservation.",
        "checkedBagOptionTitle": "Do you have checked bags?",
        "checkedBagOptionsYes": "Yes",
        "checkedBagOptionsNo": "No",
        "checkedBagModal": {
          "title": "Important notice on checked bags",
          "bodyParagraph1": "Since you already have checked-in bags on your disrupted flight with the airline, they must be retrieved and checked in again on your new flight. To do so, please visit the airline's check-in counter at the airport.",
          "bodyParagraph2": "We cannot guarantee that your bags will be retrieved in time to check them for your new flight.",
          "goBack": "Go back",
          "continue": "Continue and manage my own bags"
        },
        "polciyDetails": {
          "title": "Your service details",
          "eventsCovered": "Service information",
          "delayThreshold": "Delay threshold",
          "policyStatus": "Status",
          "policyExpiration": "Expiration",
          "rebookingLimit": "Rebooking limit",
          "viewDetails": "<0>View </0><1>Terms & Conditions</1>",
          "hours": "+{{delayThreshold}} hours",
          "perTraveler": "{{rebookingLimit}} per traveler",
          "notEligible": "Not eligible",
          "eligible": "Eligible",
          "delays": "Delays",
          "missedConnections": "Missed Connections",
          "cancellations": "Cancellations"
        }
      },
      "refundReviewPage": {
        "loadingMessage": "Your refund is being processed",
        "confirmAndGetRefund": "Confirm refund request",
        "confirmRefundRequest": "Confirm refund request",
        "forMoreDetailsAbout": "<0>For more details about the service, please see</0> <1>here.</1>",
        "moreDetailsAboutYourService": "More details about your service",
        "forMoreInformationOn": "For more information on Carrot Cash view Hopper’s Terms of Service",
        "hopperCarrotCashCan": "<b>Hopper Carrot Cash</b> can be used on pre-paid Air, Hotel or Car bookings and is good for up to one year. Cannot be used on United Airlines flights.",
        "ifYouUsedAny": "If you used any alternative payment method (e.g.: travel credit, rewards...) these will be instantly returned to your account",
        "importantInformation": "Important Information",
        "keepYourCurrentFlight": "Getting a refund will not impact your original reservation with the airline.",
        "premiumDisruptionAssistance": "Premium Disruption Assistance",
        "providedBy": "Provided by",
        "rebookingIsntAvailableAfter": "Rebooking isn’t available after refund is requested",
        "refundMethod": "Refund Method",
        "refundToCard": "Refunded to {{cardDisplay}}",
        "refundToCredit": "Refund to credit",
        "refundsTypicallyTake3": "Refunds typically take 3 to 5 days to process",
        "theReimbursementWillBe": "The reimbursement will be issued to the same payment method as the original booking",
        "totalRefund": "Total refund",
        "travelCreditRefund": "Travel credit refund",
        "youllReceiveARefund": "You’ll receive a refund back to your original payment method.",
        "cashRefundTakes": "Cash refunds may take 7 to 10 business days. If you used travel credits and/or rewards on your purchase, these will be instantly returned to your account",
        "rewardsRefund": "Rewards refund",
        "creditBalance": "Refunded to credit balance",
        "accountBalance": "Refunded to account balance",
        "pointsRefund": "Points refund"
      },
      "refundConfirmationPage": {
        "title": "Refund successful!",
        "subtitle": "Thanks for using {{productName}} – Your refund has been processed back to your original payment method. A confirmation email will be sent shortly to {{email}}.",
        "confirmCta": "Done"
      },
      "rebook": {
        "hours": "{{hours}} hrs",
        "hoursSingular": "{{hours}} hr",
        "direct": "Direct",
        "stops": "{{stops}} stops",
        "stopsSingle": "{{stops}} stop",
        "stops_one": "{{stops}} stop",
        "stops_other": "{{stops}} stops",
        "outboundHeadline": "<b>Outbound</b> to {{destination}} ({{airport}}) on {{date}}",
        "returnHeadline": "<b>Return</b> to {{destination}} ({{airport}}) on {{date}}",
        "flightTime": "{{fromTime}} - {{toTime}}",
        "rebookOnboardingPage": {
          "loadingMessage": "Fetching flight info",
          "title": "Rebook your flight",
          "subtitle": "Choose from flights on the same or following day as your original delayed or cancelled flight, and arrive at your original destination.",
          "additionalDetails": "For additional details on the service, please review the <a href=\"{{termsUrl}}\" target=\"_blank\">\"Terms & Conditions\"</a>",
          "importantInfo": {
            "bulletOne": "Flights on same or a lower fare class (up to {{maxPerPax}} per traveler).",
            "bulletTwo": "You can rebook with the service <b>one time</b> per itinerary.",
            "bulletThree": "<b>If you have checked bags</b>, make sure you have plenty of time to make it to your new flight as some rebooking options may involve a different airline and/or terminal.",
            "bulletFourWithRebookLimit": "<b>If you’re rebooking the outbound flight of a roundtrip</b>, you might need to <b>rebook your return flight</b>. We pay for both (up to {{rebookLimit}} per traveler)."
          },
          "learnMoreBaggage": {
            "title": "More about your luggage",
            "subtitle": "After booking a new flight you’ll need to collect and check any non-carry-on luggage onto your new flight.",
            "question1": "What steps do I need to take once I rebook my flight?",
            "answer1": "Speak with the airline of your original flight and ask them how you can claim your luggage.<br/><br/><b>Note:</b> If you need to collect it at the baggage claim, you will need to make sure you will have enough time to make it to your new flight.",
            "question2": "Do I need to pay anything to recheck my luggage?",
            "answer2": "It depends on the airline policy, but you might have to pay any applicable luggage fees using your personal payment method."
          },
          "learnMoreBookReturn": {
            "title": "Rebooking your return flight",
            "subtitle": "Once you book your new outbound flight with us, you may need to rebook your return flight.",
            "question1": "Why might I have to rebook my return flight?",
            "answer1": "The airline will sometimes cancel your return flight if you do not show up for the outbound flight you had originally booked.",
            "question2": "How and when should I rebook my return flight?",
            "answer2": "It’s easy! After selecting your outbound flight, you will be able to instantly select your return flight right on our rebooking tool.",
            "question3": "Do I have to pay for rebooking my return flight?",
            "answer3": "Your {{productName}} covers up to {{maxPerPax}} per traveler."
          },
          "moreHelpPopup": {
            "title": "Get in touch and we’d love to help!",
            "subtitle": "It looks like you might need extra help with your request. Please reach out and one of our agents will be happy to assist you!",
            "contactSupportButton": "Contact support",
            "getRefundButton": "Get a refund instead",
            "goBackButton": "Go back"
          }
        },
        "segmentSelectionPage": {
          "title": "Tell us where you’re at",
          "originDestinationInfo": "{{origin}} to <bold>{{destination}}</bold>",
          "originDestinationInfoWithCode": "{{origin}} <originCode>({{originCode}})</originCode> to <destination>{{destination}}</destination> <destinationCode>({{destinationCode}})</destinationCode>",
          "travelersInfo": "<0>{{numberOfTravelers}} Travelers</0> • {{fareName}}",
          "travelersInfoSingle": "<0>{{numberOfTravelers}} Traveler</0> • {{fareName}}",
          "submitButton": "Search flights to {{destination}}"
        },
        "sliceSelectionPage": {
          "title": "Which part of your trip is disrupted?"
        },
        "flightShopPage": {
          "loadingMessage": "Loading flights",
          "title": "Pick your new flight",
          "tomorrowButton": "Tomorrow • {{date}}",
          "todayButton": "Today • {{date}}",
          "filter": "Filter",
          "noFlightsTitle": "No flights found",
          "noFlightsSubtitle": "Unfortunately there are no flights available. Please reach out and one of our agents will be happy to assist you or request a refund instead.",
          "filters": {
            "title": "Filter by",
            "stops": "Stops",
            "times": "Times",
            "airlines": "Airlines",
            "departureInOrigin": "Departure time in {{origin}}",
            "arrivalInDestination": "Arrival in {{destination}}",
            "flightDuration": "Flight Duration",
            "layoverDuration": "Layover Duration"
          },
          "back": "Back",
          "selectFlight": "Select flight",
          "tripReview": "Trip review"
        },
        "flightCheckoutPage": {
          "priceQuoteLoadingMessage": "Checking flight data",
          "fulfillLoadingMessage": "Booking your flight",
          "title": "Review and confirm your new flight",
          "subtitle": "Here are the final details of your new flight. Rebook and relax.",
          "originToDestination": "{{origin}} {{originCode}} to {{destination}} {{destinationCode}}",
          "originToDestinationWithDate": "{{origin}} {{originCode}} to {{destination}} {{destinationCode}}",
          "submitButton": "Confirm & book free flight",
          "checkout": "Checkout",
          "total": "Total",
          "free": "Free",
          "fullyCovered": "Your new flight is <bold>free</bold> thanks to your {{productName}}!"
        },
        "checkoutConfirmationPage": {
          "title": "New booking successful",
          "subtitle": "Thanks for using {{productName}} – A confirmation email will be sent shortly to {{email}}",
          "done": "Done",
          "bookReturnButton": "Book my return flight",
          "whatNext": {
            "title": "What’s next?",
            "bulletOneTitle": "Collect and re-check any luggage",
            "bulletOneSubtitle": "If you have checked-in luggage, check with the airline how to claim it.",
            "bulletTwoTitle": "Confirm departure time and gate",
            "bulletTwoSubtitle": "Check the flight information display and confirm the details of your new flight.",
            "bulletThreeTitle": "If needed, book your return flight",
            "bulletThreeSubtitleWithRebookingLimit": "Contact the airline to confirm your return flight hasn't been canceled. If it is, you can rebook through {{portalName}}. We pay for both (up to {{maxPerPax}} per traveler)."
          }
        }
      },
      "flightDisruptionAlertBanner": {
        "bookReturn": "<0>Confirm the status of your return flight.</0> <1>You’ve successfully rebooked your flight to {{destination}}. In case your original return flight is cancelled by the airline,</1> <2>rebook it with {{productName}}.</2>",
        "bookReturnDetailed": "<title>Confirm the status of your return flight.</title> <subtitle>You've successfully rebooked your flight to {{destination}}. In case your original return flight is cancelled by the airline,</subtitle> <rebook>rebook it with {{productName}}.</rebook>",
        "rebookReturnFlight": "Rebook return flight",
        "flightDisruptedTitle": "Your flight has been disrupted",
        "flightDisruptedAction": "Use your {{productName}}",
        "entryPointTitle": "{{productName}}",
        "entryPointAction": "View your service",
        "entryPointRebookReturnFlight": "Rebook return flight"
      },
      "contactSupportModal": {
        "title": "Get in touch and we’d love to help!",
        "subtitle": "It looks like you might need extra help with your request. Please reach out and one of our agents will be happy to assist you!",
        "callUs": "Call us",
        "close": "Close"
      }
    }
  },
  "selectCoverageType": "Select coverage type",
  "core-flights-cfar": {
    "productName": "Cancel for Any Reason",
    "bodyOne": "Cancel <0>up to 3 hours before departure</0> – truly for any reason.",
    "bodyTwo": "Get an <0>{{coveragePercentage}} ({{refundAmount}}) refund</0> of your flight base fare and taxes.",
    "bodyThree": "Cancel your flight yourself via our self-serve option online.",
    "optionTitle": "{{coveragePercentage}} refundable",
    "costPerTraveler": "<0>{{premiumAmount}}</0>/traveler (incl. taxes)",
    "declineOptionTitle": "No, thanks",
    "declineOptionSubtitle": "Keep my trip non-refundable",
    "declineOptionSubtitleMobile": "Continue with non-refundable",
    "offerSelected": "Made <0>{{coveragePercentage}} refundable</0> for <0>{{premiumAmount}}</0>/traveler",
    "cta": {
      "offerSelected": "{{coveragePercentage}} refundable | +{{premiumAmount}}"
    },
    "offerDeclined": "No thanks, I don’t want to add this option",
    "informationalBanner": "If you don’t add this option, your flight is <strong>non-refundable</strong>.",
    "howItWorksDialog": {
      "title": "Cancel for Any Reason",
      "bullets": {
        "one": "Cancel your flight for any reason through $t(brand:portalName) portal up until <0>3 hours before your first scheduled departure</0>.",
        "two": "Get a <0>{{coverageAmount}} refund per traveler</0> within 7 to 10 business days of cancelling."
      },
      "importantInformation": {
        "title": "Important information before you book:",
        "one": "If you don't add this option, your flight may be eligible for <0>free cancellation</0> within 24 hours of booking. Please refer to the airline's terms and conditions to learn more.",
        "two": "The amount you get back <0>excludes the amount you paid for the service</0>. This amount is non-refundable.",
        "three": "This service only covers <0>cancellations made by the traveler</0>. Other cancellations are subject to the airlines fare rules.",
        "four": "All cancellations must be done <0>through $t(brand:portalName) portal</0>, not the airline."
      },
      "bookNow": "Book now, stay flexible!",
      "footer": {
        "cfarDescription": "Cancel for Any Reason is a flexibility service and is not an insurance product; for more information, please <0>see here</0>.",
        "cfarAdditionalDescription": "For additional details on the service, please <0>review the full Terms & Conditions here.</0>"
      }
    },
    "selectAnOption": "Select an option",
    "continue": "Continue",
    "checkout": {
      "cfar": "Cancel for Any Reason",
      "pda": "Premium Disruption Assistance"
    },
    "ftcDisclaimer": "Your flight is non-refundable in cash, but you're eligible for travel credit from the airline if you cancel (less any cancellation penalties). Cancel for Any Reason provides an alternative refund option.",
    "returnFilterBanner": "We're showing you {{coveragePercentage}} refundable fare options because you selected a {{coveragePercentage}} refundable fare class for your outbound flight.",
    "exercise": {
      "main": {
        "title": "Cancel For Any Reason",
        "goBack": "Back",
        "confirm": "Confirm cancellation",
        "continue": "Continue",
        "quoteFetchLoadingTitle": "Loading...",
        "fulfillCommandLoadingTitle": "Your cancellation is being processed...",
        "fulfillCommandLoadingSubtitle": "Please do not exit until the cancellation is complete",
        "termsAndConditions": "Terms & Conditions",
        "needHelp": "Need help?",
        "contactSupport": "Contact support"
      },
      "errorExercised": {
        "title": "Your flight is canceled.",
        "description": "You’ve already used Cancel for Any Reason for this trip. Please contact support if you need additional assistance.",
        "contactSupport": "Contact support",
        "goBack": "Go back"
      },
      "void": {
        "title": "Cancel my flight",
        "description": "Cancel your booking free of charge and get a full refund for the fee you paid to Cancel For Any Reason as you are in the free cancellation window for your flight.",
        "termsAndConditions": "Terms & Conditions",
        "continue": "Continue",
        "goBack": "Go back"
      },
      "complete": {
        "title": "Cancellation complete!",
        "descriptionV2": "Your booking has been canceled and your refund has been processed. A confirmation email will be sent shortly.",
        "done": "Done"
      },
      "errorUnknown": {
        "title": "Something went wrong.",
        "description": "We were unable to process your request. Please try again or contact support.",
        "continue": "Got it",
        "contactSupport": "Contact support",
        "goBack": "Go back"
      },
      "errorExpired": {
        "title": "Your Cancel for Any Reason has expired",
        "description": "You are not able to use your Cancel for Any Reason starting 3 hours before your first departure. If you still want to cancel, the airline cancellation policy will apply. Please contact support if you need additional assistance.",
        "continue": "Continue to cancel",
        "contactSupport": "Contact support",
        "goBack": "Go back"
      },
      "confirmCancellation": {
        "title": "Confirm cancellation",
        "description": "Since you added Cancel For Any Reason, you’ll get a refund of {{refundString}} to your original payment method. You should receive your refund within the next 7 to 10 business days.",
        "importantInformationTitle": "Important information",
        "importantInformationPointOne": "Cancellations are allowed up to 3 hours before your first scheduled departure.",
        "importantInformationPointTwo": "All passengers will be canceled from this booking. Cancellations cannot be reversed.",
        "importantInformationPointThree": "Refunds will be issued using the same method of payment as the original booking (e.g., credit card, rewards and/or travel credits), up to the benefit maximum. Please allow 7 to 10 business days for credit card refunds to appear in your account.",
        "importantInformationPointFour": "You will receive a confirmation email and the status of your trip will be updated in the portal.",
        "importantInformationPointFive": "<0>Cancellations cannot be reversed. If you have any questions about canceling your trip please </0><1>contact support</1>.",
        "refundBreakdownRewardSegment": "{{rewardsAmount}} Rewards points",
        "refundBreakdownCreditSegment": "{{travelCreditAmount}} in travel credit",
        "refundBreakdownTwoItems": "{{refundSegment1}} and {{refundSegment2}}",
        "refundBreakdownThreeItems": "{{refundSegment1}}, {{refundSegment2}} and {{refundSegment3}}",
        "confirmCancellation": "Confirm cancellation",
        "footerSuffix": "This action cannot be reversed.",
        "goBack": "Go back"
      }
    }
  },
  "core-hotels-cfar-product-name": "Cancel for Any Reason",
  "core-hotels-cfar-offers": {
    "refundableRoom": {
      "productTitle": "{{coveragePercentage}} refundable",
      "productSubtitleBullet": "Cancel up until {{policyExpiryDate}} and get a refund of {{coveragePercentage}} ({{refundAmount}})"
    },
    "bodyText": {
      "fullyRefundableRoom": "Your free cancellation period ends <strong>{{freeCancellationEndDate}}</strong>, fees apply after. Add extra flexibility!",
      "nonRefundableRoom": "You selected a <strong>non-refundable</strong> room. Add extra flexibility!"
    },
    "bodyOne": "Cancel your booking <strong>up until {{policyExpiryDate}}</strong> - truly for any reason",
    "bodyOne_checkInTime": "Cancel your booking <strong>up until {{policyExpiryDate}}</strong> (check-in time) - truly for any reason",
    "bodyTwoRefundPremiumAtExercise": "Get a refund of <strong>{{coveragePercentage}} ({{refundAmount}})</strong> of your base room rate and taxes, including the Cancel for Any Reason fee",
    "bodyTwo": "Get a refund of <strong>{{coveragePercentage}} ({{refundAmount}})</strong> of your base room rate and taxes",
    "bodyThree": "Cancel instantly online without talking to customer service or the hotel",
    "optionTitle": "Yes, make my booking {{coveragePercentage}} refundable",
    "costPerTraveler": "<strong>+ {{premiumAmount}}</strong>",
    "declineOptionTitle": "No, thanks",
    "declineOptionSubtitle": "Continue with non-refundable",
    "declineOptionSubtitleRefundPremiumAtExercise": "I don't want to add this option",
    "declineOptionSubtitleMobile": "Continue with non-refundable",
    "declineOptionSubtitleMobileRefundPremiumAtExercise": "Continue with non-refundable",
    "offerSelected": "Made <strong>refundable</strong> for + <strong>{{premiumAmount}}</strong>",
    "continueCta": {
      "refundPremiumAtExercise": "{{coveragePercentage}} refundable | +{{premiumAmount}}",
      "notRefundPremiumAtExercise": "Make it refundable | + {{premiumAmount}}",
      "continue": "Continue"
    },
    "offerDeclined": "No thanks, I don't want to add this option",
    "informationalBanner": "If you don't add this option, your flight is <0>non-refundable</0>.",
    "howItWorksDialog": {
      "title": {
        "fullyRefundable": "Make your hotel fully refundable.",
        "partiallyRefundable": "Make your hotel refundable."
      },
      "bullets": {
        "one": {
          "refundPremiumAtExercise": "If your plans change, cancel up until <strong>{{policyExpiryDate}}</strong> and get 100% of your base room rate and taxes, and the Cancel for Any Reason cancellation fee back to your original form of payment.",
          "notRefundPremiumAtExercise": "If your plans change cancel up until <strong>{{policyExpiryDate}}</strong> and get 100% of your base room rate and taxes back to your original form of payment."
        },
        "two": "Cancel your booking online through {{portalName}}, not the hotel."
      },
      "partialRefundInfo": "The amount you get back <strong>excludes the amount you paid for the service</strong>. This amount is non-refundable.",
      "footer": {
        "cfarDescription": "Cancel For Any Reason is a flexibility service and is not an insurance product; for more information, please <Modal>see here</Modal>.",
        "cfarAdditionalDescription": "For additional details on the service, please review the full <Modal>Terms & Conditions.</Modal>"
      }
    },
    "checkout": {
      "productName": "Cancel For Any Reason",
      "policyDisclaimer": {
        "title": "Cancellation policy",
        "subtitle": "Cancel for Any Reason",
        "description": {
          "fullyRefundable": "Cancel your booking up until {{serviceExpiryDate}} (check-in time) for any reason, and get a refund of {{amount}}. Cancellations made after this period are subject to a penalty according to the hotel’s policy. The Cancel for Any Reason fee will be included in the refund.",
          "partiallyRefundable": "Cancel your booking up until {{serviceExpiryDate}} (check-in time) for any reason, and get a refund of {{amount}}. Cancellations made after this period are subject to a penalty according to the hotel’s policy. The Cancel for Any Reason fee will be included in the refund."
        }
      }
    },
    "cancellationPolicy": {
      "main": {
        "poweredBy": "Powered by",
        "title": "Cancellation Policy",
        "viewTerms": "View terms"
      },
      "nonRefundable": {
        "title": "Non-refundable",
        "description": "If you choose to change or cancel this booking, you will not be refunded any of the payment."
      },
      "partiallyRefundableHopper": {
        "title": "Partially refundable until {{serviceExpiryDate}}",
        "description": "Cancel your booking for any reason <bold>up until {{serviceExpiryDate}} (check-in time)</bold>, and get a <bold>refund of your hotel base rate, taxes and fees ({{amount}})</bold>.",
        "description2": "Get a resolution through Hopper without contacting the hotel or completing forms."
      },
      "fullyRefundableHopper": {
        "title": "Fully refundable until {{serviceExpiryDate}}",
        "description": "Cancel your booking for any reason <bold>up until {{serviceExpiryDate}} (check-in time)</bold>, and get a <bold>full refund ({{amount}})</bold>.",
        "description2": "Get a resolution through Hopper without contacting the hotel or completing forms."
      },
      "fullyRefundable": {
        "title": "Fully refundable until {{serviceExpiryDate}}",
        "description": "Cancellations or changes made after {{serviceExpiryDateTime}} are subject to a fee equal to the first night’s rate plus taxes and fees."
      }
    },
    "syntheticRate": {
      "fullyRefundable": {
        "title": "Fully refundable",
        "subtitle": "<highlight>Until {{serviceExpiryDate}}</highlight>",
        "highlights": {
          "one": "Cancel for any reason up until {{serviceExpiryDate}} (check-in time) and get a <bold>full refund ({{refundAmount}})</bold>",
          "two": "Fast resolution through Hopper"
        },
        "termsAndConditionsText": "View terms"
      },
      "fullyRefundableModal": {
        "title": "Make your hotel refundable.",
        "selectAndContinue": "Select and continue",
        "description": "Add the flexibility to cancel your hotel booking for any reason.",
        "highlights": {
          "one": "Cancel for any reason up until <bold>{{serviceExpiryDate}}</bold> and get a refund of <bold>{{refundAmount}}</bold> back to your original form of payment.",
          "two": "Cancel your booking online through {{portalName}}, not the hotel.",
          "three": "Additional per night fee <bold>is included in your refund upon cancellation.</bold>"
        },
        "disclaimer": "If you don't add this option, your booking will be subject to the hotel cancellation policy that you select.",
        "footer": {
          "cfarDescription": "Cancel for any reason is a flexibility service and is not an insurance product; for more information, please <linkText>see here</linkText>.",
          "terms": "For additional details on the service, please review the full <linkText>Terms & Conditions</linkText>."
        }
      },
      "partiallyRefundable": {
        "title": "Partially Refundable",
        "subtitle": "<highlight>Until {{serviceExpiryDate}}</highlight>",
        "highlights": {
          "one": "Cancel for any reason up until {{serviceExpiryDate}} (check-in time) and get a <bold>partial refund ({{refundAmount}})</bold>",
          "two": "Fast resolution through Hopper"
        },
        "termsAndConditionsText": "View terms"
      },
      "negativePremium": {
        "title": "{{percentage}} refundable",
        "subtitle": "<highlight>Until {{serviceExpiryDate}}</highlight> by Hopper",
        "highlights": {
          "one": "Cancel up until {{serviceExpiryDate}} and get a refund of <bold>{{percentage}} ({{refundAmount}})</bold>",
          "two": "Fast resolution in the app"
        },
        "termsAndConditionsText": "View terms"
      }
    }
  },
  "core-hotels-cfar-exercise": {
    "main": {
      "title": "Cancel for Any Reason",
      "goBack": "Back",
      "quoteFetchLoadingTitle": "Loading...",
      "fulfillCommandLoadingTitle": "Your cancellation is being processed...",
      "fulfillCommandLoadingSubtitle": "Please do not exit until the cancellation is complete",
      "needHelp": "Need help?",
      "contactSupport": "Contact support"
    },
    "errorExercised": {
      "title": "Your hotel is canceled",
      "description": "You've already canceled your booking using Cancel for Any Reason and your refund is on the way! Please contact support if you need additional assistance.",
      "contactSupport": "Contact support",
      "goBack": "Go back"
    },
    "void": {
      "title": "Cancel my stay",
      "description": "Cancel your booking free of charge and get a full refund for the fee you paid to Cancel for Any Reason as you are in the free cancellation window for your stay.",
      "termsAndConditions": "Terms & Conditions",
      "continue": "Continue",
      "goBack": "Go back"
    },
    "complete": {
      "title": "Cancellation complete!",
      "description": "Your booking has been canceled and your refund has been processed. A confirmation email will be sent shortly.",
      "done": "Done"
    },
    "errorUnknown": {
      "title": "Something went wrong.",
      "description": "We were unable to process your request. Please try again or contact support.",
      "continue": "Go back",
      "contactSupport": "Contact support",
      "goBack": "Go back"
    },
    "errorExpired": {
      "title": "Your Cancel for Any Reason has expired",
      "description": "You are not able to use your Cancel for Any Reason starting {{expiresAt}}. If you still want to cancel, hotel cancellation policy will apply. Please contact support if you need additional assistance.",
      "termsAndConditions": "Terms & Conditions",
      "continue": "Continue to cancel",
      "contactSupport": "Contact support",
      "goBack": "Go back"
    },
    "confirmCancellation": {
      "title": "Confirm cancellation",
      "notRefundPremiumDescription": "Since you added <b>Cancel for Any Reason</b>, your booking is refundable. You'll get a refund of <RefundString/> to your original payment method.",
      "refundPremiumDescription": "Since you added <b>Cancel for Any Reason</b>, your booking is fully refundable. You'll get a refund of <RefundString/> to your original payment method.",
      "importantInformationTitle": "Important information",
      "partialRefundInfo": "The amount refundable excludes the amount you paid for the service ({{premiumAmount}}). This amount is non-refundable.",
      "notRefundPremiumTerms": "<li>Cancel anytime up until {{expiresAt}}.</li><li>Receive a refund worth 100% of your hotel base rate and taxes. Cancel for Any Reason fee will not be included in the refund.</li><li>Refunds will be issued using the same method of payment as the original booking (e.g., credit card, rewards and/or travel credits), up to the benefit maximum. Please allow 7 to 10 business days for credit card refunds to appear in your account.</li><li>All guests will be canceled from this booking. Cancellations cannot be reversed.</li><li>If you have any questions about canceling your booking please <SupportLink>contact support</SupportLink>.</li>",
      "refundPremiumTerms": "<li>Cancel anytime up until {{expiresAt}}.</li><li>Receive a refund worth 100% of your hotel base rate and taxes. Cancel for Any Reason fee will be included in the refund.</li><li>Refunds will be issued using the same method of payment as the original booking (e.g., credit card, rewards and/or travel credits), up to the benefit maximum. Please allow 7 to 10 business days for credit card refunds to appear in your account.</li><li>All guests will be canceled from this booking. Cancellations cannot be reversed.</li><li>If you have any questions about canceling your booking please <SupportLink>contact support</SupportLink>.</li>",
      "refundBreakdownCashSegment": "{{cashAmount}}",
      "refundBreakdownRewardSegment": "{{rewardsAmount}} rewards",
      "refundBreakdownCarrotCashSegment": "{{carrotCashAmount}} in Travel credits",
      "refundBreakdownOneItem": "<b>{{refundSegment1}}</b>",
      "refundBreakdownTwoItems": "<b>{{refundSegment1}}</b> and <b>{{refundSegment2}}</b>",
      "refundBreakdownThreeItems": "<b>{{refundSegment1}}</b>, <b>{{refundSegment2}}</b> and <b>{{refundSegment3}}</b>",
      "confirmCancellation": "Confirm cancellation",
      "goBack": "Go back"
    },
    "htsExercised": {
      "title": "Your hotel is canceled",
      "description": "You've already canceled your booking using Cancel for Any Reason and your refund is on the way! Please contact support if you need additional assistance.",
      "contactSupport": "Contact support",
      "goBack": "Go back"
    },
    "htsExpired": {
      "title": "Your Cancel for Any Reason has expired",
      "description": "You are not able to use your Cancel for Any Reason starting {{expiresAt}}. If you still want to cancel, hotel cancellation policy will apply. Please contact support if you need additional assistance.",
      "termsAndConditions": "Terms & Conditions",
      "continue": "Continue to cancel",
      "contactSupport": "Contact support",
      "goBack": "Go back"
    },
    "htsGeneralError": {
      "title": "Something went wrong",
      "description": "It looks like you might need extra help with your request. Please reach out and one of our agents will be happy to assist you!",
      "contactSupport": "Contact support",
      "dismiss": "Dismiss"
    },
    "htsCanceledConfirmation": {
      "title": "Cancellation complete!",
      "description": "Your booking has been canceled and your refund has been processed. A confirmation email will be sent shortly to <{{emailAddress}}>.",
      "done": "Done"
    },
    "hotelDetails": {
      "checkIn": "Check-in",
      "checkOut": "Check-out",
      "guests": "{{count}} guest",
      "guests_other": "{{count}} guests"
    },
    "cardPayout": "{{amount}} to your original payment method",
    "loyaltyPointsPayout": "{{points}} points to your account"
  },
  "core-hotels-insurance-product-name": "Trip Insurance",
  "core-hotels-insurance": {
    "checkout": {
      "productName": "Trip Insurance"
    },
    "offer": {
      "title": "Add peace of mind",
      "subtitle": "Protect yourself from unexpected bumps in the road with trip insurance.",
      "expandAllBenefitsText": "Expand all benefits",
      "collapseAllBenefitsText": "Hide benefits",
      "options": {
        "accept": {
          "badge": "Recommended",
          "label": "Yes, add to my trip"
        },
        "decline": {
          "label": "No, thanks",
          "description": "Decline trip insurance"
        }
      },
      "disclaimer": "This content is for information purposes only. You should select <0>\"</0><1>View Details</1><2>\"</2> to view full terms, conditions and exclusions. The coverages described herein may vary by state and may not be available to all applicants. The information above should not be construed as legal or insurance advice, and is not a guarantee of coverage. *Event Ticket and Registration Fee Protection benefit is not available to residents of NY, WA or MT. **Travel inconvenience and Hotel Overbooking benefits are not available in NY, WA, PA or MT. Cover Genius Insurance Services, LLC, a limited liability company organized under the laws of Delaware, is a licensed insurance producer. Cover Genius offers travel protection on its XCover platform underwritten by United States Fire Insurance Company. Any noninsurance services are provided by On Call International. Hopper (USA), Inc., a corporation organized under the laws of Massachusetts, is a licensed insurance producer in Hawaii (License No. 19163577), Massachusetts (License No. 19163577), New York (License No. 1555661) and Washington (License No. 1145832) and a travel retailer for Cover Genius.",
      "footer": "Powered by ",
      "extendedFooter": "via Hopper (USA), Inc."
    },
    "verify": {
      "title": "Do you live in the US?",
      "subtitle": "You must be a US resident to add trip insurance for this trip. If you are booking on behalf of someone else, the traveler handling check-in at the hotel must be a US resident.",
      "accept": "Confirm and continue",
      "decline": "Continue without insurance"
    },
    "exercise": {
      "title": "Your trip insurance coverage",
      "subtitle": "To file a claim or get more information about your XCover coverage, please proceed to their portal. If you want to request a policy refund, please reach out and one of our agents will be happy to assist you!",
      "continue": "Continue to XCover Portal",
      "supportNumberFormatted": "+1 833 933 4671",
      "supportNumber": "18339334671"
    }
  },
  "editProtection": "Edit",
  "price-freeze": {
    "paymentLineLabel": "Price Freeze Discount"
  },
  "core-fintech-ui": {
    "exerciseSuccessConfirmation": {
      "title": "Cancellation confirmed",
      "description": "Your booking has been cancelled and your refund has been processed. A confirmation email will be sent shortly to {{emailAddress}}.",
      "done": "Done"
    },
    "fintech-marketplace": {
      "goBack": "Back",
      "selectAllToContinuePrompt": "Please select an option to continue",
      "continue": "Continue",
      "productOffersFetchLoadingTitle": "Loading..."
    },
    "fintech-product": {
      "optionsTitle": "Select an option below"
    }
  },
  "seeTermsAndConditions": "For additional details, please review the <0>Terms and Conditions</0>",
  "priceFreeze": {
    "activePriceFreezeTabTitle": "Current",
    "expiredPriceFreezeTabTitle": "Past",
    "frozenPriceExpirationString": "Active",
    "frozenPriceExpiredString": "Expired",
    "frozenPriceBookedString": "Exercised",
    "frozenPriceRefundedString": "Refunded",
    "frozenPriceCancelledString": "Canceled",
    "frozenPricePendingString": "Pending"
  },
  "percentageRefundable": "{{percentage}} refundable",
  "exchangeable": {
    "backToTrips": "Back to Trips",
    "voidable": "View Exchange Options",
    "loading": {
      "context": "Loading your flight details and exchange policy...",
      "shop": "Searching for flights",
      "quote": "Confirming availability...",
      "quoteCancel": "Cancel",
      "fulfill": "Confirming your booking!",
      "submit": "Submitting exchange request"
    },
    "error": {
      "subtitle": "Please try again or reach out to support if the issue persists.",
      "title": "Oops, something went wrong."
    },
    "landing": {
      "body": "Select your desired changes and search for replacement flight options.",
      "fallbackAirline": "Your airline",
      "title": {
        "fee": "{{airline}} allows changes for a fee of {{amount}} plus any applicable fare difference",
        "noFee": "{{airline}} allows changes for no fee, just pay any applicable fare difference"
      },
      "terms": {
        "passengers": "All passengers will be affected by any changes. Changes cannot be reversed.",
        "paymentMethod": "Fees and any fare difference will be charged to the same payment method as the original booking.",
        "fees": "Any fees from your original booking, such as baggage and seat cost are not carried over or covered."
      },
      "importantInformation": "Important information"
    },
    "slicePicker": {
      "title": "Select which flights you'd like to modify",
      "modify": "Modify"
    },
    "shop": {
      "breadcrumbs": {
        "trips": "Trips",
        "chooseDeparture": "Choose Departure",
        "chooseReturn": "Choose Return",
        "reviewItinerary": "Review Itinerary"
      },
      "comparator": {
        "newFlightTitle": "Select your new {{flightType}} flight",
        "newFlightSubtitle": "These are the same flight options available to customer service agents.",
        "prevFlightTitle": "Your current {{flightType}} flight",
        "departureDesc": "{{originCity}} ({{originCode}}) to {{destCity}} ({{destCode}}) on {{date}}"
      },
      "minDelta": "+{{currencySymbol}}0"
    },
    "reviewItinerary": {
      "submitRequest": "Submit request"
    },
    "priceBreakdown": {
      "baseFare": "Base fare",
      "cfar": "Cancel For Any Reason",
      "changeFee": "Airline change fee",
      "ftcApplied": "Travel credit applied",
      "prevFlightCredit": "Less previous payment",
      "priorPayment": "Prior payment breakdown",
      "seats": "Seats purchased",
      "subtotal": "Updated booking price",
      "taxes": "Taxes & fees",
      "title": "Traveler and Pricing Summary",
      "total": "Total",
      "totalCost": "Total payable"
    },
    "submit": {
      "sliceDesc": "to {{cityName}} ({{cityCode}}) on {{date}}",
      "showPricing": "Show Pricing Summary",
      "hidePricing": "Hide Pricing Summary",
      "submitReq": "Submit change request",
      "success": {
        "title": "We've received your request!",
        "body1": "You'll receive an email confirmation once your request is complete, ",
        "processingTime": "generally within 2-4 hours.",
        "body2": "We'll contact you by phone is there are any issues."
      },
      "error": {
        "title": "Oh no! There was an issue while submitting",
        "subtitle": "Try again in a few minutes, or reach out to our support team who'd be happy to assist."
      }
    },
    "ancillaries": {
      "CancelOrChange": "Cancel Or Change",
      "Cfar": "Cancel For Any Reason",
      "Chfar": "Change For Any Reason",
      "Delay": "Delay Protection",
      "Insurance": "Travel Insurance",
      "Luggage": "Luggage",
      "MissedConnection": "Missed Connection",
      "priceFreezeCredit": "Less Price Freeze Credit",
      "walletCredit": "Less Travel Credit Applied",
      "walletOffer": "Less Travel Offer Applied",
      "Points": "Points"
    },
    "pageTitles": {
      "default": "Self-Serve Flight Change",
      "error": "Uh oh! Something went wrong",
      "landing": "Change {{flightType}} flight",
      "priceBreakdown": "Price breakdown",
      "reviewItinerary": "Review change request",
      "selectDate": "Select date",
      "selectOutbound": "Select outbound",
      "selectReturn": "Select return",
      "slicePicker": "Select flights",
      "success": "Change request submitted"
    },
    "core": {
      "landing": {
        "title": "Update your preferred changes below",
        "subtitle": {
          "fee": "For your booking, {{airline}} allows changes for a fee of {{amount}} plus any applicable fare difference",
          "noFee": "For your booking, {{airline}} allows changes for no fee, just pay any applicable fare difference"
        },
        "importantInformation": "Important information"
      },
      "confirmation": {
        "status_exchangeConfirmed": "Confirmed",
        "status_exchangeRequested": "Requested",
        "header": {
          "title_exchangeConfirmed": "Exchange completed.",
          "title_exchangeRequested": "We're Reviewing Your Request",
          "body_exchangeConfirmed": "An email confirmation with your updated trip details will be sent to {{email}}",
          "body_exchangeRequested": "Our team is reviewing the details to ensure everything is processed correctly. You'll receive an update to <userEmail>{{email}}<userEmail> within 4 hours once your exchange is complete. Please do not submit any duplicate requests on the same flight."
        },
        "confirmationCodeLabel": "Confirmation code",
        "itinerary": {
          "badge_exchangeConfirmed": "Updated",
          "badge_exchangeRequested": "Update Requested",
          "sliceDetailsTitle_original": "Original {{direction}} Flight",
          "sliceDetailsTitle_requested": "Requested {{direction}} Flight",
          "sliceDetailsTitle_updated": "Updated {{direction}} Flight",
          "viewDetailsCta": "View details",
          "editFlightCta": "Edit flight",
          "updatedPillMessage": "Updated"
        },
        "viewTripDetailsCta": "View trip details"
      },
      "rebook": {
        "title": "Rebook",
        "subtitle": "Check the details and outstanding amount for your new itinerary.",
        "confirmButton": "Confirm and re-book",
        "requestButton": "Submit request",
        "totalPayableDifference": "Total payable difference",
        "updateRequested": "Update Requested"
      }
    }
  },
  "notExchangeable": {
    "body": "This booking is not exchangeable at this time.",
    "body_BookingPending": "This booking is pending and cannot be exchanged.",
    "body_Canceled": "This flight is canceled and cannot be exchanged.",
    "body_CancellationPending": "This flight is pending cancellation and cannot be exchanged.",
    "body_ContainsRemarks": "This itinerary contains remarks added by either the Airline or a Customer Support Agent and cannot be exchanged.",
    "body_Departed": "This flight has already departed and cannot be exchanged.",
    "canceled": {
      "subtitle": "Cancelled flights cannot be exchanged",
      "title": "This flight was cancelled"
    },
    "departed": {
      "subtitle": "This flight has departed and is no longer exchangeable via self serve. Please contact support for further assistance",
      "title": "Flight has departed"
    },
    "loadFailed": {
      "title": "We couldn't load your flight exchange policy",
      "subtitle": "Please try again or contact support"
    },
    "loading": "Loading your flight's exchange policy...",
    "title": "Error",
    "title_BookingPending": "Booking Pending",
    "title_Canceled": "Flight Canceled",
    "title_CancellationPending": "Cancellation Pending",
    "title_ContainsRemarks": "Contains Itinerary Remarks",
    "title_Departed": "Flight Departed"
  },
  "misc": {
    "CFAR_COVERAGE": "Cancel For Any Reason Booking Fee Coverage",
    "DEFAULT_CASH_CURRENCY": "GBP",
    "DEFAULT_REWARDS_CURRENCY": "Miles",
    "ISSUE_SUBMITTING_REQ": "There was an issue submitting your request",
    "PREV_CARD_CHARGED": "Previously charged card",
    "SUBMIT_SUCCESS": "Change Requested",
    "SUBMIT_SUCCESS_SUBTITLE": "We are reviewing your request and will confirm completion within 2-4 hours. If your request is approved, you'll receive an email confirmation. Our team will contact you by phone in the event that your chosen flights are unavailable.",
    "SUBMIT_TRY_AGAIN": "Please try again or contact support for assistance.",
    "MODIFY_SEARCH": "Modify Search",
    "SEARCH_FOR_FLIGHTS": "Search for Flights",
    "SAME_FLIGHT_OPTIONS": "These are the same flight options available to customer service agents.",
    "SEARCHING_FOR_FLIGHTS_TITLE": "for flights",
    "BANNER_TITLE": "Change of plans?",
    "BANNER_TITLE_FTC": "Redeem Your Travel Credit",
    "CHOOSE_SAME_OPTS": "Choose from the same options available to our customer support team",
    "ERROR_TITLE": "Oops... something went wrong!",
    "NO_FILTERED_FLIGHTS_SUBTITLE": "Try searching again or modifying your filters",
    "NO_FLIGHTS_SUBTITLE": "There are no flights available.",
    "NO_FLIGHTS_TITLE": "We couldn't find any flights",
    "BANNER_SUBTITLE": "Take a look at some replacement flights{{airline}}"
  },
  "exchangeHeaderTitle": "Change my trip",
  "viewTripDetails": "View trip details",
  "walletOffers": {
    "title": "Choose a promotion to apply on top of your Wallet Balance",
    "suggestedBy": "Suggested by {{tenant}}",
    "useNextTime": "Keep your promotions for your next booking",
    "useNextTimeDisclaimer": "You can use your applicable promotions on future bookings",
    "carrotCashOfferAmount": "{{amount}} {{currencyName}} applied",
    "walletSavings": "Wallet Savings",
    "nextStepButton": "Continue",
    "additionalDiscountsAvailable": "You have up to {{amount}} in additional discounts available at checkout",
    "additionalDiscountsAvailableWithBold": "You have <b>up to {{amount}} in additional discounts</b> available at checkout",
    "additionalDiscountsAtCheckout": "Up to {{amount}} in additional discounts at checkout",
    "noPromoHeader": "You don't have any applicable promotions.",
    "noPromoText": "Check back again soon!"
  },
  "core-wallet-offer": {
    "offersPage": {
      "title": "Your Offers",
      "noOffers": "No offers available"
    },
    "offerCard": {
      "cta": "Claim now",
      "product": {
        "hotels": "Shop hotels with voucher"
      },
      "expires": "Expires on {{dateTime}}"
    }
  },
  "core-packages": {
    "search": {
      "startSearch": "Search for packages",
      "origin": "Where from?",
      "destination": "Where to?",
      "button": "Search packages"
    },
    "price": {
      "nightCount_one": "{{count}} night",
      "nightCount_other": "{{count}} nights",
      "total_one": "{{totalAmount}} total for {{nights}}, {{count}} traveler. Includes taxes & fees",
      "total_other": "{{totalAmount}} total for {{nights}}, {{count}} travelers. Includes taxes & fees",
      "product": "Flight + Hotel per person",
      "discount": "{{price}} off"
    },
    "hotelAvailability": {
      "upSellBanner": {
        "title": "Your flight details are locked in",
        "description": "Dates, destination, and travelers match your selected flight so you keep your fixed points price. Starting a new search will release this price.",
        "startNewSearch": "Start a new search"
      }
    },
    "benchmark": {
      "title": {
        "nightCount_one": "{{count}} night",
        "nightCount_other": "{{count}} nights",
        "passengerCount_one": "{{count}} passenger",
        "passengerCount_other": "{{count}} passengers",
        "priceIncludesStayFlightAndCar": "Your package total price includes stay ({{nights}}), round-trip flight ({{passengers}}) and car, which you can modify in later steps.",
        "priceIncludesStayFlight": "Your package total price includes stay ({{nights}}) and round-trip flight ({{passengers}}), which you can modify in later steps.",
        "priceIncludesStayFlightChosen": "Your package total price includes stay ({{nights}}) and your selected round-trip flight ({{passengers}}).",
        "priceIncludesStayCar": "Your package total price includes stay ({{nights}}) and car, which you can modify in later steps.",
        "priceIncludesFlightCar": "Your package total price includes round-trip flight ({{passengers}}) and car, which you can modify in later steps."
      },
      "flightDetailsTitle": {
        "detailsOutbound": "<0>Outbound to {{city}}</0> on {{date}}",
        "detailsReturn": "<0>Return to {{city}}</0> on {{date}}"
      }
    },
    "packageType": {
      "hotelFlightCar": "Hotel + Flight + Car",
      "hotelFlight": "Hotel + Flight",
      "hotelCar": "Hotel + Car",
      "flightCar": "Flight + Car"
    },
    "breadcrumbs": {
      "hotelAvailability": "Choose stay",
      "hotelShop": "Choose room",
      "flightDeparture": "Choose departing flight",
      "flightReturn": "Choose return flight",
      "carAvailability": "Choose car",
      "carShop": "Car details",
      "checkout": "Checkout"
    },
    "priceSummary": {
      "whatsIncluded": {
        "hotelFlightCar": "Incl. stay, round trip flight, car, taxes & fees",
        "hotelFlight": "Incl. stay, round trip flight, taxes & fees",
        "hotelCar": "Incl. stay, car, taxes & fees",
        "flightCar": "Incl. round trip flight, car, taxes & fees"
      },
      "totalPrice": "{{totalPrice}} total",
      "costPerTraveler": "{{costPerTraveler}} per traveler",
      "costPerTravelerPoints": "{{costPerTravelerPoints}} or {{costPerTravelerFiat}} per traveler",
      "packageSavings": "{{price}} package savings"
    },
    "flights": {
      "includedInPackage": "Package includes this flight",
      "additionalFlightsAvailableTitle": "Below are all remaining flights available for this route",
      "additionalFlightsAvailableSubtitle": "Total price will vary based on final flight selection"
    },
    "cars": {
      "includedInPackage": "Package includes this car",
      "additionalCarsAvailableTitle": "Below are all remaining cars available for this package",
      "additionalCarsAvailableSubtitle": "Total price will vary based on final car selection",
      "carAvailabilityTitle": "Choose your rental car",
      "carAvailabilitySubtitle": "Price per traveler, includes taxes and fees",
      "priceDisplay": {
        "rewardsOrPrice": "<rewards>{{rewards}}</rewards> <price>or {{price}}</price>"
      }
    },
    "checkout": {
      "completePackageBooking": "Complete booking",
      "editViewPackage": "View or edit package details",
      "editViewPackageDialogTitle": "Your package selections",
      "changeStay": "Change stay",
      "changeFlight": "Change flight",
      "changeCar": "Change car",
      "loadingScreen": {
        "title": "Checking availability...",
        "subtitle": "Please don't close or reload this page."
      },
      "cartQuoteTitle": "Checking price",
      "cartQuoteSubtitle": "Fetching the most up to date price.",
      "cartFulfillTitle": "Booking your package...",
      "cartFulfillSubtitle": "This may take a few minutes. Please don't close or reload this page.",
      "packageReviewTitle": "Review",
      "additionalInformation": {
        "whoIsDrivingCar": "Who is driving the car?",
        "whoIsCheckingIn": "Who is checking into the stay?"
      },
      "reviewSection": {
        "minifiedFlight": {
          "title": "{{origin}} to {{destination}}"
        }
      },
      "breakdown": {
        "title": "Checkout breakdown",
        "subtitle": {
          "nightCount_one": "{{count}} night",
          "nightCount_other": "{{count}} nights",
          "passengerCount_one": "{{count}} passenger",
          "passengerCount_other": "{{count}} passengers",
          "priceIncludesStayFlightAndCar": "Prices include stay ({{nights}}), round-trip flight ({{passengers}}) and car",
          "priceIncludesStayFlight": "Prices include stay ({{nights}}) and round-trip flight ({{passengers}})",
          "priceIncludesStayCar": "Prices include stay ({{nights}}) and car",
          "priceIncludesFlightCar": "Prices include round-trip flight ({{passengers}}) and car",
          "andTaxesAndFees": "and taxes and fees"
        },
        "startingPricePerTraveler": "Starting price per traveler",
        "subtotalForTravelers_one": "Subtotal ({{count}} traveler)",
        "subtotalForTravelers_other": "Subtotal ({{count}} travelers)",
        "taxesAndFees": "Taxes & fees",
        "total": "Total",
        "amountDueToday": "Amount due today",
        "payLaterTotal": "Total due at check-in"
      }
    },
    "bookingConfirmation": {
      "title": "Confirmed, your package is booked!"
    },
    "hotelCardPrice": {
      "notAvailable": "Price not available",
      "originalPriceLabel": "Original price:",
      "totalWithPrice": "{{price}} package total",
      "totalWithPoints": "{{points}} or {{price}} package total",
      "totalWithPointsPlus": "{{points}} + {{price}} package total"
    },
    "pricePerPassenger": "<0>{{price}}</0> per traveller",
    "priceWithPointsPerPassenger": "<0>{{points}} or {{price}}</0> per traveller",
    "priceWithPointsPlusPerPassenger": "<0>{{points}} + {{price}}</0> per traveller"
  },
  "review-page": {
    "title": "Review package details",
    "reviewHotel": "Review hotel",
    "reviewFlight": "Review flight"
  },
  "core-traveler": {
    "travelerType": {
      "adult": "Adult",
      "child": "Child",
      "infant": "Infant"
    },
    "actions": {
      "add": {
        "button": "Add traveler"
      },
      "update": {
        "button": "Update"
      },
      "delete": {
        "button": "Delete",
        "alert": {
          "title": "Delete traveler profile?",
          "description": "Are you sure you want to delete <strong>{{name}}</strong>? This will remove the traveler information and cannot be undone.",
          "actions": {
            "cancel": "Cancel",
            "confirm": "Delete"
          }
        }
      }
    },
    "travelerForm": {
      "error": {
        "generic": "Error updating the traveler. Please try again."
      },
      "title": {
        "car": "Add driver information"
      },
      "firstName": {
        "label": "First name"
      },
      "middleName": {
        "label": "Middle name"
      },
      "lastName": {
        "label": "Last name"
      },
      "Gender": {
        "label": "Gender"
      },
      "nationality": {
        "label": "Nationality"
      },
      "dateOfBirth": {
        "label": "Date of birth (MM/DD/YYYY)",
        "formatValidation": "Please enter a valid date in MM/DD/YYYY format",
        "futureValidation": "Date of birth cannot be in the future",
        "pastValidation": "Date of birth must be after January 1, 1901"
      },
      "submit": "Save traveler",
      "clear": "Clear form",
      "car": {
        "title": "Driver’s license details",
        "address": {
          "label": "Driver’s License Address"
        },
        "city": {
          "label": "City"
        },
        "country": {
          "label": "Country"
        },
        "postalCode": {
          "label": "Zip code"
        }
      },
      "required": "Required"
    }
  },
  "travel-wishlists": {
    "buttons": {
      "add": "Add",
      "delete": "Delete",
      "view": "View",
      "createWishlist": "Create wishlist"
    }
  },
  "core-activities": {
    "funnelName": "Activities",
    "search": {
      "startSearch": "Search for activities",
      "locationLabel": "Where to?",
      "searchButtonLabel": "Search",
      "mobileSearchButtonLabel": "Search for activities",
      "date": {
        "whenLabel": "When?",
        "selectDates": "Select dates",
        "selectedDateLabel": "Date",
        "applyButton": "Continue",
        "title": "Select your dates"
      },
      "participantPicker": {
        "adult_one": "Adult",
        "adult_other": "Adults",
        "child_one": "Child",
        "child_other": "Children",
        "infant_one": "Infant",
        "infant_other": "Infants",
        "senior_one": "Senior",
        "senior_other": "Seniors",
        "traveler_one": "Traveler",
        "traveler_other": "Travelers",
        "unknown": "Unknown",
        "youth_one": "Youth",
        "youth_other": "Youths",
        "applyButton": "Continue",
        "buttonLabel": "{{count}} Travelers",
        "modalTitle": "Edit travelers",
        "ageRange": "Ages {{minAge}} - {{maxAge}}",
        "minimumNumberOfTravelers": "Minimum: {{count}}",
        "maximumNumberOfTravelers": "Maximum: {{count}}"
      }
    },
    "breadcrumbs": {
      "availability": "Activities results",
      "availabilityWithLocation": "Activities in {{location}}",
      "shop": "Activity details",
      "book": "Book"
    },
    "availabilityPage": {
      "title": "Viewing {{count}} activities",
      "loadingScreen": {
        "title": "Searching activities",
        "subtitle": "Please don't close or reload this page."
      },
      "results": {
        "activityCard": {
          "notAvailableActivity": "No availability for these dates",
          "tryDifferentDates": "Try selecting different dates",
          "price": {
            "pointsTotal": "from {{points}} per {{pricingCategory}}",
            "priceTotal": "from {{price}} per {{pricingCategory}} (incl. taxes & fees)",
            "priceTotalWithPoints": "or {{price}} per {{pricingCategory}} (incl. taxes & fees)",
            "groupPricingCategory": "group",
            "personPricingCategory": "person"
          }
        },
        "noResults": {
          "activityUnavailable": "This activity is unavailable for your dates",
          "noActivitiesFound": "Sorry, there are no activities available",
          "filteredActivitiesNotFound": "Please try adjusting your search criteria.",
          "noActivitiesAvailable": "Please try adjusting your search criteria.",
          "changeDates": "Change dates"
        }
      },
      "filters": {
        "resetFilters": "Reset Filters",
        "categories": {
          "title": "Activity Category"
        },
        "price": {
          "title": "Price"
        },
        "rating": {
          "title": "Traveller rating",
          "threePointFive": "Good (3.5 and up)",
          "four": "Very Good (4 and up)",
          "fourPointFive": "Great (4.5 and up)",
          "any": "Any"
        },
        "timeOfDay": {
          "title": "Time of the day"
        },
        "startTime": {
          "morning": "Morning (starts before 12pm)",
          "afternoon": "Afternoon (starts after 12pm)",
          "eveningAndNight": "Evening and night (starts after 5pm)"
        },
        "duration": {
          "title": "Duration",
          "description": "Activity duration",
          "lessThanOneHour": "Up to 1 hour",
          "oneToFourHours": "1 to 4 hours",
          "upToOneDay": "4 hours to 1 day",
          "moreThanOneDay": "More than 1 day"
        },
        "popularFeatureTags": {
          "title": "Extra services"
        }
      }
    },
    "activitySort": {
      "dropDownLabel": "Sort:",
      "recommended": "Recommended",
      "rating": "Tripadvisor rating (high to low)",
      "priceAscending": "Price (low to high)",
      "priceDescending": "Price (high to low)",
      "durationAscending": "Duration (short to long)",
      "durationDescending": "Duration (long to short)"
    },
    "shopPage": {
      "title": "Activity details",
      "tabs": {
        "overview": "Overview",
        "whatsIncluded": "What's included",
        "meetingAndMeetup": "Meeting and pickup",
        "reviews": "Reviews",
        "itinerary": "Itinerary",
        "additionalInfo": "Additional info"
      },
      "noResults": {
        "activityUnavailable": "This activity is unavailable for your dates",
        "noActivitiesAvailable": "Please try adjusting your search to view available activities."
      },
      "activityBookingDetails": {
        "duration": "{{duration}} (approx.)",
        "pickupOffered": "Pick-up offered",
        "languages": "Offered in: {{languages}}",
        "ticketTypeMobile": "Mobile ticket",
        "ticketTypePaper": "Paper ticket"
      },
      "activityBookingOptions": {
        "title": "Booking options",
        "bookingOption": {
          "travelers": "{{count}}x {{ageBand}}",
          "selectStartTimePlaceholder": "Select a time"
        }
      },
      "activityOverview": {
        "title": "Overview",
        "readMore": "Read more"
      },
      "activityInclusions": {
        "title": "What's included"
      },
      "activityMeetup": {
        "title": "Meeting location",
        "subtitle": "You can head directly to the meeting point",
        "addressLabel": "Meeting location:",
        "map": {
          "openButton": "View map"
        }
      },
      "customerReviews": {
        "title": "Customer reviews",
        "averageRating": "Average rating: {{averageRating}}",
        "reviewCount": "{{count}} reviews",
        "moreReviews": "More reviews",
        "reviewInfo": "{{name}}, {{date}}",
        "poweredBy": "Reviews powered by Viator and",
        "tripadvisorAlt": "TripAdvisor",
        "ratingDescription": {
          "exceptional": "Exceptional",
          "superb": "Superb",
          "excellent": "Excellent",
          "veryGood": "Very Good",
          "good": "Good",
          "pleasant": "Pleasant",
          "satisfactory": "Satisfactory",
          "fair": "Fair",
          "adequate": "Adequate",
          "mediocre": "Mediocre",
          "belowAverage": "Below Average",
          "poor": "Poor",
          "veryPoor": "Very Poor"
        }
      },
      "activityItinerary": {
        "title": "Itinerary Information",
        "startingPoint": "Starting point",
        "passBy": "Pass by",
        "viewDetails": "View details",
        "hideDetails": "Hide details"
      },
      "additionalInfo": {
        "title": "Additional Information",
        "readMore": "See more",
        "suppliedBy": "Supplied by <supplierName>{{name}}</supplierName>"
      },
      "unavailable": "Activity unavailable",
      "bookNow": "Book now",
      "checkAvailability": "Check availability",
      "updateSearch": "Update search",
      "priceBreakdown": {
        "title": "Checkout breakdown",
        "lineItem": "{{pricePerPerson}} x {{count}} {{ageBandLabel}}",
        "totalPrice": "Total",
        "owingAmount": "Amount due",
        "disclaimer": "All taxes and fees included in the prices above."
      },
      "freeCancellationBanner": {
        "freeCancellationBefore": "Free cancellation before {{date}} at {{time}} (local time)",
        "partialRefundBefore": "{{percentage}}% refund before {{date}} at {{time}} (local time)",
        "nonRefundable": "Non-refundable - you will not receive a refund if you cancel."
      },
      "continueToCheckout": "Continue to checkout"
    },
    "checkout": {
      "seeDetails": "See details about the experience operator",
      "loadingScreen": {
        "title": "Loading"
      },
      "cartQuote": {
        "title": "Checking availability",
        "subtitle": "Please don't close or reload this page. We're getting the latest rates for the activity you've chosen."
      },
      "confirmation": {
        "title": "Confirmed, your activity is booked",
        "subtitle": "An email confirmation will be sent to <strong>{{bookingEmail}}</strong>",
        "confirmationNumber": "<strong>Your confirmation number is #{{confirmationNumber}}</strong>",
        "dateAndTime": "{{date}} at {{time}}",
        "travelers_one": "{{count}} traveler",
        "travelers_other": "{{count}} travelers",
        "tourLanguage": "Tour language: {{language}}"
      }
    },
    "cartFulfill": {
      "title": "Booking your activity...",
      "subtitle": "This may take a few minutes. Please don't close or reload this page."
    },
    "image": {
      "altWithNoCategory": "Image with no category",
      "showAllImages": "View all photos ({{count}})",
      "imageGallery": {
        "title": "Viewing all photos - {{activityName}}"
      }
    },
    "time": {
      "hours_one": "{{count}} hour",
      "hours_other": "{{count}} hours",
      "minutes_one": "{{count}} minute",
      "minutes_other": "{{count}} minutes"
    }
  },
  "searchActivities": "Search activities",
  "activities": {
    "checkout": {
      "additionalDetails": {
        "specialRequirements": {
          "title": "Special requirements ({{requirement}})",
          "label": "Special requirements",
          "placeholder": "e.g: dietary requirements, accessibility needs"
        },
        "selectLanguage": {
          "title": "Select language",
          "subtitle": "This provider offers this activity in multiple languages",
          "errorMessage": "You must make a selection to continue.",
          "guideType": {
            "Audio": "Audio",
            "Human": "Human",
            "Written": "Written"
          }
        },
        "pickupPoint": {
          "options": {
            "selectPickup": "Select hotel and arrange pickup now",
            "pickupLater": "Arrange pickup later",
            "noPickup": "I do not need a pickup"
          },
          "enterLocation": {
            "title": "Enter pickup location",
            "subtitle": "Your pickup location will be confirmed before your activity.",
            "hotelNameLabel": "Hotel name",
            "addressLabel": "Address",
            "cityLabel": "City",
            "zipCodeLabel": "Postal code",
            "errorMessage": "Complete all required fields to continue."
          },
          "selectHotel": {
            "title": "Select hotel",
            "placeholder": "Search by hotel name",
            "customLocationLabel": "I don't see my hotel",
            "errorMessage": "Select a location to continue."
          },
          "voucherMessage": "See voucher for details on meeting point",
          "requiredTitle": "Hotel pickup (Required to attend this activity)",
          "requiredWarning": "This tour operator requires you to be picked up from one of these select hotels. If your hotel is not listed, you can meet your tour operator at any of the other hotels listed below.",
          "availableTitle": "Hotel pickup available",
          "availableSubtitle": "Tell us where you’d like to be picked up from. If you're not sure, you can decide later.",
          "pickupLaterMessage": "Contact your tour operator before your activity to arrange a pickup.",
          "selectionError": "You must make a selection to continue."
        },
        "continue": "Save and continue",
        "helperText": "You must complete all required fields to continue.",
        "editInformation": "Edit information",
        "transferArrivalMode": {
          "title": "Arrival details",
          "subtitle": "You can provide your arrival details if you have it scheduled for tour day.",
          "options": {
            "flight": "Arriving by flight and can provide details",
            "other": "Other"
          },
          "otherLabel": "Arrival details (required)"
        },
        "transferDepartureMode": {
          "title": "Departure details",
          "subtitle": "You can provide your departure details if you have it scheduled for tour day.",
          "options": {
            "flight": "Departing by flight and can provide details",
            "other": "Other"
          },
          "otherLabel": "Departure details (required)"
        },
        "transferConditionalQuestions": {
          "TransferAirArrivalAirline": "Arrival airline",
          "TransferAirArrivalFlightNo": "Arrival flight number",
          "TransferAirDepartureAirline": "Departure airline",
          "TransferAirDepartureFlightNo": "Departure flight number",
          "TransferArrivalDropOff": "Arrival drop-off location",
          "TransferArrivalTime": "Arrival time",
          "TransferDepartureDate": "Departure date",
          "TransferDeparturePickup": "Departure pickup location",
          "TransferDepartureTime": "Departure time"
        }
      },
      "activityInformation": {
        "editInformation": "Edit"
      }
    },
    "postBooking": {
      "tripCardTitle": "Activity",
      "startTime": "Start time",
      "endTime": "End time",
      "localTimeLabel": "{{date}} - {{time}} (local time)",
      "duration": "Duration",
      "numberOfTravelers": "Number of travelers",
      "tourLanguage": "Tour language",
      "status": {
        "cancelled": "Canceled",
        "confirmed": "Confirmed",
        "pending": "Pending",
        "unknown": "Unknown"
      },
      "confirmation": "Confirmation: {{reservationId}}",
      "details": {
        "title": "Activity reservation",
        "detailsTitle": "Activity details",
        "goToVoucher": "Go to voucher",
        "altDescription": "Activity image for {{activityName}}",
        "inclusions": "What's included",
        "language": "Language",
        "specialRequirements": "Special requirements",
        "pickup": "Pick up",
        "pickupArrangeLater": "Arrange pickup later",
        "pickupNotNeeded": "I do not need a pickup",
        "pickupArrangeNow": "Select hotel and arrange pickup now",
        "meetupLocation": "Meetup location",
        "dropOffLocation": "Drop-off location"
      },
      "bookingDetails": {
        "title": "Booking details",
        "tourOperator": "Tour operator",
        "primaryTraveler": "Primary traveler"
      },
      "bookingQuestions": {
        "inclusionAltLabel": "Included",
        "exclusionAltLabel": "Excluded"
      }
    }
  },
  "required": "required",
  "optional": "optional",
  "activitiesTripsLinks": {
    "cancelActivity": "Cancel booking",
    "changeActivity": "Change booking"
  }
};

export { englishStrings };
